
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire75f2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire75f2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h6ark", function(module, exports) {

$parcel$export(module.exports, "log", () => log);
$parcel$export(module.exports, "pair_device", () => pair_device);
$parcel$export(module.exports, "select_existing", () => select_existing);
$parcel$export(module.exports, "get_autoconnect", () => get_autoconnect);
$parcel$export(module.exports, "connect_device", () => connect_device);
$parcel$export(module.exports, "disconnect", () => disconnect);
$parcel$export(module.exports, "set_autoconnect", () => set_autoconnect);
$parcel$export(module.exports, "monitor_usb", () => monitor_usb);
$parcel$export(module.exports, "exploit_gabb", () => exploit_gabb);
$parcel$export(module.exports, "godo", () => godo);
$parcel$export(module.exports, "install_app", () => install_app);
$parcel$export(module.exports, "run_user_command", () => run_user_command);
$parcel$export(module.exports, "navigate_in_time", () => navigate_in_time);
$parcel$export(module.exports, "start_wifi_adb", () => start_wifi_adb);
$parcel$export(module.exports, "stop_wifi_adb", () => stop_wifi_adb);
$parcel$export(module.exports, "send_to_device", () => send_to_device);
parcelRequire("iuptw");
var $dGdCH = parcelRequire("dGdCH");
var $aI8PJ = parcelRequire("aI8PJ");

var $jhyqS = parcelRequire("jhyqS");
parcelRequire("27oor");
var $4uv4T = parcelRequire("4uv4T");
var $aIHw7 = parcelRequire("aIHw7");
var $23OH0 = parcelRequire("23OH0");
const konsole = document.querySelector("#konsole");
const CredentialStore = new (0, $jhyqS.default)();
console.log("hi friend!");
log(navigator.usb);
const Manager = (0, $aI8PJ.AdbDaemonWebUsbDeviceManager).BROWSER;
if (!Manager) {
    alert("WebUSB is not supported in this browser!\nWe need WebUSB in order to function.\nPlease try again with Google Chrome.");
    return;
} else log("Yay, you have WebUSB!");
let device = null;
let devices = null;
let connection = null;
let adb = null;
let onmonitor = null;
let dev_list = null;
let autoconnect_enabled = localStorage["autoconnect_enabled"] || "true";
function is_device() {
    return !!device;
}
function is_connected() {
    return !!connection;
}
async function pair_device() {
    await Manager.requestDevice({
        filters: [
            {
                ...(0, $dGdCH.ADB_DEFAULT_DEVICE_FILTER),
                vendorId: 0x19D2,
                productId: 0x0452
            }
        ]
    });
    await autoconnect();
}
async function list_existing() {
    devices = await Manager.getDevices([
        {
            ...(0, $dGdCH.ADB_DEFAULT_DEVICE_FILTER),
            vendorId: 0x19D2,
            productId: 0x0452
        }
    ]);
    return devices;
}
function select_existing(serial) {
    device = devices.filter((dev)=>{
        return dev.serial == serial;
    });
    console.log(device);
    if (device.length < 1) {
        device = null;
        return;
    }
    device = device[0];
    if (get_autoconnect()) connect_device();
}
async function disconnect() {
    if (!device) {
        log("No device connected!");
        return;
    }
    try {
        await adb.close();
    } catch (e) {
        log("Error when closing adb");
        console.error(e);
    }
    log("ADB session closed");
    adb = null;
    try {
        await device.raw.close();
    } catch (e) {
        log("Error when closing connection");
        console.error(e);
    }
    log("Connection closed");
    connection = null;
    device = null;
    if (dev_list) await draw_device_list();
    if (onmonitor) onmonitor();
}
async function autoconnect() {
    await list_existing();
    if (device && devices.filter((dev)=>{
        return dev.serial == device.serial;
    }).length < 1) device = null;
    console.log(devices);
    // if (devices.length == 0) return [];
    if (!device && get_autoconnect() && devices.length > 0) {
        device = devices[0];
        await connect_device();
        if (onmonitor) onmonitor();
    }
    if (dev_list) await draw_device_list();
    return devices;
}
function set_autoconnect(val) {
    val = "" + val;
    autoconnect_enabled = val;
    localStorage["autoconnect_enabled"] = val;
}
function get_autoconnect() {
    return autoconnect_enabled == "true";
}
function monitor_usb(dev_list_p, onmonitor_p) {
    dev_list = dev_list_p;
    onmonitor = onmonitor_p;
    navigator.usb.addEventListener("connect", ()=>{
        log("Connect event received, updating devices...");
        autoconnect();
    });
    navigator.usb.addEventListener("disconnect", ()=>{
        log("Disconnect event received, updating devices...");
        autoconnect();
    });
    log("Checking devices due to start...");
    autoconnect();
}
async function draw_device_list() {
    const list_elem = dev_list;
    if (!devices) await list_existing();
    // log(devices.toString());
    list_elem.innerHTML = `<option value="null">No device</option>`;
    for (const dev of devices){
        const opt = document.createElement("option");
        opt.textContent = `${dev.raw.productName}\t${dev.raw.manufacturerName}\t${dev.serial}`;
        opt.value = dev.serial;
        list_elem.appendChild(opt);
    }
    if (device) list_elem.value = device.serial;
    else list_elem.value = "null";
}
async function connect_device() {
    console.log("connect dev");
    if (!device) {
        console.log("Device is null");
        alert("Device is null");
        return;
    }
    connection = await device.connect();
    log("Device connection opened...");
    const transport = await (0, $aIHw7.AdbDaemonTransport).authenticate({
        serial: device.serial,
        connection: connection,
        credentialStore: CredentialStore
    });
    log("ADB transport opened...");
    adb = new (0, $4uv4T.Adb)(transport);
    log("ADB connection created!");
    // console.log(adb);
    log("Android version: " + await adb.getProp("ro.build.version.release"));
    if (onmonitor) onmonitor();
}
async function exploit_gabb() {
    let res = null;
    await godo("am switch-user 0");
    res = await godo("pm list users");
    const mmus = res.stdout.matchAll(/(?<uid>\d+):MaintenanceModeUser:/g);
    for (const mmu of mmus)if (mmu.groups.uid) await godo("pm remove-user " + mmu.groups.uid);
    await godo("pm disable-user --user 0 com.gabb.packageupdater");
    await godo("pm disable-user --user 0 com.zte.zdm");
    log("Exploited (if no errors above, lol)!");
}
async function install_app(file, user) {
    if (!user) user = "current";
    //const file_input = document.querySelector("#apk");
    //const file = file_input.files[0];
    log("Acquiring sync...");
    const sync = await adb.sync();
    log("Sending APK...");
    await sync.write({
        filename: "/data/local/tmp/temp.apk",
        file: file.stream()
    });
    sync.dispose();
    log("APK sent!");
    let res = null;
    log("Installing...");
    res = await godo("pm install-create -d --user " + user);
    const session = res.stdout.split("[")[1].split("]")[0];
    await godo(`pm install-write ${session} tomato /data/local/tmp/temp.apk`);
    await godo(`pm install-commit ${session}`);
    await adb.rm("/data/local/tmp/temp.apk");
}
async function send_command_and_get_response(command, ignore_errors, silence_logs) {
    const process = await adb.subprocess.spawnAndWait(command, {
        protocols: [
            (0, $23OH0.AdbSubprocessShellProtocol)
        ]
    });
    if (process.stderr) {
        if (!silence_logs) log(process.stderr);
        if (!ignore_errors) throw process.stderr;
    }
    if (!silence_logs) log(process.stdout);
    return process;
}
const command_history = [];
let command_lock = 0;
async function run_user_command(runner) {
    if (runner.value.startsWith("adb shell ")) {
        log('Removing "adb shell " from command...');
        runner.value = runner.value.substring(10);
    }
    command_history.push(runner.value);
    command_lock = command_history.length;
    await godo(runner.value);
    runner.value = "";
    runner.focus();
}
function navigate_in_time(step, runner) {
    const comstep = command_lock + step;
    // console.log(comstep, command_history);
    if (comstep > command_history.length || comstep < 0) return;
    if (comstep == command_history.length) {
        runner.value = "";
        command_lock = comstep;
        return;
    }
    command_lock = comstep;
    runner.value = command_history[comstep];
}
async function start_wifi_adb() {
    log(await adb.tcpip.setPort(5555));
}
async function stop_wifi_adb() {
    log(await adb.tcpip.disable());
}
async function send_to_device(file) {
    log("Acquiring sync...");
    const sync = await adb.sync();
    log("Sending...");
    await sync.write({
        filename: "/sdcard/Download/" + file.name,
        file: file.stream()
    });
    await sync.dispose();
    log("Sent!");
}
const godo = send_command_and_get_response;
function log(msg) {
    if (konsole) {
        konsole.textContent += `[${new Date().toLocaleString()}] ${msg}\n`;
        konsole.scrollTo(0, konsole.scrollHeight);
    } else console.log(msg);
    return msg;
}

});
parcelRegister("iuptw", function(module, exports) {
$parcel$export(module.exports, "ADB_DEFAULT_DEVICE_FILTER", () => (parcelRequire("dGdCH")).ADB_DEFAULT_DEVICE_FILTER);
$parcel$export(module.exports, "AdbDaemonWebUsbDeviceManager", () => (parcelRequire("aI8PJ")).AdbDaemonWebUsbDeviceManager);
parcelRequire("dGdCH");
parcelRequire("aI8PJ");
parcelRequire("byTpg");
parcelRequire("7wgv6");

});
parcelRegister("dGdCH", function(module, exports) {

$parcel$export(module.exports, "ADB_DEFAULT_DEVICE_FILTER", () => $9f59c3e3ec39e929$export$83dac9bc96800be2);
$parcel$export(module.exports, "AdbDaemonWebUsbDevice", () => $9f59c3e3ec39e929$export$b4df074ec7ed7a36);
parcelRequire("27oor");
var $2lmjj = parcelRequire("2lmjj");
var $fXuIk = parcelRequire("fXuIk");
parcelRequire("7edQJ");
var $bwQFm = parcelRequire("bwQFm");
var $jEctC = parcelRequire("jEctC");
var $3Ppgt = parcelRequire("3Ppgt");
var $6NYMu = parcelRequire("6NYMu");
parcelRequire("hr1EK");
var $j4unN = parcelRequire("j4unN");

var $byTpg = parcelRequire("byTpg");
const $9f59c3e3ec39e929$export$83dac9bc96800be2 = {
    classCode: 0xff,
    subclassCode: 0x42,
    protocolCode: 1
};
/**
 * Find the first pair of input and output endpoints from an alternate interface.
 *
 * ADB interface only has two endpoints, one for input and one for output.
 */ function $9f59c3e3ec39e929$var$findUsbEndpoints(endpoints) {
    if (endpoints.length === 0) throw new TypeError("No endpoints given");
    let inEndpoint;
    let outEndpoint;
    for (const endpoint of endpoints)switch(endpoint.direction){
        case "in":
            inEndpoint = endpoint;
            if (outEndpoint) return {
                inEndpoint: inEndpoint,
                outEndpoint: outEndpoint
            };
            break;
        case "out":
            outEndpoint = endpoint;
            if (inEndpoint) return {
                inEndpoint: inEndpoint,
                outEndpoint: outEndpoint
            };
            break;
    }
    if (!inEndpoint) throw new TypeError("No input endpoint found.");
    if (!outEndpoint) throw new TypeError("No output endpoint found.");
    throw new Error("unreachable");
}
class $9f59c3e3ec39e929$var$Uint8ArrayExactReadable {
    #data;
    #position;
    get position() {
        return this.#position;
    }
    constructor(data){
        this.#data = data;
        this.#position = 0;
    }
    readExactly(length) {
        const result = this.#data.subarray(this.#position, this.#position + length);
        this.#position += length;
        return result;
    }
}
class $9f59c3e3ec39e929$export$d762018b8d06af13 {
    #device;
    get device() {
        return this.#device;
    }
    #inEndpoint;
    get inEndpoint() {
        return this.#inEndpoint;
    }
    #outEndpoint;
    get outEndpoint() {
        return this.#outEndpoint;
    }
    #readable;
    get readable() {
        return this.#readable;
    }
    #writable;
    get writable() {
        return this.#writable;
    }
    constructor(device, inEndpoint, outEndpoint, usbManager){
        this.#device = device;
        this.#inEndpoint = inEndpoint;
        this.#outEndpoint = outEndpoint;
        let closed1 = false;
        const duplex = new (0, $bwQFm.DuplexStreamFactory)({
            close: async ()=>{
                try {
                    closed1 = true;
                    await device.raw.close();
                } catch  {
                /* device may have already disconnected */ }
            },
            dispose: ()=>{
                closed1 = true;
                usbManager.removeEventListener("disconnect", handleUsbDisconnect);
            }
        });
        function handleUsbDisconnect(e) {
            if (e.device === device.raw) duplex.dispose().catch((0, $fXuIk.unreachable));
        }
        usbManager.addEventListener("disconnect", handleUsbDisconnect);
        this.#readable = duplex.wrapReadable(new (0, $6NYMu.ReadableStream)({
            pull: async (controller)=>{
                const packet = await this.#transferIn();
                if (packet) controller.enqueue(packet);
                else controller.close();
            }
        }, {
            highWaterMark: 0
        }));
        const zeroMask = outEndpoint.packetSize - 1;
        this.#writable = (0, $3Ppgt.pipeFrom)(duplex.createWritable(new (0, $jEctC.MaybeConsumable).WritableStream({
            write: async (chunk)=>{
                try {
                    await device.raw.transferOut(outEndpoint.endpointNumber, chunk);
                    // In USB protocol, a not-full packet indicates the end of a transfer.
                    // If the payload size is a multiple of the packet size,
                    // we need to send an empty packet to indicate the end,
                    // so the OS will send it to the device immediately.
                    if (zeroMask && (chunk.length & zeroMask) === 0) await device.raw.transferOut(outEndpoint.endpointNumber, (0, $j4unN.EMPTY_UINT8_ARRAY));
                } catch (e) {
                    if (closed1) return;
                    throw e;
                }
            }
        })), new (0, $2lmjj.AdbPacketSerializeStream)());
    }
    async #transferIn() {
        try {
            while(true){
                // ADB daemon sends each packet in two parts, the 24-byte header and the payload.
                const result = await this.#device.raw.transferIn(this.#inEndpoint.endpointNumber, this.#inEndpoint.packetSize);
                if (result.data.byteLength !== 24) continue;
                // Per spec, the `result.data` always covers the whole `buffer`.
                const buffer = new Uint8Array(result.data.buffer);
                const stream = new $9f59c3e3ec39e929$var$Uint8ArrayExactReadable(buffer);
                // Add `payload` field to its type, it's assigned below.
                const packet = (0, $2lmjj.AdbPacketHeader).deserialize(stream);
                if (packet.magic !== (packet.command ^ 0xffffffff)) continue;
                if (packet.payloadLength !== 0) {
                    const result = await this.#device.raw.transferIn(this.#inEndpoint.endpointNumber, packet.payloadLength);
                    packet.payload = new Uint8Array(result.data.buffer);
                } else packet.payload = (0, $j4unN.EMPTY_UINT8_ARRAY);
                return packet;
            }
        } catch (e) {
            // On Windows, disconnecting the device will cause `NetworkError` to be thrown,
            // even before the `disconnect` event is fired.
            // We need to wait a little bit and check if the device is still connected.
            // https://github.com/WICG/webusb/issues/219
            if ((0, $byTpg.isErrorName)(e, "NetworkError")) {
                await new Promise((resolve)=>{
                    setTimeout(()=>{
                        resolve();
                    }, 100);
                });
                if (closed) return undefined;
                else throw e;
            }
            throw e;
        }
    }
}
class $9f59c3e3ec39e929$export$b4df074ec7ed7a36 {
    #filters;
    #usbManager;
    #raw;
    get raw() {
        return this.#raw;
    }
    #serial;
    get serial() {
        return this.#serial;
    }
    get name() {
        return this.#raw.productName;
    }
    /**
     * Create a new instance of `AdbDaemonWebUsbConnection` using a specified `USBDevice` instance
     *
     * @param device The `USBDevice` instance obtained elsewhere.
     * @param filters The filters to use when searching for ADB interface. Defaults to {@link ADB_DEFAULT_DEVICE_FILTER}.
     */ constructor(device, filters = [
        $9f59c3e3ec39e929$export$83dac9bc96800be2
    ], usbManager){
        this.#raw = device;
        this.#serial = (0, $byTpg.getSerialNumber)(device);
        this.#filters = filters;
        this.#usbManager = usbManager;
    }
    async #claimInterface() {
        if (!this.#raw.opened) await this.#raw.open();
        const { configuration: configuration, interface_: interface_, alternate: alternate } = (0, $byTpg.findUsbAlternateInterface)(this.#raw, this.#filters);
        if (this.#raw.configuration?.configurationValue !== configuration.configurationValue) // Note: Switching configuration is not supported on Windows,
        // but Android devices should always expose ADB function at the first (default) configuration.
        await this.#raw.selectConfiguration(configuration.configurationValue);
        if (!interface_.claimed) await this.#raw.claimInterface(interface_.interfaceNumber);
        if (interface_.alternate.alternateSetting !== alternate.alternateSetting) await this.#raw.selectAlternateInterface(interface_.interfaceNumber, alternate.alternateSetting);
        const { inEndpoint: inEndpoint, outEndpoint: outEndpoint } = $9f59c3e3ec39e929$var$findUsbEndpoints(alternate.endpoints);
        return [
            inEndpoint,
            outEndpoint
        ];
    }
    /**
     * Claim the device and create a pair of `AdbPacket` streams to the ADB interface.
     * @returns The pair of `AdbPacket` streams.
     */ async connect() {
        const [inEndpoint, outEndpoint] = await this.#claimInterface();
        return new $9f59c3e3ec39e929$export$d762018b8d06af13(this, inEndpoint, outEndpoint, this.#usbManager);
    }
}

});
parcelRegister("27oor", function(module, exports) {
$parcel$export(module.exports, "Adb", () => (parcelRequire("4uv4T")).Adb);
$parcel$export(module.exports, "AdbSubprocessShellProtocol", () => (parcelRequire("23OH0")).AdbSubprocessShellProtocol);
$parcel$export(module.exports, "AdbDaemonTransport", () => (parcelRequire("aIHw7")).AdbDaemonTransport);
$parcel$export(module.exports, "AdbPacketHeader", () => (parcelRequire("2lmjj")).AdbPacketHeader);
$parcel$export(module.exports, "AdbPacketSerializeStream", () => (parcelRequire("2lmjj")).AdbPacketSerializeStream);
$parcel$export(module.exports, "unreachable", () => (parcelRequire("fXuIk")).unreachable);
parcelRequire("4uv4T");
parcelRequire("bFpy9");
parcelRequire("chJ24");
parcelRequire("7gpwK");
parcelRequire("drR7i");
parcelRequire("jBeoN");
parcelRequire("5lBQi");

});
parcelRegister("4uv4T", function(module, exports) {

$parcel$export(module.exports, "Adb", () => $34521237b2ec6ce9$export$7a062b26cb22e9be);
parcelRequire("7edQJ");
var $k61Wg = parcelRequire("k61Wg");
var $koQVx = parcelRequire("koQVx");
parcelRequire("chJ24");
var $5WSZn = parcelRequire("5WSZn");
var $gequt = parcelRequire("gequt");
var $5jHg5 = parcelRequire("5jHg5");
var $aBc50 = parcelRequire("aBc50");
var $liel6 = parcelRequire("liel6");
var $beA73 = parcelRequire("beA73");
var $755W6 = parcelRequire("755W6");
class $34521237b2ec6ce9$export$7a062b26cb22e9be {
    transport;
    get serial() {
        return this.transport.serial;
    }
    get maxPayloadSize() {
        return this.transport.maxPayloadSize;
    }
    get banner() {
        return this.transport.banner;
    }
    get disconnected() {
        return this.transport.disconnected;
    }
    get clientFeatures() {
        return this.transport.clientFeatures;
    }
    get deviceFeatures() {
        return this.banner.features;
    }
    subprocess;
    power;
    reverse;
    tcpip;
    constructor(transport){
        this.transport = transport;
        this.subprocess = new (0, $5jHg5.AdbSubprocess)(this);
        this.power = new (0, $5WSZn.AdbPower)(this);
        this.reverse = new (0, $gequt.AdbReverseCommand)(this);
        this.tcpip = new (0, $liel6.AdbTcpIpCommand)(this);
    }
    canUseFeature(feature) {
        return this.clientFeatures.includes(feature) && this.deviceFeatures.includes(feature);
    }
    async createSocket(service) {
        return this.transport.connect(service);
    }
    async createSocketAndWait(service) {
        const socket = await this.createSocket(service);
        return await socket.readable.pipeThrough(new (0, $koQVx.TextDecoderStream)()).pipeThrough(new (0, $k61Wg.ConcatStringStream)());
    }
    async getProp(key) {
        const stdout = await this.subprocess.spawnAndWaitLegacy([
            "getprop",
            key
        ]);
        return stdout.trim();
    }
    async rm(filenames, options) {
        const args = [
            "rm"
        ];
        if (options?.recursive) args.push("-r");
        if (options?.force) args.push("-f");
        if (Array.isArray(filenames)) for (const filename of filenames)args.push((0, $beA73.escapeArg)(filename));
        else args.push((0, $beA73.escapeArg)(filenames));
        // https://android.googlesource.com/platform/packages/modules/adb/+/1a0fb8846d4e6b671c8aa7f137a8c21d7b248716/client/adb_install.cpp#984
        args.push("</dev/null");
        const stdout = await this.subprocess.spawnAndWaitLegacy(args);
        return stdout;
    }
    async sync() {
        const socket = await this.createSocket("sync:");
        return new (0, $aBc50.AdbSync)(this, socket);
    }
    async framebuffer() {
        return (0, $755W6.framebuffer)(this);
    }
    async close() {
        await this.transport.close();
    }
}

});
parcelRegister("7edQJ", function(module, exports) {
$parcel$export(module.exports, "BufferedReadableStream", () => (parcelRequire("bJSM1")).BufferedReadableStream);
$parcel$export(module.exports, "ConcatStringStream", () => (parcelRequire("k61Wg")).ConcatStringStream);
$parcel$export(module.exports, "Consumable", () => (parcelRequire("5Ywqs")).Consumable);
$parcel$export(module.exports, "BufferCombiner", () => (parcelRequire("b5TnZ")).BufferCombiner);
$parcel$export(module.exports, "DistributionStream", () => (parcelRequire("b5TnZ")).DistributionStream);
$parcel$export(module.exports, "DuplexStreamFactory", () => (parcelRequire("bwQFm")).DuplexStreamFactory);
$parcel$export(module.exports, "TextDecoderStream", () => (parcelRequire("koQVx")).TextDecoderStream);
$parcel$export(module.exports, "MaybeConsumable", () => (parcelRequire("jEctC")).MaybeConsumable);
$parcel$export(module.exports, "pipeFrom", () => (parcelRequire("3Ppgt")).pipeFrom);
$parcel$export(module.exports, "PushReadableStream", () => (parcelRequire("fnPEF")).PushReadableStream);
$parcel$export(module.exports, "AbortController", () => (parcelRequire("6NYMu")).AbortController);
$parcel$export(module.exports, "ReadableStream", () => (parcelRequire("6NYMu")).ReadableStream);
$parcel$export(module.exports, "TransformStream", () => (parcelRequire("6NYMu")).TransformStream);
$parcel$export(module.exports, "WritableStream", () => (parcelRequire("6NYMu")).WritableStream);
$parcel$export(module.exports, "StructDeserializeStream", () => (parcelRequire("ebpYL")).StructDeserializeStream);
$parcel$export(module.exports, "WrapWritableStream", () => (parcelRequire("67qk3")).WrapWritableStream);
parcelRequire("1QeNb");
parcelRequire("bJSM1");
parcelRequire("k61Wg");
parcelRequire("5Ywqs");
parcelRequire("b5TnZ");
parcelRequire("bwQFm");
parcelRequire("koQVx");
parcelRequire("4eHDJ");
parcelRequire("jEctC");
parcelRequire("3Ppgt");
parcelRequire("fnPEF");
parcelRequire("jbstH");
parcelRequire("6NYMu");
parcelRequire("ebpYL");
parcelRequire("1yRYZ");
parcelRequire("cilb9");
parcelRequire("cSu3L");
parcelRequire("67qk3");

});
parcelRegister("1QeNb", function(module, exports) {

$parcel$export(module.exports, "BufferedTransformStream", () => $15761f3c464dcaca$export$1dec6b9a18b23f58);
parcelRequire("hr1EK");
var $9LJSP = parcelRequire("9LJSP");

var $bJSM1 = parcelRequire("bJSM1");

var $fnPEF = parcelRequire("fnPEF");

var $6NYMu = parcelRequire("6NYMu");
class $15761f3c464dcaca$export$1dec6b9a18b23f58 {
    #readable;
    get readable() {
        return this.#readable;
    }
    #writable;
    get writable() {
        return this.#writable;
    }
    constructor(transform){
        // Convert incoming chunks to a `BufferedReadableStream`
        let sourceStreamController;
        const buffered = new (0, $bJSM1.BufferedReadableStream)(new (0, $fnPEF.PushReadableStream)((controller)=>{
            sourceStreamController = controller;
        }));
        this.#readable = new (0, $6NYMu.ReadableStream)({
            async pull (controller) {
                try {
                    const value = await transform(buffered);
                    controller.enqueue(value);
                } catch (e) {
                    // Treat `StructEmptyError` as a normal end.
                    // If the `transform` method doesn't have enough data to return a value,
                    // it should throw another error to indicate that.
                    if (e instanceof (0, $9LJSP.StructEmptyError)) {
                        controller.close();
                        return;
                    }
                    throw e;
                }
            },
            cancel: (reason)=>{
                // Propagate cancel to the source stream
                // So future writes will be rejected
                return buffered.cancel(reason);
            }
        });
        this.#writable = new (0, $6NYMu.WritableStream)({
            async write (chunk) {
                await sourceStreamController.enqueue(chunk);
            },
            abort () {
                sourceStreamController.close();
            },
            close () {
                sourceStreamController.close();
            }
        });
    }
}

});
parcelRegister("hr1EK", function(module, exports) {
$parcel$export(module.exports, "ExactReadableEndedError", () => (parcelRequire("70dme")).ExactReadableEndedError);
$parcel$export(module.exports, "Struct", () => (parcelRequire("9LJSP")).Struct);
$parcel$export(module.exports, "StructEmptyError", () => (parcelRequire("9LJSP")).StructEmptyError);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("6yg6p")).SyncPromise);
$parcel$export(module.exports, "EMPTY_UINT8_ARRAY", () => (parcelRequire("j4unN")).EMPTY_UINT8_ARRAY);
$parcel$export(module.exports, "decodeUtf8", () => (parcelRequire("6Savq")).decodeUtf8);
$parcel$export(module.exports, "encodeUtf8", () => (parcelRequire("6Savq")).encodeUtf8);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("6Savq")).placeholder);

$parcel$export(module.exports, "default", () => (parcelRequire("9LJSP")).Struct);
parcelRequire("aF1FJ");

var $9LJSP = parcelRequire("9LJSP");
parcelRequire("6yg6p");
parcelRequire("3rhZL");
parcelRequire("6Savq");

});
parcelRegister("aF1FJ", function(module, exports) {
$parcel$export(module.exports, "StructFieldDefinition", () => (parcelRequire("hU3mS")).StructFieldDefinition);
$parcel$export(module.exports, "StructFieldValue", () => (parcelRequire("4dyEt")).StructFieldValue);
$parcel$export(module.exports, "StructDefaultOptions", () => (parcelRequire("8j8Qa")).StructDefaultOptions);
$parcel$export(module.exports, "ExactReadableEndedError", () => (parcelRequire("70dme")).ExactReadableEndedError);
$parcel$export(module.exports, "isStructValueInit", () => (parcelRequire("iissA")).isStructValueInit);
$parcel$export(module.exports, "STRUCT_VALUE_SYMBOL", () => (parcelRequire("iissA")).STRUCT_VALUE_SYMBOL);
$parcel$export(module.exports, "StructValue", () => (parcelRequire("iissA")).StructValue);
parcelRequire("hU3mS");
parcelRequire("4dyEt");
parcelRequire("8j8Qa");
parcelRequire("70dme");
parcelRequire("iissA");

});
parcelRegister("hU3mS", function(module, exports) {

$parcel$export(module.exports, "StructFieldDefinition", () => $035d11ab306c6c89$export$804794de18b9cab0);
/**
 * A field definition defines how to deserialize a field.
 *
 * @template TOptions TypeScript type of this definition's `options`.
 * @template TValue TypeScript type of this field.
 * @template TOmitInitKey Optionally remove some fields from the init type. Should be a union of string literal types.
 */ class $035d11ab306c6c89$export$804794de18b9cab0 {
    /**
     * When `T` is a type initiated `StructFieldDefinition`,
     * use `T['TValue']` to retrieve its `TValue` type parameter.
     */ TValue;
    /**
     * When `T` is a type initiated `StructFieldDefinition`,
     * use `T['TOmitInitKey']` to retrieve its `TOmitInitKey` type parameter.
     */ TOmitInitKey;
    options;
    constructor(options){
        this.options = options;
    }
}

});

parcelRegister("4dyEt", function(module, exports) {

$parcel$export(module.exports, "StructFieldValue", () => $312341718db575d7$export$391b04ee9b3e1655);
/**
 * A field value defines how to serialize a field.
 *
 * It may contains extra metadata about the value which are essential or
 * helpful for the serialization process.
 */ class $312341718db575d7$export$391b04ee9b3e1655 {
    /** Gets the definition associated with this runtime value */ definition;
    /** Gets the options of the associated `Struct` */ options;
    /** Gets the associated `Struct` instance */ struct;
    get hasCustomAccessors() {
        return this.get !== $312341718db575d7$export$391b04ee9b3e1655.prototype.get || this.set !== $312341718db575d7$export$391b04ee9b3e1655.prototype.set;
    }
    value;
    constructor(definition, options, struct, value){
        this.definition = definition;
        this.options = options;
        this.struct = struct;
        this.value = value;
    }
    /**
     * Gets size of this field. By default, it returns its `definition`'s size.
     *
     * When overridden in derived classes, can have custom logic to calculate the actual size.
     */ getSize() {
        return this.definition.getSize();
    }
    /**
     * When implemented in derived classes, reads current field's value.
     */ get() {
        return this.value;
    }
    /**
     * When implemented in derived classes, updates current field's value.
     */ set(value) {
        this.value = value;
    }
}

});

parcelRegister("8j8Qa", function(module, exports) {

$parcel$export(module.exports, "StructDefaultOptions", () => $60c6f49fee635812$export$d519eb5cbd68a82e);
const $60c6f49fee635812$export$d519eb5cbd68a82e = {
    littleEndian: false
};

});

parcelRegister("70dme", function(module, exports) {

$parcel$export(module.exports, "ExactReadableEndedError", () => $5192e50163bfdc4f$export$a89eeb2712a9e4e1);
// TODO: allow over reading (returning a `Uint8Array`, an `offset` and a `length`) to avoid copying
class $5192e50163bfdc4f$export$a89eeb2712a9e4e1 extends Error {
    constructor(){
        super("ExactReadable ended");
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

});

parcelRegister("iissA", function(module, exports) {

$parcel$export(module.exports, "STRUCT_VALUE_SYMBOL", () => $d51ffc090449bd90$export$bbd6643020302418);
$parcel$export(module.exports, "isStructValueInit", () => $d51ffc090449bd90$export$82df0b712ff78769);
$parcel$export(module.exports, "StructValue", () => $d51ffc090449bd90$export$f66d5fb339033b6);
const $d51ffc090449bd90$export$bbd6643020302418 = Symbol("struct-value");
function $d51ffc090449bd90$export$82df0b712ff78769(value) {
    return typeof value === "object" && value !== null && $d51ffc090449bd90$export$bbd6643020302418 in value;
}
class $d51ffc090449bd90$export$f66d5fb339033b6 {
    /** @internal */ fieldValues = {};
    /**
     * Gets the result struct value object
     */ value;
    constructor(prototype){
        // PERF: `Object.create(extra)` is 50% faster
        // than `Object.defineProperties(this.value, extra)`
        this.value = Object.create(prototype);
        // PERF: `Object.defineProperty` is slow
        // but we need it to be non-enumerable
        Object.defineProperty(this.value, $d51ffc090449bd90$export$bbd6643020302418, {
            enumerable: false,
            value: this
        });
    }
    /**
     * Sets a `StructFieldValue` for `key`
     *
     * @param name The field name
     * @param fieldValue The associated `StructFieldValue`
     */ set(name, fieldValue) {
        this.fieldValues[name] = fieldValue;
        // PERF: `Object.defineProperty` is slow
        // use normal property when possible
        if (fieldValue.hasCustomAccessors) Object.defineProperty(this.value, name, {
            configurable: true,
            enumerable: true,
            get () {
                return fieldValue.get();
            },
            set (v) {
                fieldValue.set(v);
            }
        });
        else this.value[name] = fieldValue.get();
    }
    /**
     * Gets the `StructFieldValue` for `key`
     *
     * @param name The field name
     */ get(name) {
        return this.fieldValues[name];
    }
}

});


parcelRegister("9LJSP", function(module, exports) {

$parcel$export(module.exports, "StructEmptyError", () => $71cc184b366eacb0$export$7af6964ac5489517);
$parcel$export(module.exports, "Struct", () => $71cc184b366eacb0$export$eabc71f011df675a);
/* eslint-disable @typescript-eslint/no-explicit-any */ parcelRequire("aF1FJ");
var $70dme = parcelRequire("70dme");
var $iissA = parcelRequire("iissA");
var $8j8Qa = parcelRequire("8j8Qa");

var $6yg6p = parcelRequire("6yg6p");
parcelRequire("3rhZL");
var $ioobU = parcelRequire("ioobU");
var $7M0oO = parcelRequire("7M0oO");
var $fiklF = parcelRequire("fiklF");
var $j4unN = parcelRequire("j4unN");
var $drcSV = parcelRequire("drcSV");
class $71cc184b366eacb0$export$40dad8b579eb5f98 extends Error {
    constructor(message){
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class $71cc184b366eacb0$export$4217ee4abf29bfe6 extends $71cc184b366eacb0$export$40dad8b579eb5f98 {
    constructor(){
        super("The underlying readable was ended before the struct was fully deserialized");
    }
}
class $71cc184b366eacb0$export$7af6964ac5489517 extends $71cc184b366eacb0$export$40dad8b579eb5f98 {
    constructor(){
        super("The underlying readable doesn't contain any more struct");
    }
}
class $71cc184b366eacb0$export$eabc71f011df675a {
    TFields;
    TOmitInitKey;
    TExtra;
    TInit;
    TDeserializeResult;
    options;
    #size = 0;
    /**
     * Gets the static size (exclude fields that can change size at runtime)
     */ get size() {
        return this.#size;
    }
    #fields = [];
    get fields() {
        return this.#fields;
    }
    #extra = {};
    #postDeserialized;
    constructor(options){
        this.options = {
            ...(0, $8j8Qa.StructDefaultOptions),
            ...options
        };
    }
    /**
     * Appends a `StructFieldDefinition` to the `Struct
     */ field(name, definition) {
        for (const field of this.#fields)if (field[0] === name) {
            // Convert Symbol to string
            const nameString = String(name);
            throw new Error(`This struct already have a field with name '${nameString}'`);
        }
        this.#fields.push([
            name,
            definition
        ]);
        const size = definition.getSize();
        this.#size += size;
        // Force cast `this` to another type
        return this;
    }
    /**
     * Merges (flats) another `Struct`'s fields and extra fields into this one.
     *
     * `other`'s `postDeserialize` will be ignored.
     */ concat(other) {
        if (!(other instanceof $71cc184b366eacb0$export$eabc71f011df675a)) throw new TypeError("The other value must be a `Struct` instance");
        for (const field of other.#fields)this.#fields.push(field);
        this.#size += other.#size;
        Object.defineProperties(this.#extra, Object.getOwnPropertyDescriptors(other.#extra));
        return this;
    }
    #number(name, type, typeScriptType) {
        return this.field(name, new (0, $fiklF.NumberFieldDefinition)(type, typeScriptType));
    }
    /**
     * Appends an `int8` field to the `Struct`
     */ int8(name, typeScriptType) {
        return this.#number(name, (0, $fiklF.NumberFieldVariant).Int8, typeScriptType);
    }
    /**
     * Appends an `uint8` field to the `Struct`
     */ uint8(name, typeScriptType) {
        return this.#number(name, (0, $fiklF.NumberFieldVariant).Uint8, typeScriptType);
    }
    /**
     * Appends an `int16` field to the `Struct`
     */ int16(name, typeScriptType) {
        return this.#number(name, (0, $fiklF.NumberFieldVariant).Int16, typeScriptType);
    }
    /**
     * Appends an `uint16` field to the `Struct`
     */ uint16(name, typeScriptType) {
        return this.#number(name, (0, $fiklF.NumberFieldVariant).Uint16, typeScriptType);
    }
    /**
     * Appends an `int32` field to the `Struct`
     */ int32(name, typeScriptType) {
        return this.#number(name, (0, $fiklF.NumberFieldVariant).Int32, typeScriptType);
    }
    /**
     * Appends an `uint32` field to the `Struct`
     */ uint32(name, typeScriptType) {
        return this.#number(name, (0, $fiklF.NumberFieldVariant).Uint32, typeScriptType);
    }
    #bigint(name, type, typeScriptType) {
        return this.field(name, new (0, $ioobU.BigIntFieldDefinition)(type, typeScriptType));
    }
    /**
     * Appends an `int64` field to the `Struct`
     *
     * Requires native `BigInt` support
     */ int64(name, typeScriptType) {
        return this.#bigint(name, (0, $ioobU.BigIntFieldVariant).Int64, typeScriptType);
    }
    /**
     * Appends an `uint64` field to the `Struct`
     *
     * Requires native `BigInt` support
     */ uint64(name, typeScriptType) {
        return this.#bigint(name, (0, $ioobU.BigIntFieldVariant).Uint64, typeScriptType);
    }
    #arrayBufferLike = (name, type, options)=>{
        if ("length" in options) return this.field(name, new (0, $7M0oO.FixedLengthBufferLikeFieldDefinition)(type, options));
        else return this.field(name, new (0, $drcSV.VariableLengthBufferLikeFieldDefinition)(type, options));
    };
    uint8Array = (name, options, typeScriptType)=>{
        return this.#arrayBufferLike(name, (0, $j4unN.Uint8ArrayBufferFieldConverter).Instance, options, typeScriptType);
    };
    string = (name, options, typeScriptType)=>{
        return this.#arrayBufferLike(name, (0, $j4unN.StringBufferFieldConverter).Instance, options, typeScriptType);
    };
    /**
     * Adds some extra properties into every `Struct` value.
     *
     * Extra properties will not affect serialize or deserialize process.
     *
     * Multiple calls to `extra` will merge all properties together.
     *
     * @param value
     * An object containing properties to be added to the result value. Accessors and methods are also allowed.
     */ extra(value) {
        Object.defineProperties(this.#extra, Object.getOwnPropertyDescriptors(value));
        return this;
    }
    postDeserialize(callback) {
        this.#postDeserialized = callback;
        return this;
    }
    deserialize(stream) {
        const structValue = new (0, $iissA.StructValue)(this.#extra);
        let promise = (0, $6yg6p.SyncPromise).resolve();
        const startPosition = stream.position;
        for (const [name, definition] of this.#fields)promise = promise.then(()=>definition.deserialize(this.options, stream, structValue)).then((fieldValue)=>{
            structValue.set(name, fieldValue);
        }, (e)=>{
            if (!(e instanceof (0, $70dme.ExactReadableEndedError))) throw e;
            if (stream.position === startPosition) throw new $71cc184b366eacb0$export$7af6964ac5489517();
            else throw new $71cc184b366eacb0$export$4217ee4abf29bfe6();
        });
        return promise.then(()=>{
            const value = structValue.value;
            // Run `postDeserialized`
            if (this.#postDeserialized) {
                const override = this.#postDeserialized.call(value, value);
                // If it returns a new value, use that as result
                // Otherwise it only inspects/mutates the object in place.
                if (override !== undefined) return override;
            }
            return value;
        }).valueOrPromise();
    }
    /**
     * Serialize a struct value to a buffer.
     * @param init Fields of the struct
     * @param output The buffer to serialize the struct to. It must be large enough to hold the entire struct. If not provided, a new buffer will be created.
     * @returns A view of `output` that contains the serialized struct, or a new buffer if `output` is not provided.
     */ serialize(init, output) {
        let structValue;
        if ((0, $iissA.isStructValueInit)(init)) {
            structValue = init[0, $iissA.STRUCT_VALUE_SYMBOL];
            for (const [key, value] of Object.entries(init)){
                const fieldValue = structValue.get(key);
                if (fieldValue) fieldValue.set(value);
            }
        } else {
            structValue = new (0, $iissA.StructValue)({});
            for (const [name, definition] of this.#fields){
                const fieldValue = definition.create(this.options, structValue, init[name]);
                structValue.set(name, fieldValue);
            }
        }
        let structSize = 0;
        const fieldsInfo = [];
        for (const [name] of this.#fields){
            const fieldValue = structValue.get(name);
            const size = fieldValue.getSize();
            fieldsInfo.push({
                fieldValue: fieldValue,
                size: size
            });
            structSize += size;
        }
        if (!output) output = new Uint8Array(structSize);
        else if (output.length < structSize) throw new TypeError("Output buffer is too small");
        const dataView = new DataView(output.buffer, output.byteOffset, output.byteLength);
        let offset = 0;
        for (const { fieldValue: fieldValue, size: size } of fieldsInfo){
            fieldValue.serialize(dataView, output, offset);
            offset += size;
        }
        if (output.length !== structSize) return output.subarray(0, structSize);
        else return output;
    }
}

});
parcelRegister("6yg6p", function(module, exports) {

$parcel$export(module.exports, "SyncPromise", () => $4c5268a801551813$export$6f292d4960313241);
const $4c5268a801551813$export$6f292d4960313241 = {
    reject (reason) {
        return new $4c5268a801551813$var$RejectedSyncPromise(reason);
    },
    resolve (value) {
        if (typeof value === "object" && value !== null && typeof value.then === "function") {
            if (value instanceof $4c5268a801551813$var$PendingSyncPromise || value instanceof $4c5268a801551813$var$ResolvedSyncPromise || value instanceof $4c5268a801551813$var$RejectedSyncPromise) return value;
            return new $4c5268a801551813$var$PendingSyncPromise(value);
        } else return new $4c5268a801551813$var$ResolvedSyncPromise(value);
    },
    try (executor) {
        try {
            return $4c5268a801551813$export$6f292d4960313241.resolve(executor());
        } catch (e) {
            return $4c5268a801551813$export$6f292d4960313241.reject(e);
        }
    }
};
class $4c5268a801551813$var$PendingSyncPromise {
    #promise;
    constructor(promise){
        this.#promise = promise;
    }
    then(onfulfilled, onrejected) {
        return new $4c5268a801551813$var$PendingSyncPromise(this.#promise.then(onfulfilled, onrejected));
    }
    valueOrPromise() {
        return this.#promise;
    }
}
class $4c5268a801551813$var$ResolvedSyncPromise {
    #value;
    constructor(value){
        this.#value = value;
    }
    then(onfulfilled) {
        if (!onfulfilled) return this;
        return $4c5268a801551813$export$6f292d4960313241.try(()=>onfulfilled(this.#value));
    }
    valueOrPromise() {
        return this.#value;
    }
}
class $4c5268a801551813$var$RejectedSyncPromise {
    #reason;
    constructor(reason){
        this.#reason = reason;
    }
    then(onfulfilled, onrejected) {
        if (!onrejected) return this;
        return $4c5268a801551813$export$6f292d4960313241.try(()=>onrejected(this.#reason));
    }
    valueOrPromise() {
        throw this.#reason;
    }
}

});

parcelRegister("3rhZL", function(module, exports) {
$parcel$export(module.exports, "BigIntFieldDefinition", () => (parcelRequire("ioobU")).BigIntFieldDefinition);
$parcel$export(module.exports, "BigIntFieldVariant", () => (parcelRequire("ioobU")).BigIntFieldVariant);
$parcel$export(module.exports, "EMPTY_UINT8_ARRAY", () => (parcelRequire("j4unN")).EMPTY_UINT8_ARRAY);
$parcel$export(module.exports, "FixedLengthBufferLikeFieldDefinition", () => (parcelRequire("7M0oO")).FixedLengthBufferLikeFieldDefinition);
$parcel$export(module.exports, "StringBufferFieldConverter", () => (parcelRequire("j4unN")).StringBufferFieldConverter);
$parcel$export(module.exports, "Uint8ArrayBufferFieldConverter", () => (parcelRequire("j4unN")).Uint8ArrayBufferFieldConverter);
$parcel$export(module.exports, "VariableLengthBufferLikeFieldDefinition", () => (parcelRequire("drcSV")).VariableLengthBufferLikeFieldDefinition);
$parcel$export(module.exports, "NumberFieldDefinition", () => (parcelRequire("fiklF")).NumberFieldDefinition);
$parcel$export(module.exports, "NumberFieldVariant", () => (parcelRequire("fiklF")).NumberFieldVariant);
parcelRequire("ioobU");
parcelRequire("5R05c");
parcelRequire("fiklF");

});
parcelRegister("ioobU", function(module, exports) {

$parcel$export(module.exports, "BigIntFieldVariant", () => $d63d3bb5814df626$export$7f44118adc318a0c);
$parcel$export(module.exports, "BigIntFieldDefinition", () => $d63d3bb5814df626$export$47590baf50e650b4);
parcelRequire("cOond");
var $duafd = parcelRequire("duafd");
var $jzfEx = parcelRequire("jzfEx");
parcelRequire("aF1FJ");
var $hU3mS = parcelRequire("hU3mS");
var $4dyEt = parcelRequire("4dyEt");

var $6yg6p = parcelRequire("6yg6p");
class $d63d3bb5814df626$export$7f44118adc318a0c {
    TTypeScriptType;
    size;
    deserialize;
    serialize;
    constructor(size, deserialize, serialize){
        this.size = size;
        this.deserialize = deserialize;
        this.serialize = serialize;
    }
    static Int64 = new $d63d3bb5814df626$export$7f44118adc318a0c(8, (0, $duafd.getInt64), (0, $duafd.setInt64));
    static Uint64 = new $d63d3bb5814df626$export$7f44118adc318a0c(8, (0, $jzfEx.getUint64), (0, $jzfEx.setUint64));
}
class $d63d3bb5814df626$export$47590baf50e650b4 extends (0, $hU3mS.StructFieldDefinition) {
    variant;
    constructor(variant, typescriptType){
        super();
        this.variant = variant;
    }
    getSize() {
        return this.variant.size;
    }
    create(options, struct, value) {
        return new $d63d3bb5814df626$export$356b59f789fa5206(this, options, struct, value);
    }
    deserialize(options, stream, struct) {
        return (0, $6yg6p.SyncPromise).try(()=>{
            return stream.readExactly(this.getSize());
        }).then((array)=>{
            const value = this.variant.deserialize(array, 0, options.littleEndian);
            return this.create(options, struct, value);
        }).valueOrPromise();
    }
}
class $d63d3bb5814df626$export$356b59f789fa5206 extends (0, $4dyEt.StructFieldValue) {
    serialize(dataView, array, offset) {
        this.definition.variant.serialize(array, offset, this.value, this.options.littleEndian);
    }
}

});
parcelRegister("cOond", function(module, exports) {
$parcel$export(module.exports, "getInt16", () => (parcelRequire("eRgHk")).getInt16);
$parcel$export(module.exports, "getInt32", () => (parcelRequire("4smoc")).getInt32);
$parcel$export(module.exports, "getInt64", () => (parcelRequire("duafd")).getInt64);
$parcel$export(module.exports, "setInt64", () => (parcelRequire("duafd")).setInt64);
$parcel$export(module.exports, "setInt64BigEndian", () => (parcelRequire("duafd")).setInt64BigEndian);
$parcel$export(module.exports, "setInt64LittleEndian", () => (parcelRequire("duafd")).setInt64LittleEndian);
$parcel$export(module.exports, "getInt8", () => (parcelRequire("gBDJc")).getInt8);
$parcel$export(module.exports, "getUint16", () => (parcelRequire("hXg0k")).getUint16);
$parcel$export(module.exports, "getUint32", () => (parcelRequire("h4MAN")).getUint32);
$parcel$export(module.exports, "getUint32LittleEndian", () => (parcelRequire("h4MAN")).getUint32LittleEndian);
$parcel$export(module.exports, "setUint32LittleEndian", () => (parcelRequire("h4MAN")).setUint32LittleEndian);
$parcel$export(module.exports, "getUint64", () => (parcelRequire("jzfEx")).getUint64);
$parcel$export(module.exports, "getUint64BigEndian", () => (parcelRequire("jzfEx")).getUint64BigEndian);
$parcel$export(module.exports, "getUint64LittleEndian", () => (parcelRequire("jzfEx")).getUint64LittleEndian);
$parcel$export(module.exports, "setUint64", () => (parcelRequire("jzfEx")).setUint64);
parcelRequire("eRgHk");
parcelRequire("4smoc");
parcelRequire("duafd");
parcelRequire("gBDJc");
parcelRequire("hXg0k");
parcelRequire("h4MAN");
parcelRequire("jzfEx");

});
parcelRegister("eRgHk", function(module, exports) {

$parcel$export(module.exports, "getInt16", () => $ad12f7c62572a109$export$7111ea4c3e27a959);
function $ad12f7c62572a109$export$8ecc34650601d284(buffer, offset) {
    return (buffer[offset] | buffer[offset + 1] << 8) << 16 >> 16;
}
function $ad12f7c62572a109$export$31e6610dad8278c3(buffer, offset) {
    return (buffer[offset] << 8 | buffer[offset + 1]) << 16 >> 16;
}
function $ad12f7c62572a109$export$7111ea4c3e27a959(buffer, offset, littleEndian) {
    return littleEndian ? (buffer[offset] | buffer[offset + 1] << 8) << 16 >> 16 : (buffer[offset] << 8 | buffer[offset + 1]) << 16 >> 16;
}
function $ad12f7c62572a109$export$1b4d6b0ecaff32eb(buffer, offset, value) {
    buffer[offset] = value;
    buffer[offset + 1] = value >> 8;
}
function $ad12f7c62572a109$export$1583be194bf15055(buffer, offset, value) {
    buffer[offset] = value >> 8;
    buffer[offset + 1] = value;
}
function $ad12f7c62572a109$export$d8d638e42ac1fe2f(buffer, offset, value, littleEndian) {
    if (littleEndian) {
        buffer[offset] = value;
        buffer[offset + 1] = value >> 8;
    } else {
        buffer[offset] = value >> 8;
        buffer[offset + 1] = value;
    }
}

});

parcelRegister("4smoc", function(module, exports) {

$parcel$export(module.exports, "getInt32", () => $33eb2502b7dced81$export$20d487fff2ae6963);
function $33eb2502b7dced81$export$a2c6b659ff2486d0(buffer, offset) {
    return buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24;
}
function $33eb2502b7dced81$export$41cf657275e1bfab(buffer, offset) {
    return buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3];
}
function $33eb2502b7dced81$export$20d487fff2ae6963(buffer, offset, littleEndian) {
    return littleEndian ? buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24 : buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3];
}
function $33eb2502b7dced81$export$7460bcdfeca2afc5(buffer, offset, value) {
    buffer[offset] = value;
    buffer[offset + 1] = value >> 8;
    buffer[offset + 2] = value >> 16;
    buffer[offset + 3] = value >> 24;
}
function $33eb2502b7dced81$export$518473d365c4024c(buffer, offset, value) {
    buffer[offset] = value >> 24;
    buffer[offset + 1] = value >> 16;
    buffer[offset + 2] = value >> 8;
    buffer[offset + 3] = value;
}
function $33eb2502b7dced81$export$db798d0ac03ef04(buffer, offset, value, littleEndian) {
    if (littleEndian) {
        buffer[offset] = value;
        buffer[offset + 1] = value >> 8;
        buffer[offset + 2] = value >> 16;
        buffer[offset + 3] = value >> 24;
    } else {
        buffer[offset] = value >> 24;
        buffer[offset + 1] = value >> 16;
        buffer[offset + 2] = value >> 8;
        buffer[offset + 3] = value;
    }
}

});

parcelRegister("duafd", function(module, exports) {

$parcel$export(module.exports, "getInt64", () => $9d160602087c97c1$export$69825c7adcc820c6);
$parcel$export(module.exports, "setInt64LittleEndian", () => $9d160602087c97c1$export$e2d026b78208efb4);
$parcel$export(module.exports, "setInt64BigEndian", () => $9d160602087c97c1$export$cb00adb52e928ee5);
$parcel$export(module.exports, "setInt64", () => $9d160602087c97c1$export$8532a5209571c04a);
function $9d160602087c97c1$export$75f4701eb3269d38(buffer, offset) {
    return BigInt(buffer[offset]) | BigInt(buffer[offset + 1]) << 8n | BigInt(buffer[offset + 2]) << 16n | BigInt(buffer[offset + 3]) << 24n | BigInt(buffer[offset + 4]) << 32n | BigInt(buffer[offset + 5]) << 40n | BigInt(buffer[offset + 6]) << 48n | BigInt(buffer[offset + 7] << 24) << 32n;
}
function $9d160602087c97c1$export$8e7e9100eaf0d0ef(buffer, offset) {
    return BigInt(buffer[offset] << 24) << 32n | BigInt(buffer[offset + 1]) << 48n | BigInt(buffer[offset + 2]) << 40n | BigInt(buffer[offset + 3]) << 32n | BigInt(buffer[offset + 4]) << 24n | BigInt(buffer[offset + 5]) << 16n | BigInt(buffer[offset + 6]) << 8n | BigInt(buffer[offset + 7]);
}
function $9d160602087c97c1$export$69825c7adcc820c6(buffer, offset, littleEndian) {
    return littleEndian ? BigInt(buffer[offset]) | BigInt(buffer[offset + 1]) << 8n | BigInt(buffer[offset + 2]) << 16n | BigInt(buffer[offset + 3]) << 24n | BigInt(buffer[offset + 4]) << 32n | BigInt(buffer[offset + 5]) << 40n | BigInt(buffer[offset + 6]) << 48n | BigInt(buffer[offset + 7] << 24) << 32n : BigInt(buffer[offset] << 24) << 32n | BigInt(buffer[offset + 1]) << 48n | BigInt(buffer[offset + 2]) << 40n | BigInt(buffer[offset + 3]) << 32n | BigInt(buffer[offset + 4]) << 24n | BigInt(buffer[offset + 5]) << 16n | BigInt(buffer[offset + 6]) << 8n | BigInt(buffer[offset + 7]);
}
function $9d160602087c97c1$export$e2d026b78208efb4(buffer, offset, value) {
    buffer[offset] = Number(value & 0xffn);
    buffer[offset + 1] = Number(value >> 8n & 0xffn);
    buffer[offset + 2] = Number(value >> 16n & 0xffn);
    buffer[offset + 3] = Number(value >> 24n & 0xffn);
    buffer[offset + 4] = Number(value >> 32n & 0xffn);
    buffer[offset + 5] = Number(value >> 40n & 0xffn);
    buffer[offset + 6] = Number(value >> 48n & 0xffn);
    buffer[offset + 7] = Number(value >> 56n & 0xffn);
}
function $9d160602087c97c1$export$cb00adb52e928ee5(buffer, offset, value) {
    buffer[offset] = Number(value >> 56n & 0xffn);
    buffer[offset + 1] = Number(value >> 48n & 0xffn);
    buffer[offset + 2] = Number(value >> 40n & 0xffn);
    buffer[offset + 3] = Number(value >> 32n & 0xffn);
    buffer[offset + 4] = Number(value >> 24n & 0xffn);
    buffer[offset + 5] = Number(value >> 16n & 0xffn);
    buffer[offset + 6] = Number(value >> 8n & 0xffn);
    buffer[offset + 7] = Number(value & 0xffn);
}
function $9d160602087c97c1$export$8532a5209571c04a(buffer, offset, value, littleEndian) {
    if (littleEndian) {
        buffer[offset] = Number(value & 0xffn);
        buffer[offset + 1] = Number(value >> 8n & 0xffn);
        buffer[offset + 2] = Number(value >> 16n & 0xffn);
        buffer[offset + 3] = Number(value >> 24n & 0xffn);
        buffer[offset + 4] = Number(value >> 32n & 0xffn);
        buffer[offset + 5] = Number(value >> 40n & 0xffn);
        buffer[offset + 6] = Number(value >> 48n & 0xffn);
        buffer[offset + 7] = Number(value >> 56n & 0xffn);
    } else {
        buffer[offset] = Number(value >> 56n & 0xffn);
        buffer[offset + 1] = Number(value >> 48n & 0xffn);
        buffer[offset + 2] = Number(value >> 40n & 0xffn);
        buffer[offset + 3] = Number(value >> 32n & 0xffn);
        buffer[offset + 4] = Number(value >> 24n & 0xffn);
        buffer[offset + 5] = Number(value >> 16n & 0xffn);
        buffer[offset + 6] = Number(value >> 8n & 0xffn);
        buffer[offset + 7] = Number(value & 0xffn);
    }
}

});

parcelRegister("gBDJc", function(module, exports) {

$parcel$export(module.exports, "getInt8", () => $c16eeb37ab2cbf45$export$56c0324b6d39bf6e);
function $c16eeb37ab2cbf45$export$56c0324b6d39bf6e(buffer, offset) {
    return buffer[offset] << 24 >> 24;
}

});

parcelRegister("hXg0k", function(module, exports) {

$parcel$export(module.exports, "getUint16", () => $d1245c7d15e31db4$export$89b158b9ac91fb05);
function $d1245c7d15e31db4$export$e809f04cb3902cdf(buffer, offset) {
    return buffer[offset] | buffer[offset + 1] << 8;
}
function $d1245c7d15e31db4$export$41356f71fc3df9a6(buffer, offset) {
    return buffer[offset] << 8 | buffer[offset + 1];
}
function $d1245c7d15e31db4$export$89b158b9ac91fb05(buffer, offset, littleEndian) {
    return littleEndian ? buffer[offset] | buffer[offset + 1] << 8 : buffer[offset + 1] | buffer[offset] << 8;
}
function $d1245c7d15e31db4$export$56e72cb47a22d547(buffer, offset, value) {
    buffer[offset] = value;
    buffer[offset + 1] = value >> 8;
}
function $d1245c7d15e31db4$export$696f8c2194ddb93a(buffer, offset, value) {
    buffer[offset] = value >> 8;
    buffer[offset + 1] = value;
}
function $d1245c7d15e31db4$export$f86e1edc3d839287(buffer, offset, value, littleEndian) {
    if (littleEndian) {
        buffer[offset] = value;
        buffer[offset + 1] = value >> 8;
    } else {
        buffer[offset] = value >> 8;
        buffer[offset + 1] = value;
    }
}

});

parcelRegister("h4MAN", function(module, exports) {

$parcel$export(module.exports, "getUint32LittleEndian", () => $c6e880d99c088db3$export$93a5511f94f97356);
$parcel$export(module.exports, "getUint32", () => $c6e880d99c088db3$export$44118f6ad20a04bd);
$parcel$export(module.exports, "setUint32LittleEndian", () => $c6e880d99c088db3$export$c60a33cd4171510b);
function $c6e880d99c088db3$export$93a5511f94f97356(buffer, offset) {
    return (buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24) >>> 0;
}
function $c6e880d99c088db3$export$5c240411bb8c7df3(buffer, offset) {
    return (buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3]) >>> 0;
}
function $c6e880d99c088db3$export$44118f6ad20a04bd(buffer, offset, littleEndian) {
    return littleEndian ? (buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24) >>> 0 : (buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3]) >>> 0;
}
function $c6e880d99c088db3$export$c60a33cd4171510b(buffer, offset, value) {
    buffer[offset] = value;
    buffer[offset + 1] = value >> 8;
    buffer[offset + 2] = value >> 16;
    buffer[offset + 3] = value >> 24;
}
function $c6e880d99c088db3$export$b619f4ab00f83cf8(buffer, offset, value) {
    buffer[offset] = value >> 24;
    buffer[offset + 1] = value >> 16;
    buffer[offset + 2] = value >> 8;
    buffer[offset + 3] = value;
}
function $c6e880d99c088db3$export$5517b6394fc440fb(buffer, offset, value, littleEndian) {
    if (littleEndian) {
        buffer[offset] = value;
        buffer[offset + 1] = value >> 8;
        buffer[offset + 2] = value >> 16;
        buffer[offset + 3] = value >> 24;
    } else {
        buffer[offset] = value >> 24;
        buffer[offset + 1] = value >> 16;
        buffer[offset + 2] = value >> 8;
        buffer[offset + 3] = value;
    }
}

});

parcelRegister("jzfEx", function(module, exports) {

$parcel$export(module.exports, "getUint64LittleEndian", () => $e3ed6d8482796099$export$a43c509a1df9dbdf);
$parcel$export(module.exports, "getUint64BigEndian", () => $e3ed6d8482796099$export$71480404fe2732b3);
$parcel$export(module.exports, "getUint64", () => $e3ed6d8482796099$export$59a2dbf579ff9568);
$parcel$export(module.exports, "setUint64", () => $e3ed6d8482796099$export$20f71c4c8b0f96c3);
function $e3ed6d8482796099$export$a43c509a1df9dbdf(buffer, offset) {
    return BigInt(buffer[offset]) | BigInt(buffer[offset + 1]) << 8n | BigInt(buffer[offset + 2]) << 16n | BigInt(buffer[offset + 3]) << 24n | BigInt(buffer[offset + 4]) << 32n | BigInt(buffer[offset + 5]) << 40n | BigInt(buffer[offset + 6]) << 48n | BigInt(buffer[offset + 7]) << 56n;
}
function $e3ed6d8482796099$export$71480404fe2732b3(buffer, offset) {
    return BigInt(buffer[offset]) << 56n | BigInt(buffer[offset + 1]) << 48n | BigInt(buffer[offset + 2]) << 40n | BigInt(buffer[offset + 3]) << 32n | BigInt(buffer[offset + 4]) << 24n | BigInt(buffer[offset + 5]) << 16n | BigInt(buffer[offset + 6]) << 8n | BigInt(buffer[offset + 7]);
}
function $e3ed6d8482796099$export$59a2dbf579ff9568(buffer, offset, littleEndian) {
    return littleEndian ? BigInt(buffer[offset]) | BigInt(buffer[offset + 1]) << 8n | BigInt(buffer[offset + 2]) << 16n | BigInt(buffer[offset + 3]) << 24n | BigInt(buffer[offset + 4]) << 32n | BigInt(buffer[offset + 5]) << 40n | BigInt(buffer[offset + 6]) << 48n | BigInt(buffer[offset + 7]) << 56n : BigInt(buffer[offset]) << 56n | BigInt(buffer[offset + 1]) << 48n | BigInt(buffer[offset + 2]) << 40n | BigInt(buffer[offset + 3]) << 32n | BigInt(buffer[offset + 4]) << 24n | BigInt(buffer[offset + 5]) << 16n | BigInt(buffer[offset + 6]) << 8n | BigInt(buffer[offset + 7]);
}
function $e3ed6d8482796099$export$5f181e77f490ff66(buffer, offset, value) {
    buffer[offset] = Number(value & 0xffn);
    buffer[offset + 1] = Number(value >> 8n & 0xffn);
    buffer[offset + 2] = Number(value >> 16n & 0xffn);
    buffer[offset + 3] = Number(value >> 24n & 0xffn);
    buffer[offset + 4] = Number(value >> 32n & 0xffn);
    buffer[offset + 5] = Number(value >> 40n & 0xffn);
    buffer[offset + 6] = Number(value >> 48n & 0xffn);
    buffer[offset + 7] = Number(value >> 56n & 0xffn);
}
function $e3ed6d8482796099$export$e863955b31b735c4(buffer, offset, value) {
    buffer[offset] = Number(value >> 56n & 0xffn);
    buffer[offset + 1] = Number(value >> 48n & 0xffn);
    buffer[offset + 2] = Number(value >> 40n & 0xffn);
    buffer[offset + 3] = Number(value >> 32n & 0xffn);
    buffer[offset + 4] = Number(value >> 24n & 0xffn);
    buffer[offset + 5] = Number(value >> 16n & 0xffn);
    buffer[offset + 6] = Number(value >> 8n & 0xffn);
    buffer[offset + 7] = Number(value & 0xffn);
}
function $e3ed6d8482796099$export$20f71c4c8b0f96c3(buffer, offset, value, littleEndian) {
    if (littleEndian) {
        buffer[offset] = Number(value & 0xffn);
        buffer[offset + 1] = Number(value >> 8n & 0xffn);
        buffer[offset + 2] = Number(value >> 16n & 0xffn);
        buffer[offset + 3] = Number(value >> 24n & 0xffn);
        buffer[offset + 4] = Number(value >> 32n & 0xffn);
        buffer[offset + 5] = Number(value >> 40n & 0xffn);
        buffer[offset + 6] = Number(value >> 48n & 0xffn);
        buffer[offset + 7] = Number(value >> 56n & 0xffn);
    } else {
        buffer[offset] = Number(value >> 56n & 0xffn);
        buffer[offset + 1] = Number(value >> 48n & 0xffn);
        buffer[offset + 2] = Number(value >> 40n & 0xffn);
        buffer[offset + 3] = Number(value >> 32n & 0xffn);
        buffer[offset + 4] = Number(value >> 24n & 0xffn);
        buffer[offset + 5] = Number(value >> 16n & 0xffn);
        buffer[offset + 6] = Number(value >> 8n & 0xffn);
        buffer[offset + 7] = Number(value & 0xffn);
    }
}

});



parcelRegister("5R05c", function(module, exports) {
$parcel$export(module.exports, "EMPTY_UINT8_ARRAY", () => (parcelRequire("j4unN")).EMPTY_UINT8_ARRAY);
$parcel$export(module.exports, "StringBufferFieldConverter", () => (parcelRequire("j4unN")).StringBufferFieldConverter);
$parcel$export(module.exports, "Uint8ArrayBufferFieldConverter", () => (parcelRequire("j4unN")).Uint8ArrayBufferFieldConverter);
$parcel$export(module.exports, "FixedLengthBufferLikeFieldDefinition", () => (parcelRequire("7M0oO")).FixedLengthBufferLikeFieldDefinition);
$parcel$export(module.exports, "VariableLengthBufferLikeFieldDefinition", () => (parcelRequire("drcSV")).VariableLengthBufferLikeFieldDefinition);
parcelRequire("j4unN");
parcelRequire("7M0oO");
parcelRequire("drcSV");

});
parcelRegister("j4unN", function(module, exports) {

$parcel$export(module.exports, "Uint8ArrayBufferFieldConverter", () => $de25f57275dc3b5f$export$919ddce6d1c56738);
$parcel$export(module.exports, "StringBufferFieldConverter", () => $de25f57275dc3b5f$export$df462518ae175b8f);
$parcel$export(module.exports, "EMPTY_UINT8_ARRAY", () => $de25f57275dc3b5f$export$ff4d98424a9fd4b9);
$parcel$export(module.exports, "BufferLikeFieldDefinition", () => $de25f57275dc3b5f$export$5fed7215206b866f);
$parcel$export(module.exports, "BufferLikeFieldValue", () => $de25f57275dc3b5f$export$3f021200daa961db);
parcelRequire("aF1FJ");
var $hU3mS = parcelRequire("hU3mS");
var $4dyEt = parcelRequire("4dyEt");

var $6yg6p = parcelRequire("6yg6p");

var $6Savq = parcelRequire("6Savq");
class $de25f57275dc3b5f$export$44ecb42ac2345560 {
    TTypeScriptType;
}
class $de25f57275dc3b5f$export$919ddce6d1c56738 extends $de25f57275dc3b5f$export$44ecb42ac2345560 {
    static Instance = new $de25f57275dc3b5f$export$919ddce6d1c56738();
    constructor(){
        super();
    }
    toBuffer(value) {
        return value;
    }
    toValue(buffer) {
        return buffer;
    }
    getSize(value) {
        return value.length;
    }
}
class $de25f57275dc3b5f$export$df462518ae175b8f extends $de25f57275dc3b5f$export$44ecb42ac2345560 {
    static Instance = new $de25f57275dc3b5f$export$df462518ae175b8f();
    toBuffer(value) {
        return (0, $6Savq.encodeUtf8)(value);
    }
    toValue(array) {
        return (0, $6Savq.decodeUtf8)(array);
    }
    getSize() {
        // See the note in `BufferFieldConverter.getSize`
        return undefined;
    }
}
const $de25f57275dc3b5f$export$ff4d98424a9fd4b9 = new Uint8Array(0);
class $de25f57275dc3b5f$export$5fed7215206b866f extends (0, $hU3mS.StructFieldDefinition) {
    converter;
    TTypeScriptType;
    constructor(converter, options){
        super(options);
        this.converter = converter;
    }
    getDeserializeSize(struct) {
        return this.getSize();
    }
    /**
     * When implemented in derived classes, creates a `StructFieldValue` for the current field definition.
     */ create(options, struct, value, array) {
        return new $de25f57275dc3b5f$export$3f021200daa961db(this, options, struct, value, array);
    }
    deserialize(options, stream, struct) {
        return (0, $6yg6p.SyncPromise).try(()=>{
            const size = this.getDeserializeSize(struct);
            if (size === 0) return $de25f57275dc3b5f$export$ff4d98424a9fd4b9;
            else return stream.readExactly(size);
        }).then((array)=>{
            const value = this.converter.toValue(array);
            return this.create(options, struct, value, array);
        }).valueOrPromise();
    }
}
class $de25f57275dc3b5f$export$3f021200daa961db extends (0, $4dyEt.StructFieldValue) {
    array;
    constructor(definition, options, struct, value, array){
        super(definition, options, struct, value);
        this.array = array;
    }
    set(value) {
        super.set(value);
        // When value changes, clear the cached `array`
        // It will be lazily calculated in `serialize()`
        this.array = undefined;
    }
    serialize(dataView, array, offset) {
        this.array ??= this.definition.converter.toBuffer(this.value);
        array.set(this.array, offset);
    }
}

});
parcelRegister("6Savq", function(module, exports) {

$parcel$export(module.exports, "placeholder", () => $500fef713084bd27$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "encodeUtf8", () => $500fef713084bd27$export$8f647c2204da8484);
$parcel$export(module.exports, "decodeUtf8", () => $500fef713084bd27$export$72118b85b055afd);
/**
 * Returns a (fake) value of the given type.
 */ function $500fef713084bd27$export$c7187bbd1a7a9244() {
    return undefined;
}
const { TextEncoder: $500fef713084bd27$var$TextEncoder, TextDecoder: $500fef713084bd27$var$TextDecoder } = globalThis;
const $500fef713084bd27$var$SharedEncoder = new $500fef713084bd27$var$TextEncoder();
const $500fef713084bd27$var$SharedDecoder = new $500fef713084bd27$var$TextDecoder();
function $500fef713084bd27$export$8f647c2204da8484(input) {
    return $500fef713084bd27$var$SharedEncoder.encode(input);
}
function $500fef713084bd27$export$72118b85b055afd(buffer) {
    // `TextDecoder` has internal states in stream mode,
    // but this method is not for stream mode, so the instance can be reused
    return $500fef713084bd27$var$SharedDecoder.decode(buffer);
}

});


parcelRegister("7M0oO", function(module, exports) {

$parcel$export(module.exports, "FixedLengthBufferLikeFieldDefinition", () => $5a8d5361bdac236c$export$f6ef9f85bb06aeff);

var $j4unN = parcelRequire("j4unN");
class $5a8d5361bdac236c$export$f6ef9f85bb06aeff extends (0, $j4unN.BufferLikeFieldDefinition) {
    getSize() {
        return this.options.length;
    }
}

});

parcelRegister("drcSV", function(module, exports) {

$parcel$export(module.exports, "VariableLengthBufferLikeFieldDefinition", () => $9c87caa7f7c09f42$export$bd5db95fcc20ece9);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ parcelRequire("aF1FJ");
var $4dyEt = parcelRequire("4dyEt");

var $j4unN = parcelRequire("j4unN");
class $9c87caa7f7c09f42$export$bd5db95fcc20ece9 extends (0, $j4unN.BufferLikeFieldDefinition) {
    getSize() {
        return 0;
    }
    getDeserializeSize(struct) {
        let value = struct.value[this.options.lengthField];
        if (typeof value === "string") value = Number.parseInt(value, this.options.lengthFieldRadix ?? 10);
        return value;
    }
    create(options, struct, value, array) {
        return new $9c87caa7f7c09f42$export$d3219f0279a7fe4e(this, options, struct, value, array);
    }
}
class $9c87caa7f7c09f42$export$d3219f0279a7fe4e extends (0, $j4unN.BufferLikeFieldValue) {
    length;
    lengthFieldValue;
    constructor(definition, options, struct, value, array){
        super(definition, options, struct, value, array);
        if (array) this.length = array.length;
        // Patch the associated length field.
        const lengthField = this.definition.options.lengthField;
        const originalValue = struct.get(lengthField);
        this.lengthFieldValue = new $9c87caa7f7c09f42$export$4ea2368eb6ab5b42(originalValue, this);
        struct.set(lengthField, this.lengthFieldValue);
    }
    #tryGetSize() {
        const length = this.definition.converter.getSize(this.value);
        if (length !== undefined && length < 0) throw new Error("Invalid length");
        return length;
    }
    getSize() {
        if (this.length === undefined) // first try to get the size from the converter
        this.length = this.#tryGetSize();
        if (this.length === undefined) {
            // The converter doesn't know the size, so convert the value to a buffer to get its size
            this.array = this.definition.converter.toBuffer(this.value);
            this.length = this.array.length;
        }
        return this.length;
    }
    set(value) {
        super.set(value);
        this.array = undefined;
        this.length = undefined;
    }
}
class $9c87caa7f7c09f42$export$4ea2368eb6ab5b42 extends (0, $4dyEt.StructFieldValue) {
    originalValue;
    bufferValue;
    constructor(originalValue, bufferValue){
        super(originalValue.definition, originalValue.options, originalValue.struct, 0);
        this.originalValue = originalValue;
        this.bufferValue = bufferValue;
    }
    getSize() {
        return this.originalValue.getSize();
    }
    get() {
        let value = this.bufferValue.getSize();
        const originalValue = this.originalValue.get();
        if (typeof originalValue === "string") value = value.toString(this.bufferValue.definition.options.lengthFieldRadix ?? 10);
        return value;
    }
    set() {
    // Ignore setting
    // It will always be in sync with the buffer size
    }
    serialize(dataView, array, offset) {
        this.originalValue.set(this.get());
        this.originalValue.serialize(dataView, array, offset);
    }
}

});


parcelRegister("fiklF", function(module, exports) {

$parcel$export(module.exports, "NumberFieldVariant", () => $b2285239387cc49c$export$6eb6015f2bce1d68);
$parcel$export(module.exports, "NumberFieldDefinition", () => $b2285239387cc49c$export$e8cfbf1c68de676b);
parcelRequire("cOond");
var $eRgHk = parcelRequire("eRgHk");
var $4smoc = parcelRequire("4smoc");
var $gBDJc = parcelRequire("gBDJc");
var $hXg0k = parcelRequire("hXg0k");
var $h4MAN = parcelRequire("h4MAN");
parcelRequire("aF1FJ");
var $hU3mS = parcelRequire("hU3mS");
var $4dyEt = parcelRequire("4dyEt");

var $6yg6p = parcelRequire("6yg6p");
var $b2285239387cc49c$export$6eb6015f2bce1d68;
(function(NumberFieldVariant) {
    NumberFieldVariant.Uint8 = {
        signed: false,
        size: 1,
        deserialize (array) {
            return array[0];
        },
        serialize (dataView, offset, value) {
            dataView.setUint8(offset, value);
        }
    };
    NumberFieldVariant.Int8 = {
        signed: true,
        size: 1,
        deserialize (array) {
            return (0, $gBDJc.getInt8)(array, 0);
        },
        serialize (dataView, offset, value) {
            dataView.setInt8(offset, value);
        }
    };
    NumberFieldVariant.Uint16 = {
        signed: false,
        size: 2,
        deserialize (array, littleEndian) {
            // PERF: Creating many `DataView`s over small buffers is 90% slower
            // than this. Even if the `DataView` is cached, `DataView#getUint16`
            // is still 1% slower than this.
            return (0, $hXg0k.getUint16)(array, 0, littleEndian);
        },
        serialize (dataView, offset, value, littleEndian) {
            dataView.setUint16(offset, value, littleEndian);
        }
    };
    NumberFieldVariant.Int16 = {
        signed: true,
        size: 2,
        deserialize (array, littleEndian) {
            return (0, $eRgHk.getInt16)(array, 0, littleEndian);
        },
        serialize (dataView, offset, value, littleEndian) {
            dataView.setInt16(offset, value, littleEndian);
        }
    };
    NumberFieldVariant.Uint32 = {
        signed: false,
        size: 4,
        deserialize (array, littleEndian) {
            return (0, $h4MAN.getUint32)(array, 0, littleEndian);
        },
        serialize (dataView, offset, value, littleEndian) {
            dataView.setUint32(offset, value, littleEndian);
        }
    };
    NumberFieldVariant.Int32 = {
        signed: true,
        size: 4,
        deserialize (array, littleEndian) {
            return (0, $4smoc.getInt32)(array, 0, littleEndian);
        },
        serialize (dataView, offset, value, littleEndian) {
            dataView.setInt32(offset, value, littleEndian);
        }
    };
})($b2285239387cc49c$export$6eb6015f2bce1d68 || ($b2285239387cc49c$export$6eb6015f2bce1d68 = {}));
class $b2285239387cc49c$export$e8cfbf1c68de676b extends (0, $hU3mS.StructFieldDefinition) {
    variant;
    constructor(variant, typescriptType){
        super();
        this.variant = variant;
    }
    getSize() {
        return this.variant.size;
    }
    create(options, struct, value) {
        return new $b2285239387cc49c$export$1365bb43729bbdfd(this, options, struct, value);
    }
    deserialize(options, stream, struct) {
        return (0, $6yg6p.SyncPromise).try(()=>{
            return stream.readExactly(this.getSize());
        }).then((array)=>{
            const value = this.variant.deserialize(array, options.littleEndian);
            return this.create(options, struct, value);
        }).valueOrPromise();
    }
}
class $b2285239387cc49c$export$1365bb43729bbdfd extends (0, $4dyEt.StructFieldValue) {
    serialize(dataView, array, offset) {
        this.definition.variant.serialize(dataView, offset, this.value, this.options.littleEndian);
    }
}

});




parcelRegister("bJSM1", function(module, exports) {

$parcel$export(module.exports, "BufferedReadableStream", () => $88be62932bb485b5$export$4bc5733dbde37c71);
parcelRequire("hr1EK");
var $70dme = parcelRequire("70dme");

var $fnPEF = parcelRequire("fnPEF");
const $88be62932bb485b5$var$NOOP = ()=>{
// no-op
};
class $88be62932bb485b5$export$4bc5733dbde37c71 {
    #buffered;
    #bufferedOffset = 0;
    #bufferedLength = 0;
    #position = 0;
    get position() {
        return this.#position;
    }
    stream;
    reader;
    constructor(stream){
        this.stream = stream;
        this.reader = stream.getReader();
    }
    async #readSource() {
        const { done: done, value: value } = await this.reader.read();
        if (done) throw new (0, $70dme.ExactReadableEndedError)();
        return value;
    }
    async #readAsync(length, initial) {
        let result;
        let index;
        if (initial) {
            result = new Uint8Array(length);
            result.set(initial);
            index = initial.length;
            length -= initial.length;
        } else {
            const array = await this.#readSource();
            if (array.length === length) {
                this.#position += length;
                return array;
            }
            if (array.length > length) {
                this.#buffered = array;
                this.#bufferedOffset = length;
                this.#bufferedLength = array.length - length;
                this.#position += length;
                return array.subarray(0, length);
            }
            result = new Uint8Array(length);
            result.set(array);
            index = array.length;
            length -= array.length;
            this.#position += array.length;
        }
        while(length > 0){
            const array = await this.#readSource();
            if (array.length === length) {
                result.set(array, index);
                this.#position += length;
                return result;
            }
            if (array.length > length) {
                this.#buffered = array;
                this.#bufferedOffset = length;
                this.#bufferedLength = array.length - length;
                result.set(array.subarray(0, length), index);
                this.#position += length;
                return result;
            }
            result.set(array, index);
            index += array.length;
            length -= array.length;
            this.#position += array.length;
        }
        return result;
    }
    /**
     *
     * @param length
     * @returns
     */ readExactly(length) {
        // PERF: Add a synchronous path for reading from internal buffer
        if (this.#buffered) {
            const array = this.#buffered;
            const offset = this.#bufferedOffset;
            if (this.#bufferedLength > length) {
                // PERF: `subarray` is slow
                // don't use it until absolutely necessary
                this.#bufferedOffset += length;
                this.#bufferedLength -= length;
                this.#position += length;
                return array.subarray(offset, offset + length);
            }
            this.#buffered = undefined;
            this.#bufferedLength = 0;
            this.#bufferedOffset = 0;
            this.#position += array.length - offset;
            return this.#readAsync(length, array.subarray(offset));
        }
        return this.#readAsync(length);
    }
    /**
     * Return a readable stream with unconsumed data (if any) and
     * all data from the wrapped stream.
     * @returns A `ReadableStream`
     */ release() {
        if (this.#bufferedLength > 0) return new (0, $fnPEF.PushReadableStream)(async (controller)=>{
            // Put the remaining data back to the stream
            const buffered = this.#buffered.subarray(this.#bufferedOffset);
            await controller.enqueue(buffered);
            controller.abortSignal.addEventListener("abort", ()=>{
                // NOOP: the reader might already be released
                this.reader.cancel().catch($88be62932bb485b5$var$NOOP);
            });
            // Manually pipe the stream
            while(true){
                const { done: done, value: value } = await this.reader.read();
                if (done) return;
                else await controller.enqueue(value);
            }
        });
        else {
            // Simply release the reader and return the stream
            this.reader.releaseLock();
            return this.stream;
        }
    }
    async cancel(reason) {
        await this.reader.cancel(reason);
    }
}

});
parcelRegister("fnPEF", function(module, exports) {

$parcel$export(module.exports, "PushReadableStream", () => $b3311298c0c6568c$export$bcc01621d2cdbb44);
parcelRequire("kV55x");
var $aHKds = parcelRequire("aHKds");

var $6NYMu = parcelRequire("6NYMu");
class $b3311298c0c6568c$export$bcc01621d2cdbb44 extends (0, $6NYMu.ReadableStream) {
    #zeroHighWaterMarkAllowEnqueue = false;
    /**
     * Create a new `PushReadableStream` from a source.
     *
     * @param source If `source` returns a `Promise`, the stream will be closed
     * when the `Promise` is resolved, and be errored when the `Promise` is rejected.
     * @param strategy
     */ constructor(source, strategy){
        let waterMarkLow;
        const abortController = new (0, $6NYMu.AbortController)();
        super({
            start: async (controller)=>{
                await Promise.resolve();
                const result = source({
                    abortSignal: abortController.signal,
                    enqueue: async (chunk)=>{
                        if (abortController.signal.aborted) // If the stream is already cancelled,
                        // throw immediately.
                        throw abortController.signal.reason;
                        if (controller.desiredSize === null) {
                            // `desiredSize` being `null` means the stream is in error state,
                            // `controller.enqueue` will throw an error for us.
                            controller.enqueue(chunk);
                            return;
                        }
                        if (this.#zeroHighWaterMarkAllowEnqueue) {
                            this.#zeroHighWaterMarkAllowEnqueue = false;
                            controller.enqueue(chunk);
                            return;
                        }
                        if (controller.desiredSize <= 0) {
                            waterMarkLow = new (0, $aHKds.PromiseResolver)();
                            await waterMarkLow.promise;
                        }
                        // `controller.enqueue` will throw error for us
                        // if the stream is already errored.
                        controller.enqueue(chunk);
                    },
                    close () {
                        controller.close();
                    },
                    error (e) {
                        controller.error(e);
                    }
                });
                if (result && "then" in result) result.then(()=>{
                    try {
                        controller.close();
                    } catch (e) {
                    // controller already closed
                    }
                }, (e)=>{
                    controller.error(e);
                });
            },
            pull: ()=>{
                if (waterMarkLow) {
                    waterMarkLow.resolve();
                    return;
                }
                if (strategy?.highWaterMark === 0) this.#zeroHighWaterMarkAllowEnqueue = true;
            },
            cancel: (reason)=>{
                abortController.abort(reason);
                waterMarkLow?.reject(reason);
            }
        }, strategy);
    }
}

});
parcelRegister("kV55x", function(module, exports) {
$parcel$export(module.exports, "AsyncOperationManager", () => (parcelRequire("1PmPk")).AsyncOperationManager);
$parcel$export(module.exports, "delay", () => (parcelRequire("5OCzC")).delay);
$parcel$export(module.exports, "PromiseResolver", () => (parcelRequire("aHKds")).PromiseResolver);
parcelRequire("1PmPk");
parcelRequire("5OCzC");
parcelRequire("aHKds");

});
parcelRegister("1PmPk", function(module, exports) {

$parcel$export(module.exports, "AsyncOperationManager", () => $154c42d422606d92$export$10a4a5aeec48d07);

var $aHKds = parcelRequire("aHKds");
var $154c42d422606d92$export$10a4a5aeec48d07 = function() {
    function AsyncOperationManager(startId) {
        if (startId === void 0) startId = 0;
        this.pendingResolvers = new Map();
        this.nextId = startId;
    }
    AsyncOperationManager.prototype.add = function() {
        var id = this.nextId++;
        var resolver = new (0, $aHKds.PromiseResolver)();
        this.pendingResolvers.set(id, resolver);
        return [
            id,
            resolver.promise
        ];
    };
    AsyncOperationManager.prototype.getResolver = function(id) {
        if (!this.pendingResolvers.has(id)) return null;
        var resolver = this.pendingResolvers.get(id);
        this.pendingResolvers.delete(id);
        return resolver;
    };
    AsyncOperationManager.prototype.resolve = function(id, result) {
        var resolver = this.getResolver(id);
        if (resolver !== null) {
            resolver.resolve(result);
            return true;
        }
        return false;
    };
    AsyncOperationManager.prototype.reject = function(id, reason) {
        var resolver = this.getResolver(id);
        if (resolver !== null) {
            resolver.reject(reason);
            return true;
        }
        return false;
    };
    return AsyncOperationManager;
}();

});
parcelRegister("aHKds", function(module, exports) {

$parcel$export(module.exports, "PromiseResolver", () => $7cb1c50efa1262d9$export$b523a6f1f39bfd1e);
var $7cb1c50efa1262d9$export$b523a6f1f39bfd1e = function() {
    function PromiseResolver() {
        var _this = this;
        this._state = "running";
        this.resolve = function(value) {
            _this._resolve(value);
            _this._state = "resolved";
        };
        this.reject = function(reason) {
            _this._reject(reason);
            _this._state = "rejected";
        };
        this._promise = new Promise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
    }
    Object.defineProperty(PromiseResolver.prototype, "promise", {
        get: function() {
            return this._promise;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromiseResolver.prototype, "state", {
        get: function() {
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    return PromiseResolver;
}();

});


parcelRegister("5OCzC", function(module, exports) {

$parcel$export(module.exports, "delay", () => $43bf8b277380453a$export$1391212d75b2ee65);
function $43bf8b277380453a$export$1391212d75b2ee65(time) {
    return new Promise(function(resolve) {
        globalThis.setTimeout(function() {
            return resolve();
        }, time);
    });
}

});


parcelRegister("6NYMu", function(module, exports) {

$parcel$export(module.exports, "AbortController", () => $4f46778d30aae90e$export$48f7e099c149af88);
$parcel$export(module.exports, "ReadableStream", () => $4f46778d30aae90e$export$5d3e1e5268af5f76);
$parcel$export(module.exports, "WritableStream", () => $4f46778d30aae90e$export$826849241f7970f8);
$parcel$export(module.exports, "TransformStream", () => $4f46778d30aae90e$export$d102341634899398);
parcelRequire("lAXwl");
const $4f46778d30aae90e$var$Global = globalThis;
const $4f46778d30aae90e$export$48f7e099c149af88 = $4f46778d30aae90e$var$Global.AbortController;
const $4f46778d30aae90e$export$5d3e1e5268af5f76 = $4f46778d30aae90e$var$Global.ReadableStream;
const $4f46778d30aae90e$export$826849241f7970f8 = $4f46778d30aae90e$var$Global.WritableStream;
const $4f46778d30aae90e$export$d102341634899398 = $4f46778d30aae90e$var$Global.TransformStream;

});
parcelRegister("lAXwl", function(module, exports) {
/// <reference lib="es2018.asynciterable" />

});





parcelRegister("k61Wg", function(module, exports) {

$parcel$export(module.exports, "ConcatStringStream", () => $ea15df33799cd8f3$export$b6b7c3423a277d10);
parcelRequire("kV55x");
var $aHKds = parcelRequire("aHKds");
parcelRequire("hr1EK");
var $j4unN = parcelRequire("j4unN");

var $6NYMu = parcelRequire("6NYMu");
class $ea15df33799cd8f3$export$b6b7c3423a277d10 {
    // PERF: rope (concat strings) is faster than `[].join('')`
    #result = "";
    #resolver = new (0, $aHKds.PromiseResolver)();
    #writable = new (0, $6NYMu.WritableStream)({
        write: (chunk)=>{
            this.#result += chunk;
        },
        close: ()=>{
            this.#resolver.resolve(this.#result);
            this.#readableController.enqueue(this.#result);
            this.#readableController.close();
        },
        abort: (reason)=>{
            this.#resolver.reject(reason);
            this.#readableController.error(reason);
        }
    });
    get writable() {
        return this.#writable;
    }
    #readableController;
    #readable = new (0, $6NYMu.ReadableStream)({
        start: (controller)=>{
            this.#readableController = controller;
        }
    });
    get readable() {
        return this.#readable;
    }
    constructor(){
        Object.defineProperties(this.#readable, {
            then: {
                get: ()=>this.#resolver.promise.then.bind(this.#resolver.promise)
            },
            catch: {
                get: ()=>this.#resolver.promise.catch.bind(this.#resolver.promise)
            },
            finally: {
                get: ()=>this.#resolver.promise.finally.bind(this.#resolver.promise)
            }
        });
    }
}
class $ea15df33799cd8f3$export$f841ccdf11436336 {
    #segments = [];
    #resolver = new (0, $aHKds.PromiseResolver)();
    #writable = new (0, $6NYMu.WritableStream)({
        write: (chunk)=>{
            this.#segments.push(chunk);
        },
        close: ()=>{
            let result;
            let offset = 0;
            switch(this.#segments.length){
                case 0:
                    result = (0, $j4unN.EMPTY_UINT8_ARRAY);
                    break;
                case 1:
                    result = this.#segments[0];
                    break;
                default:
                    result = new Uint8Array(this.#segments.reduce((prev, item)=>prev + item.length, 0));
                    for (const segment of this.#segments){
                        result.set(segment, offset);
                        offset += segment.length;
                    }
                    break;
            }
            this.#resolver.resolve(result);
            this.#readableController.enqueue(result);
            this.#readableController.close();
        },
        abort: (reason)=>{
            this.#resolver.reject(reason);
            this.#readableController.error(reason);
        }
    });
    get writable() {
        return this.#writable;
    }
    #readableController;
    #readable = new (0, $6NYMu.ReadableStream)({
        start: (controller)=>{
            this.#readableController = controller;
        }
    });
    get readable() {
        return this.#readable;
    }
    constructor(){
        Object.defineProperties(this.#readable, {
            then: {
                get: ()=>this.#resolver.promise.then.bind(this.#resolver.promise)
            },
            catch: {
                get: ()=>this.#resolver.promise.catch.bind(this.#resolver.promise)
            },
            finally: {
                get: ()=>this.#resolver.promise.finally.bind(this.#resolver.promise)
            }
        });
    }
}

});

parcelRegister("5Ywqs", function(module, exports) {

$parcel$export(module.exports, "Consumable", () => $459bb56e0b905665$export$888324e445e7ab42);
parcelRequire("kV55x");
var $aHKds = parcelRequire("aHKds");

var $6NYMu = parcelRequire("6NYMu");

var $cilb9 = parcelRequire("cilb9");
function $459bb56e0b905665$var$isPromiseLike(value) {
    return typeof value === "object" && value !== null && "then" in value;
}
class $459bb56e0b905665$export$888324e445e7ab42 {
    #task;
    #resolver;
    value;
    consumed;
    constructor(value){
        this.#task = (0, $cilb9.createTask)("Consumable");
        this.value = value;
        this.#resolver = new (0, $aHKds.PromiseResolver)();
        this.consumed = this.#resolver.promise;
    }
    consume() {
        this.#resolver.resolve();
    }
    error(error) {
        this.#resolver.reject(error);
    }
    tryConsume(callback) {
        try {
            let result = this.#task.run(()=>callback(this.value));
            if ($459bb56e0b905665$var$isPromiseLike(result)) result = result.then((value)=>{
                this.#resolver.resolve();
                return value;
            }, (e)=>{
                this.#resolver.reject(e);
                throw e;
            });
            else this.#resolver.resolve();
            return result;
        } catch (e) {
            this.#resolver.reject(e);
            throw e;
        }
    }
}
(function(Consumable) {
    class WritableStream extends (0, $6NYMu.WritableStream) {
        static async write(writer, value) {
            const consumable = new Consumable(value);
            await writer.write(consumable);
            await consumable.consumed;
        }
        constructor(sink, strategy){
            let wrappedStrategy;
            if (strategy) {
                wrappedStrategy = {};
                if ("highWaterMark" in strategy) wrappedStrategy.highWaterMark = strategy.highWaterMark;
                if ("size" in strategy) wrappedStrategy.size = (chunk)=>{
                    return strategy.size(chunk instanceof Consumable ? chunk.value : chunk);
                };
            }
            super({
                start (controller) {
                    return sink.start?.(controller);
                },
                async write (chunk, controller) {
                    await chunk.tryConsume((chunk)=>sink.write?.(chunk, controller));
                },
                abort (reason) {
                    return sink.abort?.(reason);
                },
                close () {
                    return sink.close?.();
                }
            }, wrappedStrategy);
        }
    }
    Consumable.WritableStream = WritableStream;
    class ReadableStream extends (0, $6NYMu.ReadableStream) {
        static async enqueue(controller, chunk) {
            const output = new Consumable(chunk);
            controller.enqueue(output);
            await output.consumed;
        }
        constructor(source, strategy){
            let wrappedController;
            let wrappedStrategy;
            if (strategy) {
                wrappedStrategy = {};
                if ("highWaterMark" in strategy) wrappedStrategy.highWaterMark = strategy.highWaterMark;
                if ("size" in strategy) wrappedStrategy.size = (chunk)=>{
                    return strategy.size(chunk.value);
                };
            }
            super({
                async start (controller) {
                    wrappedController = {
                        async enqueue (chunk) {
                            await ReadableStream.enqueue(controller, chunk);
                        },
                        close () {
                            controller.close();
                        },
                        error (reason) {
                            controller.error(reason);
                        }
                    };
                    await source.start?.(wrappedController);
                },
                async pull () {
                    await source.pull?.(wrappedController);
                },
                async cancel (reason) {
                    await source.cancel?.(reason);
                }
            }, wrappedStrategy);
        }
    }
    Consumable.ReadableStream = ReadableStream;
})($459bb56e0b905665$export$888324e445e7ab42 || ($459bb56e0b905665$export$888324e445e7ab42 = {}));

});
parcelRegister("cilb9", function(module, exports) {

$parcel$export(module.exports, "createTask", () => $8f3798290ba6e406$export$f7292ab7796be73c);
// `createTask` allows browser DevTools to track the call stack across async boundaries.
const { console: $8f3798290ba6e406$var$console } = globalThis;
const $8f3798290ba6e406$export$f7292ab7796be73c = $8f3798290ba6e406$var$console?.createTask?.bind($8f3798290ba6e406$var$console) ?? (()=>({
        run (callback) {
            return callback();
        }
    }));

});


parcelRegister("b5TnZ", function(module, exports) {

$parcel$export(module.exports, "BufferCombiner", () => $813b1fd2092db7cf$export$b30c524a58e8458c);
$parcel$export(module.exports, "DistributionStream", () => $813b1fd2092db7cf$export$feca7eb4e486f5cf);

var $5Ywqs = parcelRequire("5Ywqs");

var $jEctC = parcelRequire("jEctC");

var $6NYMu = parcelRequire("6NYMu");
class $813b1fd2092db7cf$export$b30c524a58e8458c {
    #capacity;
    #buffer;
    #offset;
    #available;
    constructor(size){
        this.#capacity = size;
        this.#buffer = new Uint8Array(size);
        this.#offset = 0;
        this.#available = size;
    }
    /**
     * Pushes data to the combiner.
     * @param data The input data to be split or combined.
     * @returns
     * A generator that yields buffers of specified size.
     * It may yield the same buffer multiple times, consume the data before calling `next`.
     */ *push(data) {
        let offset = 0;
        let available = data.length;
        if (this.#offset !== 0) {
            if (available >= this.#available) {
                this.#buffer.set(data.subarray(0, this.#available), this.#offset);
                offset += this.#available;
                available -= this.#available;
                yield this.#buffer;
                this.#offset = 0;
                this.#available = this.#capacity;
                if (available === 0) return;
            } else {
                this.#buffer.set(data, this.#offset);
                this.#offset += available;
                this.#available -= available;
                return;
            }
        }
        while(available >= this.#capacity){
            const end = offset + this.#capacity;
            yield data.subarray(offset, end);
            offset = end;
            available -= this.#capacity;
        }
        if (available > 0) {
            this.#buffer.set(data.subarray(offset), this.#offset);
            this.#offset += available;
            this.#available -= available;
        }
    }
    flush() {
        if (this.#offset === 0) return undefined;
        const output = this.#buffer.subarray(0, this.#offset);
        this.#offset = 0;
        this.#available = this.#capacity;
        return output;
    }
}
class $813b1fd2092db7cf$export$feca7eb4e486f5cf extends (0, $6NYMu.TransformStream) {
    constructor(size, combine = false){
        const combiner = combine ? new $813b1fd2092db7cf$export$b30c524a58e8458c(size) : undefined;
        super({
            async transform (chunk, controller) {
                await (0, $jEctC.MaybeConsumable).tryConsume(chunk, async (chunk)=>{
                    if (combiner) for (const buffer of combiner.push(chunk))await (0, $5Ywqs.Consumable).ReadableStream.enqueue(controller, buffer);
                    else {
                        let offset = 0;
                        let available = chunk.length;
                        while(available > 0){
                            const end = offset + size;
                            await (0, $5Ywqs.Consumable).ReadableStream.enqueue(controller, chunk.subarray(offset, end));
                            offset = end;
                            available -= size;
                        }
                    }
                });
            },
            flush (controller) {
                if (combiner) {
                    const data = combiner.flush();
                    if (data) controller.enqueue(data);
                }
            }
        });
    }
}

});
parcelRegister("jEctC", function(module, exports) {

$parcel$export(module.exports, "MaybeConsumable", () => $e4db6e59fbae8999$export$544160f784d9074);

var $5Ywqs = parcelRequire("5Ywqs");

var $6NYMu = parcelRequire("6NYMu");
var $e4db6e59fbae8999$export$544160f784d9074;
(function(MaybeConsumable) {
    function getValue(value) {
        return value instanceof (0, $5Ywqs.Consumable) ? value.value : value;
    }
    MaybeConsumable.getValue = getValue;
    function tryConsume(value, callback) {
        if (value instanceof (0, $5Ywqs.Consumable)) return value.tryConsume(callback);
        else return callback(value);
    }
    MaybeConsumable.tryConsume = tryConsume;
    class UnwrapStream extends (0, $6NYMu.TransformStream) {
        constructor(){
            super({
                transform (chunk, controller) {
                    MaybeConsumable.tryConsume(chunk, (chunk)=>{
                        controller.enqueue(chunk);
                    });
                }
            });
        }
    }
    MaybeConsumable.UnwrapStream = UnwrapStream;
    class WritableStream extends (0, $6NYMu.WritableStream) {
        constructor(sink, strategy){
            let wrappedStrategy;
            if (strategy) {
                wrappedStrategy = {};
                if ("highWaterMark" in strategy) wrappedStrategy.highWaterMark = strategy.highWaterMark;
                if ("size" in strategy) wrappedStrategy.size = (chunk)=>{
                    return strategy.size(chunk instanceof (0, $5Ywqs.Consumable) ? chunk.value : chunk);
                };
            }
            super({
                start (controller) {
                    return sink.start?.(controller);
                },
                async write (chunk, controller) {
                    await MaybeConsumable.tryConsume(chunk, (chunk)=>sink.write?.(chunk, controller));
                },
                abort (reason) {
                    return sink.abort?.(reason);
                },
                close () {
                    return sink.close?.();
                }
            }, wrappedStrategy);
        }
    }
    MaybeConsumable.WritableStream = WritableStream;
})($e4db6e59fbae8999$export$544160f784d9074 || ($e4db6e59fbae8999$export$544160f784d9074 = {}));

});


parcelRegister("bwQFm", function(module, exports) {

$parcel$export(module.exports, "DuplexStreamFactory", () => $864b8946dafa2700$export$98fb3f973b596bf2);
parcelRequire("kV55x");
var $aHKds = parcelRequire("aHKds");

var $6NYMu = parcelRequire("6NYMu");

var $cSu3L = parcelRequire("cSu3L");
const $864b8946dafa2700$var$NOOP = ()=>{
// no-op
};
class $864b8946dafa2700$export$98fb3f973b596bf2 {
    #readableControllers = [];
    #writers = [];
    #writableClosed = false;
    get writableClosed() {
        return this.#writableClosed;
    }
    #closed = new (0, $aHKds.PromiseResolver)();
    get closed() {
        return this.#closed.promise;
    }
    #options;
    constructor(options){
        this.#options = options ?? {};
    }
    wrapReadable(readable, strategy) {
        return new (0, $cSu3L.WrapReadableStream)({
            start: (controller)=>{
                this.#readableControllers.push(controller);
                return readable;
            },
            cancel: async ()=>{
                // cancel means the local peer wants to close the connection.
                await this.close();
            },
            close: async ()=>{
                // stream end means the remote peer closed the connection first.
                await this.dispose();
            }
        }, strategy);
    }
    createWritable(stream) {
        const writer = stream.getWriter();
        this.#writers.push(writer);
        // `WritableStream` has no way to tell if the remote peer has closed the connection.
        // So it only triggers `close`.
        return new (0, $6NYMu.WritableStream)({
            write: async (chunk)=>{
                await writer.write(chunk);
            },
            abort: async (reason)=>{
                await writer.abort(reason);
                await this.close();
            },
            close: async ()=>{
                // NOOP: the writer is already closed
                await writer.close().catch($864b8946dafa2700$var$NOOP);
                await this.close();
            }
        });
    }
    async close() {
        if (this.#writableClosed) return;
        this.#writableClosed = true;
        // Call `close` first, so it can still write data to `WritableStream`s.
        if (await this.#options.close?.() !== false) // `close` can return `false` to disable automatic `dispose`.
        await this.dispose();
        for (const writer of this.#writers)// NOOP: the writer is already closed
        writer.close().catch($864b8946dafa2700$var$NOOP);
    }
    async dispose() {
        this.#writableClosed = true;
        this.#closed.resolve();
        for (const controller of this.#readableControllers)try {
            controller.close();
        } catch  {
        // ignore
        }
        await this.#options.dispose?.();
    }
}

});
parcelRegister("cSu3L", function(module, exports) {

$parcel$export(module.exports, "WrapReadableStream", () => $9601d8647e507a4c$export$85a7b9d088379e9e);

var $6NYMu = parcelRequire("6NYMu");
function $9601d8647e507a4c$var$getWrappedReadableStream(wrapper, controller) {
    if ("start" in wrapper) return wrapper.start(controller);
    else if (typeof wrapper === "function") return wrapper(controller);
    else // Can't use `wrapper instanceof ReadableStream`
    // Because we want to be compatible with any ReadableStream-like objects
    return wrapper;
}
class $9601d8647e507a4c$export$85a7b9d088379e9e extends (0, $6NYMu.ReadableStream) {
    readable;
    #reader;
    constructor(wrapper, strategy){
        super({
            start: async (controller)=>{
                // `start` is invoked before `ReadableStream`'s constructor finish,
                // so using `this` synchronously causes
                // "Must call super constructor in derived class before accessing 'this' or returning from derived constructor".
                // Queue a microtask to avoid this.
                await Promise.resolve();
                this.readable = await $9601d8647e507a4c$var$getWrappedReadableStream(wrapper, controller);
                this.#reader = this.readable.getReader();
            },
            pull: async (controller)=>{
                const result = await this.#reader.read();
                if (result.done) {
                    controller.close();
                    if ("close" in wrapper) await wrapper.close?.();
                } else controller.enqueue(result.value);
            },
            cancel: async (reason)=>{
                await this.#reader.cancel(reason);
                if ("cancel" in wrapper) await wrapper.cancel?.(reason);
            }
        }, strategy);
    }
}

});


parcelRegister("koQVx", function(module, exports) {

$parcel$export(module.exports, "TextDecoderStream", () => $ed9f1ac4caa555e8$export$a47f15ea2f3a718a);
const $ed9f1ac4caa555e8$var$Global = globalThis;
const $ed9f1ac4caa555e8$export$a47f15ea2f3a718a = $ed9f1ac4caa555e8$var$Global.TextDecoderStream;
const $ed9f1ac4caa555e8$export$d6af92c119329dd1 = $ed9f1ac4caa555e8$var$Global.TextEncoderStream;

});

parcelRegister("4eHDJ", function(module, exports) {

var $6NYMu = parcelRequire("6NYMu");
class $315a522dec2122a9$export$4ebc589aac5c3f5f extends (0, $6NYMu.TransformStream) {
    constructor(callback){
        super({
            transform (chunk, controller) {
                callback(chunk);
                controller.enqueue(chunk);
            }
        });
    }
}

});

parcelRegister("3Ppgt", function(module, exports) {

$parcel$export(module.exports, "pipeFrom", () => $2c99bb95550a3c12$export$d407da7ebfa84417);

var $6NYMu = parcelRequire("6NYMu");
function $2c99bb95550a3c12$export$d407da7ebfa84417(writable, pair) {
    const writer = pair.writable.getWriter();
    const pipe = pair.readable.pipeTo(writable);
    return new (0, $6NYMu.WritableStream)({
        async write (chunk) {
            await writer.write(chunk);
        },
        async close () {
            await writer.close();
            await pipe;
        }
    });
}

});

parcelRegister("jbstH", function(module, exports) {

var $6NYMu = parcelRequire("6NYMu");
function* $df75228a7787164b$var$split(input, separator) {
    let start = 0;
    while(true){
        const index = input.indexOf(separator, start);
        if (index === -1) return;
        const part = input.substring(start, index);
        yield part;
        start = index + 1;
    }
}
class $df75228a7787164b$export$6ff6004bc16f7ed4 extends (0, $6NYMu.TransformStream) {
    constructor(separator){
        super({
            transform (chunk, controller) {
                for (const part of $df75228a7787164b$var$split(chunk, separator))controller.enqueue(part);
            }
        });
    }
}

});

parcelRegister("ebpYL", function(module, exports) {

$parcel$export(module.exports, "StructDeserializeStream", () => $a5363ea64eecd913$export$e8da4e75be156fae);

var $1QeNb = parcelRequire("1QeNb");
class $a5363ea64eecd913$export$e8da4e75be156fae extends (0, $1QeNb.BufferedTransformStream) {
    constructor(struct){
        super((stream)=>{
            return struct.deserialize(stream);
        });
    }
}

});

parcelRegister("1yRYZ", function(module, exports) {

var $6NYMu = parcelRequire("6NYMu");
class $1232d747f46baf59$export$783a776b9d0340da extends (0, $6NYMu.TransformStream) {
    constructor(struct){
        super({
            transform (chunk, controller) {
                controller.enqueue(struct.serialize(chunk));
            }
        });
    }
}

});

parcelRegister("67qk3", function(module, exports) {

$parcel$export(module.exports, "WrapWritableStream", () => $4747d098e697958e$export$98b7c608564c82c4);

var $6NYMu = parcelRequire("6NYMu");
async function $4747d098e697958e$var$getWrappedWritableStream(start) {
    if ("start" in start) return await start.start();
    else if (typeof start === "function") return await start();
    else // Can't use `wrapper instanceof WritableStream`
    // Because we want to be compatible with any WritableStream-like objects
    return start;
}
class $4747d098e697958e$export$98b7c608564c82c4 extends (0, $6NYMu.WritableStream) {
    writable;
    #writer;
    constructor(start){
        super({
            start: async ()=>{
                // `start` is invoked before `ReadableStream`'s constructor finish,
                // so using `this` synchronously causes
                // "Must call super constructor in derived class before accessing 'this' or returning from derived constructor".
                // Queue a microtask to avoid this.
                await Promise.resolve();
                this.writable = await $4747d098e697958e$var$getWrappedWritableStream(start);
                this.#writer = this.writable.getWriter();
            },
            write: async (chunk)=>{
                await this.#writer.write(chunk);
            },
            abort: async (reason)=>{
                await this.#writer.abort(reason);
                if (start !== this.writable && "close" in start) await start.close?.();
            },
            close: async ()=>{
                // Close the inner stream first.
                // Usually the inner stream is a logical sub-stream over the outer stream,
                // closing the outer stream first will make the inner stream incapable of
                // sending data in its `close` handler.
                await this.#writer.close();
                if (start !== this.writable && "close" in start) await start.close?.();
            }
        });
    }
    bePipedThroughFrom(transformer) {
        let promise;
        return new $4747d098e697958e$export$98b7c608564c82c4({
            start: ()=>{
                promise = transformer.readable.pipeTo(this);
                return transformer.writable;
            },
            async close () {
                await promise;
            }
        });
    }
}

});


parcelRegister("chJ24", function(module, exports) {
$parcel$export(module.exports, "framebuffer", () => (parcelRequire("755W6")).framebuffer);
$parcel$export(module.exports, "AdbPower", () => (parcelRequire("5WSZn")).AdbPower);
$parcel$export(module.exports, "AdbReverseCommand", () => (parcelRequire("gequt")).AdbReverseCommand);
$parcel$export(module.exports, "AdbSubprocess", () => (parcelRequire("5jHg5")).AdbSubprocess);
$parcel$export(module.exports, "AdbSubprocessShellProtocol", () => (parcelRequire("23OH0")).AdbSubprocessShellProtocol);
$parcel$export(module.exports, "escapeArg", () => (parcelRequire("beA73")).escapeArg);
$parcel$export(module.exports, "AdbSync", () => (parcelRequire("aBc50")).AdbSync);
$parcel$export(module.exports, "AdbTcpIpCommand", () => (parcelRequire("liel6")).AdbTcpIpCommand);
parcelRequire("2TOFC");
parcelRequire("755W6");
parcelRequire("5WSZn");
parcelRequire("gequt");
parcelRequire("ezTiR");
parcelRequire("3HODG");
parcelRequire("liel6");

});
parcelRegister("2TOFC", function(module, exports) {

$parcel$export(module.exports, "AdbCommandBase", () => $21c805dd93e00cd7$export$6c55dba0cc5f72fb);
parcelRequire("hpom2");
var $aGQPd = parcelRequire("aGQPd");
class $21c805dd93e00cd7$export$6c55dba0cc5f72fb extends (0, $aGQPd.AutoDisposable) {
    adb;
    constructor(adb){
        super();
        this.adb = adb;
    }
}

});
parcelRegister("hpom2", function(module, exports) {
$parcel$export(module.exports, "AutoDisposable", () => (parcelRequire("aGQPd")).AutoDisposable);
parcelRequire("aGQPd");
parcelRequire("67ny9");
parcelRequire("lreyP");
parcelRequire("5oa12");

});
parcelRegister("aGQPd", function(module, exports) {

$parcel$export(module.exports, "AutoDisposable", () => $7c86cd92403ce500$export$a22a94f7d5cef8d5);
class $7c86cd92403ce500$export$a22a94f7d5cef8d5 {
    #disposables = [];
    constructor(){
        this.dispose = this.dispose.bind(this);
    }
    addDisposable(disposable) {
        this.#disposables.push(disposable);
        return disposable;
    }
    dispose() {
        for (const disposable of this.#disposables)disposable.dispose();
        this.#disposables = [];
    }
}
class $7c86cd92403ce500$export$d6ed760be7336d34 extends $7c86cd92403ce500$export$a22a94f7d5cef8d5 {
    add(disposable) {
        return this.addDisposable(disposable);
    }
}

});

parcelRegister("67ny9", function(module, exports) {

});

parcelRegister("lreyP", function(module, exports) {
class $f9b76a0a34481251$export$4fae95256245c8c0 {
    listeners = [];
    constructor(){
        this.event = this.event.bind(this);
    }
    addEventListener(info) {
        this.listeners.push(info);
        const remove = ()=>{
            const index = this.listeners.indexOf(info);
            if (index !== -1) this.listeners.splice(index, 1);
        };
        remove.dispose = remove;
        return remove;
    }
    event = (listener, thisArg, ...args)=>{
        const info = {
            listener: listener,
            thisArg: thisArg,
            args: args
        };
        return this.addEventListener(info);
    };
    fire(e) {
        for (const info of this.listeners.slice())info.listener.apply(info.thisArg, [
            e,
            ...info.args
        ]);
    }
    dispose() {
        this.listeners.length = 0;
    }
}

});

parcelRegister("5oa12", function(module, exports) {
parcelRequire("kV55x");
var $aHKds = parcelRequire("aHKds");
async function $3ec6f68da26e5927$export$d2de3aaeafa91619(event) {
    const resolver = new (0, $aHKds.PromiseResolver)();
    const dispose = event(resolver.resolve);
    const result = await resolver.promise;
    dispose();
    return result;
}

});



parcelRegister("755W6", function(module, exports) {

$parcel$export(module.exports, "framebuffer", () => $527d9ad6cf7afd05$export$4ed6c7c560c63868);
parcelRequire("7edQJ");
var $bJSM1 = parcelRequire("bJSM1");
parcelRequire("hr1EK");
var $9LJSP = parcelRequire("9LJSP");
const $527d9ad6cf7afd05$var$Version = new (0, $9LJSP.Struct)({
    littleEndian: true
}).uint32("version");
const $527d9ad6cf7afd05$export$4c5fa6579699b052 = new (0, $9LJSP.Struct)({
    littleEndian: true
}).uint32("bpp").uint32("size").uint32("width").uint32("height").uint32("red_offset").uint32("red_length").uint32("blue_offset").uint32("blue_length").uint32("green_offset").uint32("green_length").uint32("alpha_offset").uint32("alpha_length").uint8Array("data", {
    lengthField: "size"
});
const $527d9ad6cf7afd05$export$d0bda24c79a1d603 = new (0, $9LJSP.Struct)({
    littleEndian: true
}).uint32("bpp").uint32("colorSpace").uint32("size").uint32("width").uint32("height").uint32("red_offset").uint32("red_length").uint32("blue_offset").uint32("blue_length").uint32("green_offset").uint32("green_length").uint32("alpha_offset").uint32("alpha_length").uint8Array("data", {
    lengthField: "size"
});
class $527d9ad6cf7afd05$export$31b42747346031c6 extends Error {
    constructor(message, options){
        super(message, options);
    }
}
class $527d9ad6cf7afd05$export$4fe684c7fc4bab42 extends $527d9ad6cf7afd05$export$31b42747346031c6 {
    constructor(version){
        super(`Unsupported FrameBuffer version ${version}`);
    }
}
class $527d9ad6cf7afd05$export$b1ac6f66a424282e extends $527d9ad6cf7afd05$export$31b42747346031c6 {
    constructor(){
        super("FrameBuffer is disabled by current app");
    }
}
async function $527d9ad6cf7afd05$export$4ed6c7c560c63868(adb) {
    const socket = await adb.createSocket("framebuffer:");
    const stream = new (0, $bJSM1.BufferedReadableStream)(socket.readable);
    let version;
    try {
        ({ version: version } = await $527d9ad6cf7afd05$var$Version.deserialize(stream));
    } catch (e) {
        if (e instanceof (0, $9LJSP.StructEmptyError)) throw new $527d9ad6cf7afd05$export$b1ac6f66a424282e();
        throw e;
    }
    switch(version){
        case 1:
            // TODO: AdbFrameBuffer: does all v1 responses uses the same color space? Add it so the command returns same format for all versions.
            return $527d9ad6cf7afd05$export$4c5fa6579699b052.deserialize(stream);
        case 2:
            return $527d9ad6cf7afd05$export$d0bda24c79a1d603.deserialize(stream);
        default:
            throw new $527d9ad6cf7afd05$export$4fe684c7fc4bab42(version);
    }
}

});

parcelRegister("5WSZn", function(module, exports) {

$parcel$export(module.exports, "AdbPower", () => $454d062a32aa0607$export$9b4dc8cf402dd991);
// cspell: ignore bootloader
// cspell: ignore fastboot
// cspell: ignore keyevent
// cspell: ignore longpress

var $2TOFC = parcelRequire("2TOFC");
class $454d062a32aa0607$export$9b4dc8cf402dd991 extends (0, $2TOFC.AdbCommandBase) {
    reboot(mode = "") {
        return this.adb.createSocketAndWait(`reboot:${mode}`);
    }
    bootloader() {
        return this.reboot("bootloader");
    }
    fastboot() {
        return this.reboot("fastboot");
    }
    recovery() {
        return this.reboot("recovery");
    }
    sideload() {
        return this.reboot("sideload");
    }
    /**
     * Reboot to Qualcomm Emergency Download (EDL) Mode.
     *
     * Only works on some Qualcomm devices.
     */ qualcommEdlMode() {
        return this.reboot("edl");
    }
    powerOff() {
        return this.adb.subprocess.spawnAndWaitLegacy([
            "reboot",
            "-p"
        ]);
    }
    powerButton(longPress = false) {
        const args = [
            "input",
            "keyevent"
        ];
        if (longPress) args.push("--longpress");
        args.push("POWER");
        return this.adb.subprocess.spawnAndWaitLegacy(args);
    }
    /**
     * Reboot to Samsung Odin download mode.
     *
     * Only works on Samsung devices.
     */ samsungOdin() {
        return this.reboot("download");
    }
}

});

parcelRegister("gequt", function(module, exports) {

$parcel$export(module.exports, "AdbReverseCommand", () => $bd12809a72d921e3$export$f48b52846b274f79);
// cspell: ignore killforward
parcelRequire("hpom2");
var $aGQPd = parcelRequire("aGQPd");
parcelRequire("7edQJ");
var $bJSM1 = parcelRequire("bJSM1");
parcelRequire("hr1EK");
var $9LJSP = parcelRequire("9LJSP");
var $6Savq = parcelRequire("6Savq");
var $70dme = parcelRequire("70dme");
parcelRequire("5lBQi");
var $32bmk = parcelRequire("32bmk");
var $gtlgZ = parcelRequire("gtlgZ");
const $bd12809a72d921e3$var$AdbReverseStringResponse = new (0, $9LJSP.Struct)().string("length", {
    length: 4
}).string("content", {
    lengthField: "length",
    lengthFieldRadix: 16
});
class $bd12809a72d921e3$export$12a5efc419918650 extends Error {
    constructor(message){
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class $bd12809a72d921e3$export$ae7a90ef18b5896a extends $bd12809a72d921e3$export$12a5efc419918650 {
    constructor(){
        super("ADB reverse tunnel is not supported on this device when connected wirelessly.");
    }
}
const $bd12809a72d921e3$var$AdbReverseErrorResponse = new (0, $9LJSP.Struct)().concat($bd12809a72d921e3$var$AdbReverseStringResponse).postDeserialize((value)=>{
    // https://issuetracker.google.com/issues/37066218
    // ADB on Android <9 can't create reverse tunnels when connected wirelessly (ADB over Wi-Fi),
    // and returns this confusing "more than one device/emulator" error.
    if (value.content === "more than one device/emulator") throw new $bd12809a72d921e3$export$ae7a90ef18b5896a();
    else throw new $bd12809a72d921e3$export$12a5efc419918650(value.content);
});
// Like `hexToNumber`, it's much faster than first converting `buffer` to a string
function $bd12809a72d921e3$var$decimalToNumber(buffer) {
    let value = 0;
    for (const byte of buffer){
        // Like `parseInt`, return when it encounters a non-digit character
        if (byte < 48 || byte > 57) return value;
        value = value * 10 + byte - 48;
    }
    return value;
}
const $bd12809a72d921e3$var$OKAY = (0, $6Savq.encodeUtf8)("OKAY");
class $bd12809a72d921e3$export$f48b52846b274f79 extends (0, $aGQPd.AutoDisposable) {
    adb;
    #deviceAddressToLocalAddress = new Map();
    constructor(adb){
        super();
        this.adb = adb;
    }
    async createBufferedStream(service) {
        const socket = await this.adb.createSocket(service);
        return new (0, $bJSM1.BufferedReadableStream)(socket.readable);
    }
    async sendRequest(service) {
        const stream = await this.createBufferedStream(service);
        const response = await stream.readExactly(4);
        if (!(0, $gtlgZ.sequenceEqual)(response, $bd12809a72d921e3$var$OKAY)) await $bd12809a72d921e3$var$AdbReverseErrorResponse.deserialize(stream);
        return stream;
    }
    async list() {
        const stream = await this.createBufferedStream("reverse:list-forward");
        const response = await $bd12809a72d921e3$var$AdbReverseStringResponse.deserialize(stream);
        return response.content.split("\n").filter((line)=>!!line).map((line)=>{
            const [deviceSerial, localName, remoteName] = line.split(" ");
            return {
                deviceSerial: deviceSerial,
                localName: localName,
                remoteName: remoteName
            };
        });
    // No need to close the stream, device will close it
    }
    /**
     * Add an already existing reverse tunnel. Depends on the transport type, this may not do anything.
     * @param deviceAddress The address to be listened on device by ADB daemon. Or `tcp:0` to choose an available TCP port.
     * @param localAddress The address that listens on the local machine.
     * @returns `tcp:{ACTUAL_LISTENING_PORT}`, If `deviceAddress` is `tcp:0`; otherwise, `deviceAddress`.
     */ async addExternal(deviceAddress, localAddress) {
        const stream = await this.sendRequest(`reverse:forward:${deviceAddress};${localAddress}`);
        // `tcp:0` tells the device to pick an available port.
        // On Android >=8, device will respond with the selected port for all `tcp:` requests.
        if (deviceAddress.startsWith("tcp:")) {
            const position = stream.position;
            try {
                const length = (0, $32bmk.hexToNumber)(await stream.readExactly(4));
                const port = $bd12809a72d921e3$var$decimalToNumber(await stream.readExactly(length));
                deviceAddress = `tcp:${port}`;
            } catch (e) {
                if (e instanceof (0, $70dme.ExactReadableEndedError) && stream.position === position) ;
                else throw e;
            }
        }
        return deviceAddress;
    }
    /**
     * @param deviceAddress The address to be listened on device by ADB daemon. Or `tcp:0` to choose an available TCP port.
     * @param handler A callback to handle incoming connections.
     * @param localAddressThe The address that listens on the local machine. May be `undefined` to let the transport choose an appropriate one.
     * @returns `tcp:{ACTUAL_LISTENING_PORT}`, If `deviceAddress` is `tcp:0`; otherwise, `deviceAddress`.
     * @throws {AdbReverseNotSupportedError} If ADB reverse tunnel is not supported on this device when connected wirelessly.
     * @throws {AdbReverseError} If ADB daemon returns an error.
     */ async add(deviceAddress, handler, localAddress) {
        localAddress = await this.adb.transport.addReverseTunnel(handler, localAddress);
        try {
            deviceAddress = await this.addExternal(deviceAddress, localAddress);
            this.#deviceAddressToLocalAddress.set(deviceAddress, localAddress);
            return deviceAddress;
        } catch (e) {
            await this.adb.transport.removeReverseTunnel(localAddress);
            throw e;
        }
    }
    async remove(deviceAddress) {
        const localAddress = this.#deviceAddressToLocalAddress.get(deviceAddress);
        if (localAddress) await this.adb.transport.removeReverseTunnel(localAddress);
        await this.sendRequest(`reverse:killforward:${deviceAddress}`);
    // No need to close the stream, device will close it
    }
    async removeAll() {
        await this.adb.transport.clearReverseTunnels();
        this.#deviceAddressToLocalAddress.clear();
        await this.sendRequest(`reverse:killforward-all`);
    // No need to close the stream, device will close it
    }
}

});
parcelRegister("5lBQi", function(module, exports) {
$parcel$export(module.exports, "AutoResetEvent", () => (parcelRequire("5SRHv")).AutoResetEvent);
$parcel$export(module.exports, "calculateBase64EncodedLength", () => (parcelRequire("2kccq")).calculateBase64EncodedLength);
$parcel$export(module.exports, "encodeBase64", () => (parcelRequire("2kccq")).encodeBase64);
$parcel$export(module.exports, "hexToNumber", () => (parcelRequire("32bmk")).hexToNumber);
$parcel$export(module.exports, "write4HexDigits", () => (parcelRequire("32bmk")).write4HexDigits);
$parcel$export(module.exports, "NOOP", () => (parcelRequire("fXuIk")).NOOP);
$parcel$export(module.exports, "unreachable", () => (parcelRequire("fXuIk")).unreachable);
$parcel$export(module.exports, "sequenceEqual", () => (parcelRequire("gtlgZ")).sequenceEqual);

$parcel$export(module.exports, "encodeUtf8", () => (parcelRequire("6Savq")).encodeUtf8);
parcelRequire("hr1EK");
var $6Savq = parcelRequire("6Savq");
parcelRequire("5SRHv");
parcelRequire("2kccq");
parcelRequire("32bmk");
parcelRequire("fXuIk");
parcelRequire("gtlgZ");

});
parcelRegister("5SRHv", function(module, exports) {

$parcel$export(module.exports, "AutoResetEvent", () => $448ba6c1507a4b6f$export$6c7050fcdf3fbd6b);
parcelRequire("kV55x");
var $aHKds = parcelRequire("aHKds");
class $448ba6c1507a4b6f$export$6c7050fcdf3fbd6b {
    #set;
    #queue = [];
    constructor(initialSet = false){
        this.#set = initialSet;
    }
    wait() {
        if (!this.#set) {
            this.#set = true;
            if (this.#queue.length === 0) return Promise.resolve();
        }
        const resolver = new (0, $aHKds.PromiseResolver)();
        this.#queue.push(resolver);
        return resolver.promise;
    }
    notifyOne() {
        if (this.#queue.length !== 0) this.#queue.pop().resolve();
        else this.#set = false;
    }
    dispose() {
        for (const item of this.#queue)item.reject(new Error("The AutoResetEvent has been disposed"));
        this.#queue.length = 0;
    }
}

});

parcelRegister("2kccq", function(module, exports) {

$parcel$export(module.exports, "calculateBase64EncodedLength", () => $1b16e9917870169f$export$9e6dcb9430409adb);
$parcel$export(module.exports, "encodeBase64", () => $1b16e9917870169f$export$8fb536984ec8b4d7);
// Array is faster than object literal or `Map`
const $1b16e9917870169f$var$charToIndex = [];
const $1b16e9917870169f$var$indexToChar = [];
const $1b16e9917870169f$var$paddingChar = "=".charCodeAt(0);
function $1b16e9917870169f$var$addRange(start, end) {
    const charCodeStart = start.charCodeAt(0);
    const charCodeEnd = end.charCodeAt(0);
    for(let charCode = charCodeStart; charCode <= charCodeEnd; charCode += 1){
        $1b16e9917870169f$var$charToIndex[charCode] = $1b16e9917870169f$var$indexToChar.length;
        $1b16e9917870169f$var$indexToChar.push(charCode);
    }
}
$1b16e9917870169f$var$addRange("A", "Z");
$1b16e9917870169f$var$addRange("a", "z");
$1b16e9917870169f$var$addRange("0", "9");
$1b16e9917870169f$var$addRange("+", "+");
$1b16e9917870169f$var$addRange("/", "/");
function $1b16e9917870169f$export$9e6dcb9430409adb(inputLength) {
    const remainder = inputLength % 3;
    const paddingLength = remainder !== 0 ? 3 - remainder : 0;
    return [
        (inputLength + paddingLength) / 3 * 4,
        paddingLength
    ];
}
function $1b16e9917870169f$export$8fb536984ec8b4d7(input, output) {
    const [outputLength, paddingLength] = $1b16e9917870169f$export$9e6dcb9430409adb(input.length);
    if (!output) {
        output = new Uint8Array(outputLength);
        $1b16e9917870169f$var$encodeForward(input, output, paddingLength);
        return output;
    } else {
        if (output.length < outputLength) throw new TypeError("output buffer is too small");
        output = output.subarray(0, outputLength);
        // When input and output are on same ArrayBuffer,
        // we check if it's possible to encode in-place.
        if (input.buffer !== output.buffer) $1b16e9917870169f$var$encodeForward(input, output, paddingLength);
        else if (output.byteOffset + output.length - (paddingLength + 1) <= input.byteOffset + input.length) // Output ends before input ends.
        // Can encode forwards, because writing output won't catch up with reading input.
        // The output end is subtracted by `(paddingLength + 1)` because
        // depending on padding length, it's possible to write 1-3 extra bytes after input ends.
        //
        // The following diagrams show how the last read from input and the last write to output
        // are not conflicting.
        //
        // spell: disable
        //
        // `paddingLength === 2` can write 3 extra bytes:
        //
        //   input:  | aaaaaabb |          |          |          |
        //   output: |  aaaaaa  |  bb0000  |    =     |    =     |
        //
        // `paddingLength === 1` can write 2 extra bytes:
        //
        //   input:  | aaaaaabb | bbbbcccc |          |          |
        //   output: |  aaaaaa  |  bbbbbb  |  cccc00  |    =     |
        //
        // `paddingLength === 0` can write 1 extra byte:
        //
        //   input:  | aaaaaabb | bbbbcccc | ccdddddd |          |
        //   output: |  aaaaaa  |  bbbbbb  |  cccccc  |  dddddd  |
        //
        // spell: enable
        $1b16e9917870169f$var$encodeForward(input, output, paddingLength);
        else if (output.byteOffset >= input.byteOffset - 1) // Output starts after input starts
        // So in backwards, writing output won't catch up with reading input.
        // The input start is subtracted by `1`, Because as the first 3 bytes becomes 4 bytes,
        // it's possible to write 1 extra byte before input starts.
        // spell: disable-next-line
        //   input:  |          | aaaaaabb | bbbbcccc | ccdddddd |
        //   output: |  aaaaaa  |  bbbbbb  |  cccccc  |  dddddd  |
        // Must encode backwards.
        $1b16e9917870169f$var$encodeBackward(input, output, paddingLength);
        else // Input is in the middle of output,
        // It's not possible to read either the first or the last three bytes
        // before they are overwritten by the output.
        throw new TypeError("input and output cannot overlap");
        return outputLength;
    }
}
function $1b16e9917870169f$var$encodeForward(input, output, paddingLength) {
    let inputIndex = 0;
    let outputIndex = 0;
    while(inputIndex < input.length - 2){
        /* cspell: disable-next-line */ // aaaaaabb
        const x = input[inputIndex];
        inputIndex += 1;
        /* cspell: disable-next-line */ // bbbbcccc
        const y = input[inputIndex];
        inputIndex += 1;
        /* cspell: disable-next-line */ // ccdddddd
        const z = input[inputIndex];
        inputIndex += 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[x >> 2];
        outputIndex += 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[(x & 3) << 4 | y >> 4];
        outputIndex += 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[(y & 15) << 2 | z >> 6];
        outputIndex += 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[z & 63];
        outputIndex += 1;
    }
    if (paddingLength === 2) {
        /* cspell: disable-next-line */ // aaaaaabb
        const x = input[inputIndex];
        inputIndex += 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[x >> 2];
        outputIndex += 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[(x & 3) << 4];
        outputIndex += 1;
        output[outputIndex] = $1b16e9917870169f$var$paddingChar;
        outputIndex += 1;
        output[outputIndex] = $1b16e9917870169f$var$paddingChar;
    } else if (paddingLength === 1) {
        /* cspell: disable-next-line */ // aaaaaabb
        const x = input[inputIndex];
        inputIndex += 1;
        /* cspell: disable-next-line */ // bbbbcccc
        const y = input[inputIndex];
        inputIndex += 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[x >> 2];
        outputIndex += 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[(x & 3) << 4 | y >> 4];
        outputIndex += 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[(y & 15) << 2];
        outputIndex += 1;
        output[outputIndex] = $1b16e9917870169f$var$paddingChar;
    }
}
function $1b16e9917870169f$var$encodeBackward(input, output, paddingLength) {
    let inputIndex = input.length - 1;
    let outputIndex = output.length - 1;
    if (paddingLength === 2) {
        /* cspell: disable-next-line */ // aaaaaabb
        const x = input[inputIndex];
        inputIndex -= 1;
        output[outputIndex] = $1b16e9917870169f$var$paddingChar;
        outputIndex -= 1;
        output[outputIndex] = $1b16e9917870169f$var$paddingChar;
        outputIndex -= 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[(x & 3) << 4];
        outputIndex -= 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[x >> 2];
        outputIndex -= 1;
    } else if (paddingLength === 1) {
        /* cspell: disable-next-line */ // bbbbcccc
        const y = input[inputIndex];
        inputIndex -= 1;
        /* cspell: disable-next-line */ // aaaaaabb
        const x = input[inputIndex];
        inputIndex -= 1;
        output[outputIndex] = $1b16e9917870169f$var$paddingChar;
        outputIndex -= 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[(y & 15) << 2];
        outputIndex -= 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[(x & 3) << 4 | y >> 4];
        outputIndex -= 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[x >> 2];
        outputIndex -= 1;
    }
    while(inputIndex >= 0){
        /* cspell: disable-next-line */ // ccdddddd
        const z = input[inputIndex];
        inputIndex -= 1;
        /* cspell: disable-next-line */ // bbbbcccc
        const y = input[inputIndex];
        inputIndex -= 1;
        /* cspell: disable-next-line */ // aaaaaabb
        const x = input[inputIndex];
        inputIndex -= 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[z & 63];
        outputIndex -= 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[(y & 15) << 2 | z >> 6];
        outputIndex -= 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[(x & 3) << 4 | y >> 4];
        outputIndex -= 1;
        output[outputIndex] = $1b16e9917870169f$var$indexToChar[x >> 2];
        outputIndex -= 1;
    }
}
function $1b16e9917870169f$export$94fdf11bafc8de6b(input) {
    let padding;
    if (input[input.length - 2] === "=") padding = 2;
    else if (input[input.length - 1] === "=") padding = 1;
    else padding = 0;
    const result = new Uint8Array(input.length / 4 * 3 - padding);
    let sIndex = 0;
    let dIndex = 0;
    while(sIndex < input.length - (padding !== 0 ? 4 : 0)){
        const a = $1b16e9917870169f$var$charToIndex[input.charCodeAt(sIndex)];
        sIndex += 1;
        const b = $1b16e9917870169f$var$charToIndex[input.charCodeAt(sIndex)];
        sIndex += 1;
        const c = $1b16e9917870169f$var$charToIndex[input.charCodeAt(sIndex)];
        sIndex += 1;
        const d = $1b16e9917870169f$var$charToIndex[input.charCodeAt(sIndex)];
        sIndex += 1;
        result[dIndex] = a << 2 | (b & 48) >> 4;
        dIndex += 1;
        result[dIndex] = (b & 15) << 4 | (c & 60) >> 2;
        dIndex += 1;
        result[dIndex] = (c & 3) << 6 | d;
        dIndex += 1;
    }
    if (padding === 1) {
        const a = $1b16e9917870169f$var$charToIndex[input.charCodeAt(sIndex)];
        sIndex += 1;
        const b = $1b16e9917870169f$var$charToIndex[input.charCodeAt(sIndex)];
        sIndex += 1;
        const c = $1b16e9917870169f$var$charToIndex[input.charCodeAt(sIndex)];
        result[dIndex] = a << 2 | (b & 48) >> 4;
        dIndex += 1;
        result[dIndex] = (b & 15) << 4 | (c & 60) >> 2;
    } else if (padding === 2) {
        const a = $1b16e9917870169f$var$charToIndex[input.charCodeAt(sIndex)];
        sIndex += 1;
        const b = $1b16e9917870169f$var$charToIndex[input.charCodeAt(sIndex)];
        result[dIndex] = a << 2 | (b & 48) >> 4;
    }
    return result;
}

});

parcelRegister("32bmk", function(module, exports) {

$parcel$export(module.exports, "hexToNumber", () => $235a5eb6b9daa8b2$export$d57f2bacc26b4249);
$parcel$export(module.exports, "write4HexDigits", () => $235a5eb6b9daa8b2$export$6109e2907f86231a);
function $235a5eb6b9daa8b2$var$hexCharToNumber(char) {
    if (char < 48) throw new TypeError(`Invalid hex char ${char}`);
    if (char < 58) // 0-9
    return char - 48;
    if (char < 65) throw new TypeError(`Invalid hex char ${char}`);
    if (char < 71) // A-F
    return char - 55;
    if (char < 97) throw new TypeError(`Invalid hex char ${char}`);
    if (char < 103) // a-f
    return char - 87;
    throw new TypeError(`Invalid hex char ${char}`);
}
function $235a5eb6b9daa8b2$export$d57f2bacc26b4249(data) {
    let result = 0;
    for(let i = 0; i < data.length; i += 1)result = result << 4 | $235a5eb6b9daa8b2$var$hexCharToNumber(data[i]);
    return result;
}
function $235a5eb6b9daa8b2$export$6109e2907f86231a(buffer, index, value) {
    const start = index;
    index += 3;
    while(index >= start && value > 0){
        const digit = value & 0xf;
        value >>= 4;
        if (digit < 10) buffer[index] = digit + 48; // '0'
        else buffer[index] = digit + 87; // 'a' - 10
        index -= 1;
    }
    while(index >= start){
        buffer[index] = 48; // '0'
        index -= 1;
    }
}

});

parcelRegister("fXuIk", function(module, exports) {

$parcel$export(module.exports, "NOOP", () => $b9e430d7f1e7a460$export$5702a91a6f42969f);
$parcel$export(module.exports, "unreachable", () => $b9e430d7f1e7a460$export$565e9d9bd6b6e0d4);
const $b9e430d7f1e7a460$export$5702a91a6f42969f = ()=>{
// no-op
};
function $b9e430d7f1e7a460$export$565e9d9bd6b6e0d4(...args) {
    // Trigger runtime's unhandled rejection event.
    throw new Error("Unreachable. Arguments:\n" + args.join("\n"));
}

});

parcelRegister("gtlgZ", function(module, exports) {

$parcel$export(module.exports, "sequenceEqual", () => $bfdfdb21e3c32026$export$d0a07e60ae428313);
function $bfdfdb21e3c32026$export$d0a07e60ae428313(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i += 1){
        if (a[i] !== b[i]) return false;
    }
    return true;
}

});



parcelRegister("ezTiR", function(module, exports) {
$parcel$export(module.exports, "AdbSubprocess", () => (parcelRequire("5jHg5")).AdbSubprocess);
$parcel$export(module.exports, "AdbSubprocessShellProtocol", () => (parcelRequire("23OH0")).AdbSubprocessShellProtocol);
$parcel$export(module.exports, "escapeArg", () => (parcelRequire("beA73")).escapeArg);
parcelRequire("5jHg5");
parcelRequire("cv2l6");
parcelRequire("beA73");

});
parcelRegister("5jHg5", function(module, exports) {

$parcel$export(module.exports, "AdbSubprocess", () => $3df04856ab447e80$export$7a6597f9fb12f14e);
parcelRequire("7edQJ");
var $k61Wg = parcelRequire("k61Wg");
var $koQVx = parcelRequire("koQVx");

var $2TOFC = parcelRequire("2TOFC");
parcelRequire("cv2l6");
var $co9iz = parcelRequire("co9iz");
var $23OH0 = parcelRequire("23OH0");
const $3df04856ab447e80$var$DEFAULT_OPTIONS = {
    protocols: [
        (0, $23OH0.AdbSubprocessShellProtocol),
        (0, $co9iz.AdbSubprocessNoneProtocol)
    ]
};
class $3df04856ab447e80$export$7a6597f9fb12f14e extends (0, $2TOFC.AdbCommandBase) {
    async #createProtocol(mode, command, options) {
        const { protocols: protocols } = {
            ...$3df04856ab447e80$var$DEFAULT_OPTIONS,
            ...options
        };
        let Constructor;
        for (const item of protocols)// It's async so can't use `Array#find`
        if (await item.isSupported(this.adb)) {
            Constructor = item;
            break;
        }
        if (!Constructor) throw new Error("No specified protocol is supported by the device");
        if (Array.isArray(command)) command = command.join(" ");
        else if (command === undefined) // spawn the default shell
        command = "";
        return await Constructor[mode](this.adb, command);
    }
    /**
     * Spawns an executable in PTY mode.
     *
     * Redirection mode is enough for most simple commands, but PTY mode is required for
     * commands that manipulate the terminal, such as `vi` and `less`.
     * @param command The command to run. If omitted, the default shell will be spawned.
     * @param options The options for creating the `AdbSubprocessProtocol`
     * @returns A new `AdbSubprocessProtocol` instance connecting to the spawned process.
     */ shell(command, options) {
        return this.#createProtocol("pty", command, options);
    }
    /**
     * Spawns an executable and redirect the standard input/output stream.
     *
     * Redirection mode is enough for most simple commands, but PTY mode is required for
     * commands that manipulate the terminal, such as `vi` and `less`.
     * @param command The command to run, or an array of strings containing both command and args.
     * @param options The options for creating the `AdbSubprocessProtocol`
     * @returns A new `AdbSubprocessProtocol` instance connecting to the spawned process.
     */ spawn(command, options) {
        return this.#createProtocol("raw", command, options);
    }
    /**
     * Spawns a new process, waits until it exits, and returns the entire output.
     * @param command The command to run
     * @param options The options for creating the `AdbSubprocessProtocol`
     * @returns The entire output of the command
     */ async spawnAndWait(command, options) {
        const process = await this.spawn(command, options);
        const [stdout, stderr, exitCode] = await Promise.all([
            process.stdout.pipeThrough(new (0, $koQVx.TextDecoderStream)()).pipeThrough(new (0, $k61Wg.ConcatStringStream)()),
            process.stderr.pipeThrough(new (0, $koQVx.TextDecoderStream)()).pipeThrough(new (0, $k61Wg.ConcatStringStream)()),
            process.exit
        ]);
        return {
            stdout: stdout,
            stderr: stderr,
            exitCode: exitCode
        };
    }
    /**
     * Spawns a new process, waits until it exits, and returns the entire output.
     * @param command The command to run
     * @returns The entire output of the command
     */ async spawnAndWaitLegacy(command) {
        const { stdout: stdout } = await this.spawnAndWait(command, {
            protocols: [
                (0, $co9iz.AdbSubprocessNoneProtocol)
            ]
        });
        return stdout;
    }
}

});
parcelRegister("cv2l6", function(module, exports) {
$parcel$export(module.exports, "AdbSubprocessNoneProtocol", () => (parcelRequire("co9iz")).AdbSubprocessNoneProtocol);
$parcel$export(module.exports, "AdbSubprocessShellProtocol", () => (parcelRequire("23OH0")).AdbSubprocessShellProtocol);
parcelRequire("co9iz");
parcelRequire("23OH0");
parcelRequire("cUsti");

});
parcelRegister("co9iz", function(module, exports) {

$parcel$export(module.exports, "AdbSubprocessNoneProtocol", () => $904ef069d7a99ac4$export$d83482397cfbf8db);
parcelRequire("7edQJ");
var $6NYMu = parcelRequire("6NYMu");
parcelRequire("5lBQi");
var $fXuIk = parcelRequire("fXuIk");
class $904ef069d7a99ac4$export$d83482397cfbf8db {
    static isSupported() {
        return true;
    }
    static async pty(adb, command) {
        return new $904ef069d7a99ac4$export$d83482397cfbf8db(await adb.createSocket(`shell:${command}`));
    }
    static async raw(adb, command) {
        // `shell,raw:${command}` also triggers raw mode,
        // But is not supported on Android version <7.
        return new $904ef069d7a99ac4$export$d83482397cfbf8db(await adb.createSocket(`exec:${command}`));
    }
    #socket;
    // Legacy shell forwards all data to stdin.
    get stdin() {
        return this.#socket.writable;
    }
    /**
     * Legacy shell mixes stdout and stderr.
     */ get stdout() {
        return this.#socket.readable;
    }
    #stderr;
    /**
     * `stderr` will always be empty.
     */ get stderr() {
        return this.#stderr;
    }
    #exit;
    get exit() {
        return this.#exit;
    }
    constructor(socket){
        this.#socket = socket;
        this.#stderr = new (0, $6NYMu.ReadableStream)({
            start: (controller)=>{
                this.#socket.closed.then(()=>controller.close()).catch((0, $fXuIk.unreachable));
            }
        });
        this.#exit = socket.closed.then(()=>0);
    }
    resize() {
    // Not supported, but don't throw.
    }
    async kill() {
        await this.#socket.close();
    }
}

});

parcelRegister("23OH0", function(module, exports) {

$parcel$export(module.exports, "AdbSubprocessShellProtocol", () => $18032f121c93c39a$export$6810084fa64eee3f);
parcelRequire("kV55x");
var $aHKds = parcelRequire("aHKds");
parcelRequire("7edQJ");
var $jEctC = parcelRequire("jEctC");
var $fnPEF = parcelRequire("fnPEF");
var $ebpYL = parcelRequire("ebpYL");
var $6NYMu = parcelRequire("6NYMu");
parcelRequire("hr1EK");
var $9LJSP = parcelRequire("9LJSP");
var $6Savq = parcelRequire("6Savq");

var $drR7i = parcelRequire("drR7i");
parcelRequire("5lBQi");
var $6Savq = parcelRequire("6Savq");
var $18032f121c93c39a$export$4e6123448c357dfc;
(function(AdbShellProtocolId) {
    AdbShellProtocolId[AdbShellProtocolId["Stdin"] = 0] = "Stdin";
    AdbShellProtocolId[AdbShellProtocolId["Stdout"] = 1] = "Stdout";
    AdbShellProtocolId[AdbShellProtocolId["Stderr"] = 2] = "Stderr";
    AdbShellProtocolId[AdbShellProtocolId["Exit"] = 3] = "Exit";
    AdbShellProtocolId[AdbShellProtocolId["CloseStdin"] = 4] = "CloseStdin";
    AdbShellProtocolId[AdbShellProtocolId["WindowSizeChange"] = 5] = "WindowSizeChange";
})($18032f121c93c39a$export$4e6123448c357dfc || ($18032f121c93c39a$export$4e6123448c357dfc = {}));
// This packet format is used in both direction.
const $18032f121c93c39a$var$AdbShellProtocolPacket = new (0, $9LJSP.Struct)({
    littleEndian: true
}).uint8("id", (0, $6Savq.placeholder)()).uint32("length").uint8Array("data", {
    lengthField: "length"
});
class $18032f121c93c39a$export$6810084fa64eee3f {
    static isSupported(adb) {
        return adb.canUseFeature((0, $drR7i.AdbFeature).ShellV2);
    }
    static async pty(adb, command) {
        // TODO: AdbShellSubprocessProtocol: Support setting `XTERM` environment variable
        return new $18032f121c93c39a$export$6810084fa64eee3f(await adb.createSocket(`shell,v2,pty:${command}`));
    }
    static async raw(adb, command) {
        return new $18032f121c93c39a$export$6810084fa64eee3f(await adb.createSocket(`shell,v2,raw:${command}`));
    }
    #socket;
    #writer;
    #stdin;
    get stdin() {
        return this.#stdin;
    }
    #stdout;
    get stdout() {
        return this.#stdout;
    }
    #stderr;
    get stderr() {
        return this.#stderr;
    }
    #exit = new (0, $aHKds.PromiseResolver)();
    get exit() {
        return this.#exit.promise;
    }
    constructor(socket){
        this.#socket = socket;
        let stdoutController;
        let stderrController;
        this.#stdout = new (0, $fnPEF.PushReadableStream)((controller)=>{
            stdoutController = controller;
        });
        this.#stderr = new (0, $fnPEF.PushReadableStream)((controller)=>{
            stderrController = controller;
        });
        socket.readable.pipeThrough(new (0, $ebpYL.StructDeserializeStream)($18032f121c93c39a$var$AdbShellProtocolPacket)).pipeTo(new (0, $6NYMu.WritableStream)({
            write: async (chunk)=>{
                switch(chunk.id){
                    case $18032f121c93c39a$export$4e6123448c357dfc.Exit:
                        this.#exit.resolve(chunk.data[0]);
                        break;
                    case $18032f121c93c39a$export$4e6123448c357dfc.Stdout:
                        if (!stdoutController.abortSignal.aborted) await stdoutController.enqueue(chunk.data);
                        break;
                    case $18032f121c93c39a$export$4e6123448c357dfc.Stderr:
                        if (!stderrController.abortSignal.aborted) await stderrController.enqueue(chunk.data);
                        break;
                }
            }
        })).then(()=>{
            stdoutController.close();
            stderrController.close();
            // If `#exit` has already resolved, this will be a no-op
            this.#exit.reject(new Error("Socket ended without exit message"));
        }, (e)=>{
            stdoutController.error(e);
            stderrController.error(e);
            // If `#exit` has already resolved, this will be a no-op
            this.#exit.reject(e);
        });
        this.#writer = this.#socket.writable.getWriter();
        this.#stdin = new (0, $jEctC.MaybeConsumable).WritableStream({
            write: async (chunk)=>{
                await this.#writer.write($18032f121c93c39a$var$AdbShellProtocolPacket.serialize({
                    id: $18032f121c93c39a$export$4e6123448c357dfc.Stdin,
                    data: chunk
                }));
            }
        });
    }
    async resize(rows, cols) {
        await this.#writer.write($18032f121c93c39a$var$AdbShellProtocolPacket.serialize({
            id: $18032f121c93c39a$export$4e6123448c357dfc.WindowSizeChange,
            // The "correct" format is `${rows}x${cols},${x_pixels}x${y_pixels}`
            // However, according to https://linux.die.net/man/4/tty_ioctl
            // `x_pixels` and `y_pixels` are unused, so always sending `0` should be fine.
            data: (0, $6Savq.encodeUtf8)(`${rows}x${cols},0x0\0`)
        }));
    }
    kill() {
        return this.#socket.close();
    }
}

});
parcelRegister("drR7i", function(module, exports) {

$parcel$export(module.exports, "AdbFeature", () => $9ca6ffdb312d84ef$export$e05918f35b7c5680);
// The order follows
// https://cs.android.com/android/platform/superproject/+/master:packages/modules/adb/transport.cpp;l=77;drc=6d14d35d0241f6fee145f8e54ffd77252e8d29fd
var $9ca6ffdb312d84ef$export$e05918f35b7c5680;
(function(AdbFeature) {
    AdbFeature["ShellV2"] = "shell_v2";
    AdbFeature["Cmd"] = "cmd";
    AdbFeature["StatV2"] = "stat_v2";
    AdbFeature["ListV2"] = "ls_v2";
    AdbFeature["FixedPushMkdir"] = "fixed_push_mkdir";
    AdbFeature["Abb"] = "abb";
    AdbFeature["AbbExec"] = "abb_exec";
    AdbFeature["SendReceiveV2"] = "sendrecv_v2";
    AdbFeature["DelayedAck"] = "delayed_ack";
})($9ca6ffdb312d84ef$export$e05918f35b7c5680 || ($9ca6ffdb312d84ef$export$e05918f35b7c5680 = {}));

});


parcelRegister("cUsti", function(module, exports) {

});



parcelRegister("beA73", function(module, exports) {

$parcel$export(module.exports, "escapeArg", () => $82dd03c0c08ee971$export$3470675a0ff86e89);
function $82dd03c0c08ee971$export$3470675a0ff86e89(s) {
    let result = "";
    result += `'`;
    let base = 0;
    while(true){
        const found = s.indexOf(`'`, base);
        if (found === -1) {
            result += s.substring(base);
            break;
        }
        result += s.substring(base, found);
        // a'b becomes a'\'b (the backslash is not a escape character)
        result += String.raw`'\''`;
        base = found + 1;
    }
    result += `'`;
    return result;
}

});


parcelRegister("3HODG", function(module, exports) {
$parcel$export(module.exports, "AdbSync", () => (parcelRequire("aBc50")).AdbSync);
parcelRequire("9QwYX");
parcelRequire("6cK2h");
parcelRequire("awO9J");
parcelRequire("j6zCo");
parcelRequire("h4v6J");
parcelRequire("3JkOU");
parcelRequire("9for9");
parcelRequire("aBc50");

});
parcelRegister("9QwYX", function(module, exports) {

$parcel$export(module.exports, "adbSyncOpenDir", () => $72b28df151d1adcb$export$1579339099549b64);
parcelRequire("hr1EK");
var $9LJSP = parcelRequire("9LJSP");

var $j6zCo = parcelRequire("j6zCo");

var $h4v6J = parcelRequire("h4v6J");

var $9for9 = parcelRequire("9for9");
const $72b28df151d1adcb$export$9f58ebc0d39b84a0 = new (0, $9LJSP.Struct)({
    littleEndian: true
}).concat((0, $9for9.AdbSyncLstatResponse)).uint32("nameLength").string("name", {
    lengthField: "nameLength"
});
const $72b28df151d1adcb$export$f3f12bd93e4611be = new (0, $9LJSP.Struct)({
    littleEndian: true
}).concat((0, $9for9.AdbSyncStatResponse)).uint32("nameLength").string("name", {
    lengthField: "nameLength"
});
async function* $72b28df151d1adcb$export$17741d8e2b8c93(socket, path) {
    const locked = await socket.lock();
    try {
        await (0, $j6zCo.adbSyncWriteRequest)(locked, (0, $j6zCo.AdbSyncRequestId).ListV2, path);
        for await (const item of (0, $h4v6J.adbSyncReadResponses)(locked, (0, $h4v6J.AdbSyncResponseId).Entry2, $72b28df151d1adcb$export$f3f12bd93e4611be)){
            // `LST2` can return error codes for failed `lstat` calls.
            // `LIST` just ignores them.
            // But they only contain `name` so still pretty useless.
            if (item.error !== (0, $9for9.AdbSyncStatErrorCode).SUCCESS) continue;
            yield item;
        }
    } finally{
        locked.release();
    }
}
async function* $72b28df151d1adcb$export$b83665dbb067898b(socket, path) {
    const locked = await socket.lock();
    try {
        await (0, $j6zCo.adbSyncWriteRequest)(locked, (0, $j6zCo.AdbSyncRequestId).List, path);
        for await (const item of (0, $h4v6J.adbSyncReadResponses)(locked, (0, $h4v6J.AdbSyncResponseId).Entry, $72b28df151d1adcb$export$9f58ebc0d39b84a0))yield item;
    } finally{
        locked.release();
    }
}
async function* $72b28df151d1adcb$export$1579339099549b64(socket, path, v2) {
    if (v2) yield* $72b28df151d1adcb$export$17741d8e2b8c93(socket, path);
    else for await (const item of $72b28df151d1adcb$export$b83665dbb067898b(socket, path))// Convert to same format as `AdbSyncEntry2Response` for easier consumption.
    // However it will add some overhead.
    yield {
        mode: item.mode,
        size: BigInt(item.size),
        mtime: BigInt(item.mtime),
        get type () {
            return item.type;
        },
        get permission () {
            return item.permission;
        },
        name: item.name
    };
}

});
parcelRegister("j6zCo", function(module, exports) {

$parcel$export(module.exports, "AdbSyncRequestId", () => $de8a34e0882318f6$export$5322f80b7c65656e);
$parcel$export(module.exports, "adbSyncWriteRequest", () => $de8a34e0882318f6$export$9fbb2f6d9716c879);
parcelRequire("hr1EK");
var $9LJSP = parcelRequire("9LJSP");
parcelRequire("5lBQi");
var $6Savq = parcelRequire("6Savq");

var $h4v6J = parcelRequire("h4v6J");
var $de8a34e0882318f6$export$5322f80b7c65656e;
(function(AdbSyncRequestId) {
    AdbSyncRequestId.List = (0, $h4v6J.adbSyncEncodeId)("LIST");
    AdbSyncRequestId.ListV2 = (0, $h4v6J.adbSyncEncodeId)("LIS2");
    AdbSyncRequestId.Send = (0, $h4v6J.adbSyncEncodeId)("SEND");
    AdbSyncRequestId.SendV2 = (0, $h4v6J.adbSyncEncodeId)("SND2");
    AdbSyncRequestId.Lstat = (0, $h4v6J.adbSyncEncodeId)("STAT");
    AdbSyncRequestId.Stat = (0, $h4v6J.adbSyncEncodeId)("STA2");
    AdbSyncRequestId.LstatV2 = (0, $h4v6J.adbSyncEncodeId)("LST2");
    AdbSyncRequestId.Data = (0, $h4v6J.adbSyncEncodeId)("DATA");
    AdbSyncRequestId.Done = (0, $h4v6J.adbSyncEncodeId)("DONE");
    AdbSyncRequestId.Receive = (0, $h4v6J.adbSyncEncodeId)("RECV");
})($de8a34e0882318f6$export$5322f80b7c65656e || ($de8a34e0882318f6$export$5322f80b7c65656e = {}));
const $de8a34e0882318f6$export$31b0bdfb146abfd4 = new (0, $9LJSP.Struct)({
    littleEndian: true
}).uint32("id").uint32("arg");
async function $de8a34e0882318f6$export$9fbb2f6d9716c879(writable, id, value) {
    if (typeof id === "string") id = (0, $h4v6J.adbSyncEncodeId)(id);
    if (typeof value === "number") {
        await writable.write($de8a34e0882318f6$export$31b0bdfb146abfd4.serialize({
            id: id,
            arg: value
        }));
        return;
    }
    if (typeof value === "string") value = (0, $6Savq.encodeUtf8)(value);
    // `writable` is buffered, it copies inputs to an internal buffer,
    // so don't concatenate headers and data here, that will be an unnecessary copy.
    await writable.write($de8a34e0882318f6$export$31b0bdfb146abfd4.serialize({
        id: id,
        arg: value.length
    }));
    await writable.write(value);
}

});
parcelRegister("h4v6J", function(module, exports) {

$parcel$export(module.exports, "adbSyncEncodeId", () => $c6daf0b886b3d547$export$e5f795408780cc7c);
$parcel$export(module.exports, "AdbSyncResponseId", () => $c6daf0b886b3d547$export$cb117bc133363ddb);
$parcel$export(module.exports, "adbSyncReadResponse", () => $c6daf0b886b3d547$export$2cf93447a6456640);
$parcel$export(module.exports, "adbSyncReadResponses", () => $c6daf0b886b3d547$export$59ff2512fa71dc09);
parcelRequire("cOond");
var $h4MAN = parcelRequire("h4MAN");
parcelRequire("hr1EK");
var $6Savq = parcelRequire("6Savq");
var $9LJSP = parcelRequire("9LJSP");
function $c6daf0b886b3d547$var$encodeAsciiUnchecked(value) {
    const result = new Uint8Array(value.length);
    for(let i = 0; i < value.length; i += 1)result[i] = value.charCodeAt(i);
    return result;
}
function $c6daf0b886b3d547$export$e5f795408780cc7c(value) {
    const buffer = $c6daf0b886b3d547$var$encodeAsciiUnchecked(value);
    return (0, $h4MAN.getUint32LittleEndian)(buffer, 0);
}
var $c6daf0b886b3d547$export$cb117bc133363ddb;
(function(AdbSyncResponseId) {
    AdbSyncResponseId.Entry = $c6daf0b886b3d547$export$e5f795408780cc7c("DENT");
    AdbSyncResponseId.Entry2 = $c6daf0b886b3d547$export$e5f795408780cc7c("DNT2");
    AdbSyncResponseId.Lstat = $c6daf0b886b3d547$export$e5f795408780cc7c("STAT");
    AdbSyncResponseId.Stat = $c6daf0b886b3d547$export$e5f795408780cc7c("STA2");
    AdbSyncResponseId.Lstat2 = $c6daf0b886b3d547$export$e5f795408780cc7c("LST2");
    AdbSyncResponseId.Done = $c6daf0b886b3d547$export$e5f795408780cc7c("DONE");
    AdbSyncResponseId.Data = $c6daf0b886b3d547$export$e5f795408780cc7c("DATA");
    AdbSyncResponseId.Ok = $c6daf0b886b3d547$export$e5f795408780cc7c("OKAY");
    AdbSyncResponseId.Fail = $c6daf0b886b3d547$export$e5f795408780cc7c("FAIL");
})($c6daf0b886b3d547$export$cb117bc133363ddb || ($c6daf0b886b3d547$export$cb117bc133363ddb = {}));
class $c6daf0b886b3d547$export$ad50f5a23743360b extends Error {
}
const $c6daf0b886b3d547$export$bf28540d1ad84211 = new (0, $9LJSP.Struct)({
    littleEndian: true
}).uint32("messageLength").string("message", {
    lengthField: "messageLength"
}).postDeserialize((object)=>{
    throw new $c6daf0b886b3d547$export$ad50f5a23743360b(object.message);
});
async function $c6daf0b886b3d547$export$2cf93447a6456640(stream, id, type) {
    if (typeof id === "string") id = $c6daf0b886b3d547$export$e5f795408780cc7c(id);
    const buffer = await stream.readExactly(4);
    switch((0, $h4MAN.getUint32LittleEndian)(buffer, 0)){
        case $c6daf0b886b3d547$export$cb117bc133363ddb.Fail:
            await $c6daf0b886b3d547$export$bf28540d1ad84211.deserialize(stream);
            throw new Error("Unreachable");
        case id:
            return await type.deserialize(stream);
        default:
            throw new Error(`Expected '${id}', but got '${(0, $6Savq.decodeUtf8)(buffer)}'`);
    }
}
async function* $c6daf0b886b3d547$export$59ff2512fa71dc09(stream, id, type) {
    if (typeof id === "string") id = $c6daf0b886b3d547$export$e5f795408780cc7c(id);
    while(true){
        const buffer = await stream.readExactly(4);
        switch((0, $h4MAN.getUint32LittleEndian)(buffer, 0)){
            case $c6daf0b886b3d547$export$cb117bc133363ddb.Fail:
                await $c6daf0b886b3d547$export$bf28540d1ad84211.deserialize(stream);
                throw new Error("Unreachable");
            case $c6daf0b886b3d547$export$cb117bc133363ddb.Done:
                // `DONE` responses' size are always same as the request's normal response.
                //
                // For example, `DONE` responses for `LIST` requests are 16 bytes (same as `DENT` responses),
                // but `DONE` responses for `STAT` requests are 12 bytes (same as `STAT` responses).
                await stream.readExactly(type.size);
                return;
            case id:
                yield await type.deserialize(stream);
                break;
            default:
                throw new Error(`Expected '${id}' or '${$c6daf0b886b3d547$export$cb117bc133363ddb.Done}', but got '${(0, $6Savq.decodeUtf8)(buffer)}'`);
        }
    }
}

});


parcelRegister("9for9", function(module, exports) {

$parcel$export(module.exports, "LinuxFileType", () => $6bb87868c5b7aa85$export$6b5fe9b0a9be762e);
$parcel$export(module.exports, "AdbSyncLstatResponse", () => $6bb87868c5b7aa85$export$4091d821a4f90167);
$parcel$export(module.exports, "AdbSyncStatErrorCode", () => $6bb87868c5b7aa85$export$e93cb33d37e1d1a3);
$parcel$export(module.exports, "AdbSyncStatResponse", () => $6bb87868c5b7aa85$export$32343a08ff41df91);
$parcel$export(module.exports, "adbSyncLstat", () => $6bb87868c5b7aa85$export$2241dc001bbd3624);
$parcel$export(module.exports, "adbSyncStat", () => $6bb87868c5b7aa85$export$9b51c155441928f2);
parcelRequire("hr1EK");
var $9LJSP = parcelRequire("9LJSP");
var $6Savq = parcelRequire("6Savq");

var $j6zCo = parcelRequire("j6zCo");

var $h4v6J = parcelRequire("h4v6J");
var $6bb87868c5b7aa85$export$6b5fe9b0a9be762e;
(function(LinuxFileType) {
    LinuxFileType[LinuxFileType["Directory"] = 4] = "Directory";
    LinuxFileType[LinuxFileType["File"] = 8] = "File";
    LinuxFileType[LinuxFileType["Link"] = 10] = "Link";
})($6bb87868c5b7aa85$export$6b5fe9b0a9be762e || ($6bb87868c5b7aa85$export$6b5fe9b0a9be762e = {}));
const $6bb87868c5b7aa85$export$4091d821a4f90167 = new (0, $9LJSP.Struct)({
    littleEndian: true
}).int32("mode").int32("size").int32("mtime").extra({
    get type () {
        return this.mode >> 12;
    },
    get permission () {
        return this.mode & 4095;
    }
}).postDeserialize((object)=>{
    if (object.mode === 0 && object.size === 0 && object.mtime === 0) throw new Error("lstat error");
});
var $6bb87868c5b7aa85$export$e93cb33d37e1d1a3;
(function(AdbSyncStatErrorCode) {
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["SUCCESS"] = 0] = "SUCCESS";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["EACCES"] = 13] = "EACCES";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["EEXIST"] = 17] = "EEXIST";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["EFAULT"] = 14] = "EFAULT";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["EFBIG"] = 27] = "EFBIG";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["EINTR"] = 4] = "EINTR";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["EINVAL"] = 22] = "EINVAL";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["EIO"] = 5] = "EIO";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["EISDIR"] = 21] = "EISDIR";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["ELOOP"] = 40] = "ELOOP";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["EMFILE"] = 24] = "EMFILE";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["ENAMETOOLONG"] = 36] = "ENAMETOOLONG";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["ENFILE"] = 23] = "ENFILE";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["ENOENT"] = 2] = "ENOENT";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["ENOMEM"] = 12] = "ENOMEM";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["ENOSPC"] = 28] = "ENOSPC";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["ENOTDIR"] = 20] = "ENOTDIR";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["EOVERFLOW"] = 75] = "EOVERFLOW";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["EPERM"] = 1] = "EPERM";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["EROFS"] = 30] = "EROFS";
    AdbSyncStatErrorCode[AdbSyncStatErrorCode["ETXTBSY"] = 26] = "ETXTBSY";
})($6bb87868c5b7aa85$export$e93cb33d37e1d1a3 || ($6bb87868c5b7aa85$export$e93cb33d37e1d1a3 = {}));
const $6bb87868c5b7aa85$export$32343a08ff41df91 = new (0, $9LJSP.Struct)({
    littleEndian: true
}).uint32("error", (0, $6Savq.placeholder)()).uint64("dev").uint64("ino").uint32("mode").uint32("nlink").uint32("uid").uint32("gid").uint64("size").uint64("atime").uint64("mtime").uint64("ctime").extra({
    get type () {
        return this.mode >> 12;
    },
    get permission () {
        return this.mode & 4095;
    }
}).postDeserialize((object)=>{
    if (object.error) throw new Error($6bb87868c5b7aa85$export$e93cb33d37e1d1a3[object.error]);
});
async function $6bb87868c5b7aa85$export$2241dc001bbd3624(socket, path, v2) {
    const locked = await socket.lock();
    try {
        if (v2) {
            await (0, $j6zCo.adbSyncWriteRequest)(locked, (0, $j6zCo.AdbSyncRequestId).LstatV2, path);
            return await (0, $h4v6J.adbSyncReadResponse)(locked, (0, $h4v6J.AdbSyncResponseId).Lstat2, $6bb87868c5b7aa85$export$32343a08ff41df91);
        } else {
            await (0, $j6zCo.adbSyncWriteRequest)(locked, (0, $j6zCo.AdbSyncRequestId).Lstat, path);
            const response = await (0, $h4v6J.adbSyncReadResponse)(locked, (0, $h4v6J.AdbSyncResponseId).Lstat, $6bb87868c5b7aa85$export$4091d821a4f90167);
            return {
                mode: response.mode,
                // Convert to `BigInt` to make it compatible with `AdbSyncStatResponse`
                size: BigInt(response.size),
                mtime: BigInt(response.mtime),
                get type () {
                    return response.type;
                },
                get permission () {
                    return response.permission;
                }
            };
        }
    } finally{
        locked.release();
    }
}
async function $6bb87868c5b7aa85$export$9b51c155441928f2(socket, path) {
    const locked = await socket.lock();
    try {
        await (0, $j6zCo.adbSyncWriteRequest)(locked, (0, $j6zCo.AdbSyncRequestId).Stat, path);
        return await (0, $h4v6J.adbSyncReadResponse)(locked, (0, $h4v6J.AdbSyncResponseId).Stat, $6bb87868c5b7aa85$export$32343a08ff41df91);
    } finally{
        locked.release();
    }
}

});


parcelRegister("6cK2h", function(module, exports) {

$parcel$export(module.exports, "adbSyncPull", () => $484792ce1371d406$export$b2722bc5a41c81be);
parcelRequire("7edQJ");
var $fnPEF = parcelRequire("fnPEF");
parcelRequire("hr1EK");
var $9LJSP = parcelRequire("9LJSP");

var $j6zCo = parcelRequire("j6zCo");

var $h4v6J = parcelRequire("h4v6J");
const $484792ce1371d406$export$c364285c7f62b15f = new (0, $9LJSP.Struct)({
    littleEndian: true
}).uint32("dataLength").uint8Array("data", {
    lengthField: "dataLength"
});
async function* $484792ce1371d406$export$e4f995c0cb69297d(socket, path) {
    const locked = await socket.lock();
    let done = false;
    try {
        await (0, $j6zCo.adbSyncWriteRequest)(locked, (0, $j6zCo.AdbSyncRequestId).Receive, path);
        for await (const packet of (0, $h4v6J.adbSyncReadResponses)(locked, (0, $h4v6J.AdbSyncResponseId).Data, $484792ce1371d406$export$c364285c7f62b15f))yield packet.data;
        done = true;
    } catch (e) {
        done = true;
        throw e;
    } finally{
        if (!done) {
            // sync pull can't be cancelled, so we have to read all data
            for await (const packet of (0, $h4v6J.adbSyncReadResponses)(locked, (0, $h4v6J.AdbSyncResponseId).Data, $484792ce1371d406$export$c364285c7f62b15f));
        }
        locked.release();
    }
}
function $484792ce1371d406$export$b2722bc5a41c81be(socket, path) {
    // TODO: use `ReadableStream.from` when it's supported
    return new (0, $fnPEF.PushReadableStream)(async (controller)=>{
        for await (const data of $484792ce1371d406$export$e4f995c0cb69297d(socket, path))await controller.enqueue(data);
    });
}

});

parcelRegister("awO9J", function(module, exports) {

$parcel$export(module.exports, "adbSyncPush", () => $7aa3cc788c769a7c$export$68c559ba4f0f11a4);
parcelRequire("7edQJ");
var $6NYMu = parcelRequire("6NYMu");
var $b5TnZ = parcelRequire("b5TnZ");
var $jEctC = parcelRequire("jEctC");
parcelRequire("hr1EK");
var $9LJSP = parcelRequire("9LJSP");
var $6Savq = parcelRequire("6Savq");
parcelRequire("5lBQi");
var $fXuIk = parcelRequire("fXuIk");

var $j6zCo = parcelRequire("j6zCo");

var $h4v6J = parcelRequire("h4v6J");

var $9for9 = parcelRequire("9for9");
const $7aa3cc788c769a7c$export$199544395e854c07 = 65536;
const $7aa3cc788c769a7c$export$de38b4566403a6ea = new (0, $9LJSP.Struct)({
    littleEndian: true
}).uint32("unused");
async function $7aa3cc788c769a7c$var$pipeFileData(locked, file, packetSize, mtime) {
    // Read and write in parallel,
    // allow error response to abort the write.
    const abortController = new (0, $6NYMu.AbortController)();
    file.pipeThrough(new (0, $b5TnZ.DistributionStream)(packetSize, true)).pipeTo(new (0, $jEctC.MaybeConsumable).WritableStream({
        write: async (chunk)=>{
            await (0, $j6zCo.adbSyncWriteRequest)(locked, (0, $j6zCo.AdbSyncRequestId).Data, chunk);
        }
    }), {
        signal: abortController.signal
    }).then(async ()=>{
        await (0, $j6zCo.adbSyncWriteRequest)(locked, (0, $j6zCo.AdbSyncRequestId).Done, mtime);
        await locked.flush();
    }, (0, $fXuIk.NOOP));
    await (0, $h4v6J.adbSyncReadResponse)(locked, (0, $h4v6J.AdbSyncResponseId).Ok, $7aa3cc788c769a7c$export$de38b4566403a6ea).catch((e)=>{
        abortController.abort();
        throw e;
    });
}
async function $7aa3cc788c769a7c$export$97096e9859e22356({ socket: socket, filename: filename, file: file, type: type = (0, $9for9.LinuxFileType).File, permission: permission = 438, mtime: mtime = Date.now() / 1000 | 0, packetSize: packetSize = $7aa3cc788c769a7c$export$199544395e854c07 }) {
    const locked = await socket.lock();
    try {
        const mode = type << 12 | permission;
        const pathAndMode = `${filename},${mode.toString()}`;
        await (0, $j6zCo.adbSyncWriteRequest)(locked, (0, $j6zCo.AdbSyncRequestId).Send, pathAndMode);
        await $7aa3cc788c769a7c$var$pipeFileData(locked, file, packetSize, mtime);
    } finally{
        locked.release();
    }
}
var $7aa3cc788c769a7c$export$b4c20861ad50fe86;
(function(AdbSyncSendV2Flags) {
    AdbSyncSendV2Flags[AdbSyncSendV2Flags["None"] = 0] = "None";
    AdbSyncSendV2Flags[AdbSyncSendV2Flags["Brotli"] = 1] = "Brotli";
    /**
     * 2
     */ AdbSyncSendV2Flags[AdbSyncSendV2Flags["Lz4"] = 2] = "Lz4";
    /**
     * 4
     */ AdbSyncSendV2Flags[AdbSyncSendV2Flags["Zstd"] = 4] = "Zstd";
    AdbSyncSendV2Flags[AdbSyncSendV2Flags["DryRun"] = 2147483648] = "DryRun";
})($7aa3cc788c769a7c$export$b4c20861ad50fe86 || ($7aa3cc788c769a7c$export$b4c20861ad50fe86 = {}));
const $7aa3cc788c769a7c$export$36fe31421b981962 = new (0, $9LJSP.Struct)({
    littleEndian: true
}).uint32("id").uint32("mode").uint32("flags", (0, $6Savq.placeholder)());
async function $7aa3cc788c769a7c$export$65eec66d09c9751b({ socket: socket, filename: filename, file: file, type: type = (0, $9for9.LinuxFileType).File, permission: permission = 438, mtime: mtime = Date.now() / 1000 | 0, packetSize: packetSize = $7aa3cc788c769a7c$export$199544395e854c07, dryRun: dryRun = false }) {
    const locked = await socket.lock();
    try {
        await (0, $j6zCo.adbSyncWriteRequest)(locked, (0, $j6zCo.AdbSyncRequestId).SendV2, filename);
        const mode = type << 12 | permission;
        let flags = $7aa3cc788c769a7c$export$b4c20861ad50fe86.None;
        if (dryRun) flags |= $7aa3cc788c769a7c$export$b4c20861ad50fe86.DryRun;
        await locked.write($7aa3cc788c769a7c$export$36fe31421b981962.serialize({
            id: (0, $j6zCo.AdbSyncRequestId).SendV2,
            mode: mode,
            flags: flags
        }));
        await $7aa3cc788c769a7c$var$pipeFileData(locked, file, packetSize, mtime);
    } finally{
        locked.release();
    }
}
function $7aa3cc788c769a7c$export$68c559ba4f0f11a4(options) {
    if (options.v2) return $7aa3cc788c769a7c$export$65eec66d09c9751b(options);
    if (options.dryRun) throw new Error("dryRun is not supported in v1");
    return $7aa3cc788c769a7c$export$97096e9859e22356(options);
}

});

parcelRegister("3JkOU", function(module, exports) {

$parcel$export(module.exports, "AdbSyncSocket", () => $2b75b983ed1aaf9f$export$5ab9b68fbce86ef6);
parcelRequire("7edQJ");
var $b5TnZ = parcelRequire("b5TnZ");
var $bJSM1 = parcelRequire("bJSM1");
var $5Ywqs = parcelRequire("5Ywqs");
parcelRequire("5lBQi");
var $5SRHv = parcelRequire("5SRHv");
class $2b75b983ed1aaf9f$export$7224dd8d1cb774a1 {
    #writer;
    #readable;
    #socketLock;
    #writeLock = new (0, $5SRHv.AutoResetEvent)();
    #combiner;
    get position() {
        return this.#readable.position;
    }
    constructor(writer, readable, bufferSize, lock){
        this.#writer = writer;
        this.#readable = readable;
        this.#socketLock = lock;
        this.#combiner = new (0, $b5TnZ.BufferCombiner)(bufferSize);
    }
    async #write(buffer) {
        // `#combiner` will reuse the buffer, so we need to use the Consumable pattern
        await (0, $5Ywqs.Consumable).WritableStream.write(this.#writer, buffer);
    }
    async flush() {
        try {
            await this.#writeLock.wait();
            const buffer = this.#combiner.flush();
            if (buffer) await this.#write(buffer);
        } finally{
            this.#writeLock.notifyOne();
        }
    }
    async write(data) {
        try {
            await this.#writeLock.wait();
            for (const buffer of this.#combiner.push(data))await this.#write(buffer);
        } finally{
            this.#writeLock.notifyOne();
        }
    }
    async readExactly(length) {
        // The request may still be in the internal buffer.
        // Call `flush` to send it before starting reading
        await this.flush();
        return await this.#readable.readExactly(length);
    }
    release() {
        // In theory, the writer shouldn't leave anything in the buffer,
        // but to be safe, call `flush` to throw away any remaining data.
        this.#combiner.flush();
        this.#socketLock.notifyOne();
    }
    async close() {
        await this.#readable.cancel();
    }
}
class $2b75b983ed1aaf9f$export$5ab9b68fbce86ef6 {
    #lock = new (0, $5SRHv.AutoResetEvent)();
    #socket;
    #locked;
    constructor(socket, bufferSize){
        this.#socket = socket;
        this.#locked = new $2b75b983ed1aaf9f$export$7224dd8d1cb774a1(socket.writable.getWriter(), new (0, $bJSM1.BufferedReadableStream)(socket.readable), bufferSize, this.#lock);
    }
    async lock() {
        await this.#lock.wait();
        return this.#locked;
    }
    async close() {
        await this.#locked.close();
        await this.#socket.close();
    }
}

});

parcelRegister("aBc50", function(module, exports) {

$parcel$export(module.exports, "AdbSync", () => $7b76badbaf65e5be$export$c7d21bab4b5606f3);
parcelRequire("hpom2");
var $aGQPd = parcelRequire("aGQPd");

var $drR7i = parcelRequire("drR7i");
parcelRequire("ezTiR");
var $beA73 = parcelRequire("beA73");

var $9QwYX = parcelRequire("9QwYX");

var $6cK2h = parcelRequire("6cK2h");

var $awO9J = parcelRequire("awO9J");

var $3JkOU = parcelRequire("3JkOU");

var $9for9 = parcelRequire("9for9");
function $7b76badbaf65e5be$export$7f7b8152cc673abe(path) {
    const end = path.lastIndexOf("/");
    if (end === -1) throw new Error(`Invalid path`);
    if (end === 0) return "/";
    return path.substring(0, end);
}
class $7b76badbaf65e5be$export$c7d21bab4b5606f3 extends (0, $aGQPd.AutoDisposable) {
    _adb;
    _socket;
    #supportsStat;
    #supportsListV2;
    #fixedPushMkdir;
    #supportsSendReceiveV2;
    #needPushMkdirWorkaround;
    get supportsStat() {
        return this.#supportsStat;
    }
    get supportsListV2() {
        return this.#supportsListV2;
    }
    get fixedPushMkdir() {
        return this.#fixedPushMkdir;
    }
    get supportsSendReceiveV2() {
        return this.#supportsSendReceiveV2;
    }
    get needPushMkdirWorkaround() {
        return this.#needPushMkdirWorkaround;
    }
    constructor(adb, socket){
        super();
        this._adb = adb;
        this._socket = new (0, $3JkOU.AdbSyncSocket)(socket, adb.maxPayloadSize);
        this.#supportsStat = adb.canUseFeature((0, $drR7i.AdbFeature).StatV2);
        this.#supportsListV2 = adb.canUseFeature((0, $drR7i.AdbFeature).ListV2);
        this.#fixedPushMkdir = adb.canUseFeature((0, $drR7i.AdbFeature).FixedPushMkdir);
        this.#supportsSendReceiveV2 = adb.canUseFeature((0, $drR7i.AdbFeature).SendReceiveV2);
        // https://android.googlesource.com/platform/packages/modules/adb/+/91768a57b7138166e0a3d11f79cd55909dda7014/client/file_sync_client.cpp#1361
        this.#needPushMkdirWorkaround = this._adb.canUseFeature((0, $drR7i.AdbFeature).ShellV2) && !this.fixedPushMkdir;
    }
    /**
     * Gets information of a file or folder.
     *
     * If `path` points to a symbolic link, the returned information is about the link itself (with `type` being `LinuxFileType.Link`).
     */ async lstat(path) {
        return await (0, $9for9.adbSyncLstat)(this._socket, path, this.#supportsStat);
    }
    /**
     * Gets the information of a file or folder.
     *
     * If `path` points to a symbolic link, it will be resolved and the returned information is about the target (with `type` being `LinuxFileType.File` or `LinuxFileType.Directory`).
     */ async stat(path) {
        if (!this.#supportsStat) throw new Error("Not supported");
        return await (0, $9for9.adbSyncStat)(this._socket, path);
    }
    /**
     * Checks if `path` is a directory, or a symbolic link to a directory.
     *
     * This uses `lstat` internally, thus works on all Android versions.
     */ async isDirectory(path) {
        try {
            await this.lstat(path + "/");
            return true;
        } catch (e) {
            return false;
        }
    }
    opendir(path) {
        return (0, $9QwYX.adbSyncOpenDir)(this._socket, path, this.supportsListV2);
    }
    async readdir(path) {
        const results = [];
        for await (const entry of this.opendir(path))results.push(entry);
        return results;
    }
    /**
     * Reads the content of a file on device.
     *
     * @param filename The full path of the file on device to read.
     * @returns A `ReadableStream` that contains the file content.
     */ read(filename) {
        return (0, $6cK2h.adbSyncPull)(this._socket, filename);
    }
    /**
     * Writes a file on device. If the file name already exists, it will be overwritten.
     *
     * @param options The content and options of the file to write.
     */ async write(options) {
        if (this.needPushMkdirWorkaround) // It may fail if `filename` already exists.
        // Ignore the result.
        // TODO: sync: test push mkdir workaround (need an Android 8 device)
        await this._adb.subprocess.spawnAndWait([
            "mkdir",
            "-p",
            (0, $beA73.escapeArg)($7b76badbaf65e5be$export$7f7b8152cc673abe(options.filename))
        ]);
        await (0, $awO9J.adbSyncPush)({
            v2: this.supportsSendReceiveV2,
            socket: this._socket,
            ...options
        });
    }
    lockSocket() {
        return this._socket.lock();
    }
    async dispose() {
        super.dispose();
        await this._socket.close();
    }
}

});


parcelRegister("liel6", function(module, exports) {

$parcel$export(module.exports, "AdbTcpIpCommand", () => $f80666ec7843035b$export$9d7ae67b2874bc2a);

var $2TOFC = parcelRequire("2TOFC");
class $f80666ec7843035b$export$9d7ae67b2874bc2a extends (0, $2TOFC.AdbCommandBase) {
    #parsePort(value) {
        if (!value || value === "0") return undefined;
        return Number.parseInt(value, 10);
    }
    async getListenAddresses() {
        const serviceListenAddresses = await this.adb.getProp("service.adb.listen_addrs");
        const servicePort = await this.adb.getProp("service.adb.tcp.port");
        const persistPort = await this.adb.getProp("persist.adb.tcp.port");
        return {
            serviceListenAddresses: serviceListenAddresses != "" ? serviceListenAddresses.split(",") : [],
            servicePort: this.#parsePort(servicePort),
            persistPort: this.#parsePort(persistPort)
        };
    }
    async setPort(port) {
        if (port <= 0) throw new TypeError(`Invalid port ${port}`);
        const output = await this.adb.createSocketAndWait(`tcpip:${port}`);
        if (output !== `restarting in TCP mode port: ${port}\n`) throw new Error(output);
        return output;
    }
    async disable() {
        const output = await this.adb.createSocketAndWait("usb:");
        if (output !== "restarting in USB mode\n") throw new Error(output);
        return output;
    }
}

});



parcelRegister("bFpy9", function(module, exports) {

$parcel$export(module.exports, "AdbBanner", () => $87e757b1771fca0a$export$25d495fe2ebd5375);
var $87e757b1771fca0a$export$23f5f7103a6c0e54;
(function(AdbBannerKey) {
    AdbBannerKey["Product"] = "ro.product.name";
    AdbBannerKey["Model"] = "ro.product.model";
    AdbBannerKey["Device"] = "ro.product.device";
    AdbBannerKey["Features"] = "features";
})($87e757b1771fca0a$export$23f5f7103a6c0e54 || ($87e757b1771fca0a$export$23f5f7103a6c0e54 = {}));
class $87e757b1771fca0a$export$25d495fe2ebd5375 {
    static parse(banner) {
        let product;
        let model;
        let device;
        let features = [];
        const pieces = banner.split("::");
        if (pieces.length > 1) {
            const props = pieces[1];
            for (const prop of props.split(";")){
                // istanbul ignore if
                if (!prop) continue;
                const keyValue = prop.split("=");
                if (keyValue.length !== 2) continue;
                const [key, value] = keyValue;
                switch(key){
                    case $87e757b1771fca0a$export$23f5f7103a6c0e54.Product:
                        product = value;
                        break;
                    case $87e757b1771fca0a$export$23f5f7103a6c0e54.Model:
                        model = value;
                        break;
                    case $87e757b1771fca0a$export$23f5f7103a6c0e54.Device:
                        device = value;
                        break;
                    case $87e757b1771fca0a$export$23f5f7103a6c0e54.Features:
                        features = value.split(",");
                        break;
                }
            }
        }
        return new $87e757b1771fca0a$export$25d495fe2ebd5375(product, model, device, features);
    }
    #product;
    get product() {
        return this.#product;
    }
    #model;
    get model() {
        return this.#model;
    }
    #device;
    get device() {
        return this.#device;
    }
    #features = [];
    get features() {
        return this.#features;
    }
    constructor(product, model, device, features){
        this.#product = product;
        this.#model = model;
        this.#device = device;
        this.#features = features;
    }
}

});

parcelRegister("7gpwK", function(module, exports) {
$parcel$export(module.exports, "AdbPacketHeader", () => (parcelRequire("2lmjj")).AdbPacketHeader);
$parcel$export(module.exports, "AdbPacketSerializeStream", () => (parcelRequire("2lmjj")).AdbPacketSerializeStream);
$parcel$export(module.exports, "AdbDaemonTransport", () => (parcelRequire("aIHw7")).AdbDaemonTransport);
parcelRequire("gYm23");
parcelRequire("7qLAG");
parcelRequire("1hhal");
parcelRequire("cb2uE");
parcelRequire("2lmjj");
parcelRequire("5BaNe");
parcelRequire("aIHw7");

});
parcelRegister("gYm23", function(module, exports) {

$parcel$export(module.exports, "ADB_DEFAULT_AUTHENTICATORS", () => $c5b35711f7a6189a$export$485fb103785b43ab);
$parcel$export(module.exports, "AdbAuthenticationProcessor", () => $c5b35711f7a6189a$export$e4e9c85a581bb39f);
parcelRequire("kV55x");
var $aHKds = parcelRequire("aHKds");
parcelRequire("hr1EK");
var $j4unN = parcelRequire("j4unN");
parcelRequire("5lBQi");
var $2kccq = parcelRequire("2kccq");
var $6Savq = parcelRequire("6Savq");

var $7qLAG = parcelRequire("7qLAG");

var $2lmjj = parcelRequire("2lmjj");
var $c5b35711f7a6189a$export$2e65721f4f5c7298;
(function(AdbAuthType) {
    AdbAuthType[AdbAuthType["Token"] = 1] = "Token";
    AdbAuthType[AdbAuthType["Signature"] = 2] = "Signature";
    AdbAuthType[AdbAuthType["PublicKey"] = 3] = "PublicKey";
})($c5b35711f7a6189a$export$2e65721f4f5c7298 || ($c5b35711f7a6189a$export$2e65721f4f5c7298 = {}));
const $c5b35711f7a6189a$export$6db9d4c500eaa91b = async function*(credentialStore, getNextRequest) {
    for await (const key of credentialStore.iterateKeys()){
        const packet = await getNextRequest();
        if (packet.arg0 !== $c5b35711f7a6189a$export$2e65721f4f5c7298.Token) return;
        const signature = (0, $7qLAG.rsaSign)(key.buffer, packet.payload);
        yield {
            command: (0, $2lmjj.AdbCommand).Auth,
            arg0: $c5b35711f7a6189a$export$2e65721f4f5c7298.Signature,
            arg1: 0,
            payload: signature
        };
    }
};
const $c5b35711f7a6189a$export$d4b89a035405944 = async function*(credentialStore, getNextRequest) {
    const packet = await getNextRequest();
    if (packet.arg0 !== $c5b35711f7a6189a$export$2e65721f4f5c7298.Token) return;
    let privateKey;
    for await (const key of credentialStore.iterateKeys()){
        privateKey = key;
        break;
    }
    if (!privateKey) privateKey = await credentialStore.generateKey();
    const publicKeyLength = (0, $7qLAG.adbGetPublicKeySize)();
    const [publicKeyBase64Length] = (0, $2kccq.calculateBase64EncodedLength)(publicKeyLength);
    const nameBuffer = privateKey.name?.length ? (0, $6Savq.encodeUtf8)(privateKey.name) : (0, $j4unN.EMPTY_UINT8_ARRAY);
    const publicKeyBuffer = new Uint8Array(publicKeyBase64Length + (nameBuffer.length ? nameBuffer.length + 1 : 0) + // Space character + name
    1);
    (0, $7qLAG.adbGeneratePublicKey)(privateKey.buffer, publicKeyBuffer);
    (0, $2kccq.encodeBase64)(publicKeyBuffer.subarray(0, publicKeyLength), publicKeyBuffer);
    if (nameBuffer.length) {
        publicKeyBuffer[publicKeyBase64Length] = 0x20;
        publicKeyBuffer.set(nameBuffer, publicKeyBase64Length + 1);
    }
    yield {
        command: (0, $2lmjj.AdbCommand).Auth,
        arg0: $c5b35711f7a6189a$export$2e65721f4f5c7298.PublicKey,
        arg1: 0,
        payload: publicKeyBuffer
    };
};
const $c5b35711f7a6189a$export$485fb103785b43ab = [
    $c5b35711f7a6189a$export$6db9d4c500eaa91b,
    $c5b35711f7a6189a$export$d4b89a035405944
];
class $c5b35711f7a6189a$export$e4e9c85a581bb39f {
    authenticators;
    #credentialStore;
    #pendingRequest = new (0, $aHKds.PromiseResolver)();
    #iterator;
    constructor(authenticators, credentialStore){
        this.authenticators = authenticators;
        this.#credentialStore = credentialStore;
    }
    #getNextRequest = ()=>{
        return this.#pendingRequest.promise;
    };
    async *#invokeAuthenticator() {
        for (const authenticator of this.authenticators)for await (const packet of authenticator(this.#credentialStore, this.#getNextRequest)){
            // If the authenticator yielded a response
            // Prepare `nextRequest` for next authentication request
            this.#pendingRequest = new (0, $aHKds.PromiseResolver)();
            // Yield the response to outer layer
            yield packet;
        }
    }
    async process(packet) {
        if (!this.#iterator) this.#iterator = this.#invokeAuthenticator();
        this.#pendingRequest.resolve(packet);
        const result = await this.#iterator.next();
        if (result.done) throw new Error("No authenticator can handle the request");
        return result.value;
    }
    dispose() {
        this.#iterator?.return?.();
    }
}

});
parcelRegister("7qLAG", function(module, exports) {

$parcel$export(module.exports, "adbGetPublicKeySize", () => $568fe0a3a1a6b938$export$847074fb5f64c4e1);
$parcel$export(module.exports, "adbGeneratePublicKey", () => $568fe0a3a1a6b938$export$8699f7714545d1a1);
$parcel$export(module.exports, "rsaSign", () => $568fe0a3a1a6b938$export$97e3cdd046452c80);
parcelRequire("cOond");
var $jzfEx = parcelRequire("jzfEx");
var $duafd = parcelRequire("duafd");
function $568fe0a3a1a6b938$export$19ed8bf0faa0c9c(array, byteOffset, length) {
    let result = 0n;
    // Currently `length` must be a multiplication of 8
    // Support for arbitrary length can be easily added
    for(let i = byteOffset; i < byteOffset + length; i += 8){
        result <<= 64n;
        const value = (0, $jzfEx.getUint64BigEndian)(array, i);
        result |= value;
    }
    return result;
}
function $568fe0a3a1a6b938$export$1fd10df48a397f51(array, byteOffset, length, value, littleEndian) {
    if (littleEndian) while(value > 0n){
        (0, $duafd.setInt64LittleEndian)(array, byteOffset, value);
        byteOffset += 8;
        value >>= 64n;
    }
    else {
        let position = byteOffset + length - 8;
        while(value > 0n){
            (0, $duafd.setInt64BigEndian)(array, position, value);
            position -= 8;
            value >>= 64n;
        }
    }
}
// These values are correct only if
// modulus length is 2048 and
// public exponent (e) is 65537
// Anyway, that's how this library generates keys
// To support other parameters,
// a proper ASN.1 parser can be used
// References:
//
//   https://tools.ietf.org/html/rfc8017#appendix-A.1.2
//   PKCS #1: RSA Cryptography Specifications Version 2.2
//     A.1.2.  RSA Private Key Syntax
//
//   https://lapo.it/asn1js/
//   https://github.com/lapo-luchini/asn1js
//   ASN.1 JavaScript decoder
//
//   https://www.itu.int/rec/T-REC-X.690-201508-I/en
//   X.690: Specification of Distinguished Encoding Rules (DER)
const $568fe0a3a1a6b938$var$RsaPrivateKeyNOffset = 38;
const $568fe0a3a1a6b938$var$RsaPrivateKeyNLength = 256;
const $568fe0a3a1a6b938$var$RsaPrivateKeyDOffset = 303;
const $568fe0a3a1a6b938$var$RsaPrivateKeyDLength = 256;
function $568fe0a3a1a6b938$export$5c1dc4cd37ff603(key) {
    const n = $568fe0a3a1a6b938$export$19ed8bf0faa0c9c(key, $568fe0a3a1a6b938$var$RsaPrivateKeyNOffset, $568fe0a3a1a6b938$var$RsaPrivateKeyNLength);
    const d = $568fe0a3a1a6b938$export$19ed8bf0faa0c9c(key, $568fe0a3a1a6b938$var$RsaPrivateKeyDOffset, $568fe0a3a1a6b938$var$RsaPrivateKeyDLength);
    return [
        n,
        d
    ];
}
function $568fe0a3a1a6b938$var$nonNegativeMod(m, d) {
    const r = m % d;
    if (r > 0) return r;
    return r + (d > 0 ? d : -d);
}
function $568fe0a3a1a6b938$export$f085ad9052472793(a, m) {
    a = $568fe0a3a1a6b938$var$nonNegativeMod(a, m);
    if (!a || m < 2) return NaN; // invalid input
    // find the gcd
    const s = [];
    let b = m;
    while(b){
        [a, b] = [
            b,
            a % b
        ];
        s.push({
            a: a,
            b: b
        });
    }
    /* istanbul ignore next */ if (a !== 1) return NaN; // inverse does not exists
    // find the inverse
    let x = 1;
    let y = 0;
    for(let i = s.length - 2; i >= 0; i -= 1)[x, y] = [
        y,
        x - y * Math.floor(s[i].a / s[i].b)
    ];
    return $568fe0a3a1a6b938$var$nonNegativeMod(y, m);
}
const $568fe0a3a1a6b938$var$ModulusLengthInBytes = 256;
const $568fe0a3a1a6b938$var$ModulusLengthInWords = $568fe0a3a1a6b938$var$ModulusLengthInBytes / 4;
function $568fe0a3a1a6b938$export$847074fb5f64c4e1() {
    return 8 + $568fe0a3a1a6b938$var$ModulusLengthInBytes + $568fe0a3a1a6b938$var$ModulusLengthInBytes + 4;
}
function $568fe0a3a1a6b938$export$8699f7714545d1a1(privateKey, output) {
    // cspell: ignore: mincrypt
    // Android 6 and earlier has its own encryption library called mincrypt
    // This is the RSA public key format used by mincrypt:
    // https://android.googlesource.com/platform/system/core/+/bb0c180e62703c2068a1b2c9f8ba6d634bf1553c/include/mincrypt/rsa.h#46
    // `n0inv` and `rr` are pre-calculated to speed up RSA operations
    // Android 7 switched its encryption library to BoringSSL, but still keeps the key format:
    // https://android.googlesource.com/platform/system/core.git/+/91784040db2b9273687f88d8b95f729d4a61ecc2/libcrypto_utils/android_pubkey.cpp#38
    // Except when reading a key, `n0inv` and `rr` are ignored (they are still populated when generating a key):
    // https://android.googlesource.com/platform/system/core.git/+/91784040db2b9273687f88d8b95f729d4a61ecc2/libcrypto_utils/android_pubkey.cpp#55
    // The public key is a struct (in little endian) of:
    //
    // [
    //   modulusLengthInWords, // 32-bit integer, a "word" is 32-bit so it must be 2048 / 8 / 4
    //                         // (the comment in Android source code is incorrect saying "This must be ANDROID_PUBKEY_MODULUS_SIZE")
    //   n0inv,                // 32-bit integer, the modular inverse of (lower 32 bits of `n`)
    //   modulus,              // `n`
    //   rr,                   // Montgomery parameter R^2
    //   exponent,             // 32-bit integer, must be 3 or 65537
    // ]
    let outputType;
    const outputLength = $568fe0a3a1a6b938$export$847074fb5f64c4e1();
    if (!output) {
        output = new Uint8Array(outputLength);
        outputType = "Uint8Array";
    } else {
        if (output.length < outputLength) throw new TypeError("output buffer is too small");
        outputType = "number";
    }
    const outputView = new DataView(output.buffer, output.byteOffset, output.length);
    let outputOffset = 0;
    // modulusLengthInWords
    outputView.setUint32(outputOffset, $568fe0a3a1a6b938$var$ModulusLengthInWords, true);
    outputOffset += 4;
    // extract `n` from private key
    const [n] = $568fe0a3a1a6b938$export$5c1dc4cd37ff603(privateKey);
    // Calculate `n0inv`
    const n0inv = -$568fe0a3a1a6b938$export$f085ad9052472793(Number(n % 2n ** 32n), 2 ** 32);
    outputView.setInt32(outputOffset, n0inv, true);
    outputOffset += 4;
    // Write `n` (a.k.a. `modulus`)
    $568fe0a3a1a6b938$export$1fd10df48a397f51(output, outputOffset, $568fe0a3a1a6b938$var$ModulusLengthInBytes, n, true);
    outputOffset += $568fe0a3a1a6b938$var$ModulusLengthInBytes;
    // Calculate rr = (2 ** (rsa_size)) ** 2 % n
    const rr = 2n ** 4096n % n;
    $568fe0a3a1a6b938$export$1fd10df48a397f51(output, outputOffset, $568fe0a3a1a6b938$var$ModulusLengthInBytes, rr, true);
    outputOffset += $568fe0a3a1a6b938$var$ModulusLengthInBytes;
    // exponent
    outputView.setUint32(outputOffset, 65537, true);
    outputOffset += 4;
    if (outputType === "Uint8Array") return output;
    else return outputLength;
}
function $568fe0a3a1a6b938$export$a871ce58ee56241a(base, exponent, modulus) {
    if (modulus === 1n) return 0n;
    let r = 1n;
    base = base % modulus;
    while(exponent > 0n){
        if (BigInt.asUintN(1, exponent) === 1n) r = r * base % modulus;
        base = base * base % modulus;
        exponent >>= 1n;
    }
    return r;
}
const $568fe0a3a1a6b938$export$f2deb3df359a068d = 20;
const $568fe0a3a1a6b938$export$35b3d451b440c51 = 0x30;
const $568fe0a3a1a6b938$export$f44bb4e033b660f9 = 0x04;
const $568fe0a3a1a6b938$export$3d2259b791fdf8f1 = 0x05;
const $568fe0a3a1a6b938$export$6307913b6c4d9e66 = 0x06;
const $568fe0a3a1a6b938$export$1025a137f1840fa1 = new Uint8Array([
    $568fe0a3a1a6b938$export$35b3d451b440c51,
    0x0d + $568fe0a3a1a6b938$export$f2deb3df359a068d,
    $568fe0a3a1a6b938$export$35b3d451b440c51,
    0x09,
    // SHA-1 (1 3 14 3 2 26)
    $568fe0a3a1a6b938$export$6307913b6c4d9e66,
    0x05,
    43,
    14,
    3,
    2,
    26,
    $568fe0a3a1a6b938$export$3d2259b791fdf8f1,
    0x00,
    $568fe0a3a1a6b938$export$f44bb4e033b660f9,
    $568fe0a3a1a6b938$export$f2deb3df359a068d
]);
function $568fe0a3a1a6b938$export$97e3cdd046452c80(privateKey, data) {
    const [n, d] = $568fe0a3a1a6b938$export$5c1dc4cd37ff603(privateKey);
    // PKCS#1 padding
    const padded = new Uint8Array(256);
    let index = 0;
    padded[index] = 0;
    index += 1;
    padded[index] = 1;
    index += 1;
    const fillLength = padded.length - $568fe0a3a1a6b938$export$1025a137f1840fa1.length - data.length - 1;
    while(index < fillLength){
        padded[index] = 0xff;
        index += 1;
    }
    padded[index] = 0;
    index += 1;
    padded.set($568fe0a3a1a6b938$export$1025a137f1840fa1, index);
    index += $568fe0a3a1a6b938$export$1025a137f1840fa1.length;
    padded.set(data, index);
    // Encryption
    // signature = padded ** d % n
    const signature = $568fe0a3a1a6b938$export$a871ce58ee56241a($568fe0a3a1a6b938$export$19ed8bf0faa0c9c(padded, 0, padded.length), d, n);
    // `padded` is not used anymore,
    // re-use the buffer to store the result
    $568fe0a3a1a6b938$export$1fd10df48a397f51(padded, 0, padded.length, signature, false);
    return padded;
}

});

parcelRegister("2lmjj", function(module, exports) {

$parcel$export(module.exports, "AdbCommand", () => $1b4ed9515c9d7ed1$export$5d836449dc8c8870);
$parcel$export(module.exports, "AdbPacketHeader", () => $1b4ed9515c9d7ed1$export$96ac7b5be108186d);
$parcel$export(module.exports, "calculateChecksum", () => $1b4ed9515c9d7ed1$export$b0943743069d64df);
$parcel$export(module.exports, "AdbPacketSerializeStream", () => $1b4ed9515c9d7ed1$export$4f57c42a69edaa4d);
parcelRequire("7edQJ");
var $5Ywqs = parcelRequire("5Ywqs");
var $6NYMu = parcelRequire("6NYMu");
parcelRequire("hr1EK");
var $9LJSP = parcelRequire("9LJSP");
var $1b4ed9515c9d7ed1$export$5d836449dc8c8870;
(function(AdbCommand) {
    AdbCommand[AdbCommand["Auth"] = 1213486401] = "Auth";
    AdbCommand[AdbCommand["Close"] = 1163086915] = "Close";
    AdbCommand[AdbCommand["Connect"] = 1314410051] = "Connect";
    AdbCommand[AdbCommand["Okay"] = 1497451343] = "Okay";
    AdbCommand[AdbCommand["Open"] = 1313165391] = "Open";
    AdbCommand[AdbCommand["Write"] = 1163154007] = "Write";
})($1b4ed9515c9d7ed1$export$5d836449dc8c8870 || ($1b4ed9515c9d7ed1$export$5d836449dc8c8870 = {}));
const $1b4ed9515c9d7ed1$export$96ac7b5be108186d = new (0, $9LJSP.Struct)({
    littleEndian: true
}).uint32("command").uint32("arg0").uint32("arg1").uint32("payloadLength").uint32("checksum").int32("magic");
const $1b4ed9515c9d7ed1$export$5a43c2ea262f9c91 = new (0, $9LJSP.Struct)({
    littleEndian: true
}).concat($1b4ed9515c9d7ed1$export$96ac7b5be108186d).uint8Array("payload", {
    lengthField: "payloadLength"
});
function $1b4ed9515c9d7ed1$export$b0943743069d64df(payload) {
    return payload.reduce((result, item)=>result + item, 0);
}
class $1b4ed9515c9d7ed1$export$4f57c42a69edaa4d extends (0, $6NYMu.TransformStream) {
    constructor(){
        const headerBuffer = new Uint8Array($1b4ed9515c9d7ed1$export$96ac7b5be108186d.size);
        super({
            transform: async (chunk, controller)=>{
                await chunk.tryConsume(async (chunk)=>{
                    const init = chunk;
                    init.payloadLength = init.payload.length;
                    await (0, $5Ywqs.Consumable).ReadableStream.enqueue(controller, $1b4ed9515c9d7ed1$export$96ac7b5be108186d.serialize(init, headerBuffer));
                    if (init.payloadLength) // USB protocol preserves packet boundaries,
                    // so we must write payload separately as native ADB does,
                    // otherwise the read operation on device will fail.
                    await (0, $5Ywqs.Consumable).ReadableStream.enqueue(controller, init.payload);
                });
            }
        });
    }
}

});


parcelRegister("1hhal", function(module, exports) {

});

parcelRegister("cb2uE", function(module, exports) {

$parcel$export(module.exports, "AdbPacketDispatcher", () => $8dd872409796e78b$export$d634de534db06769);
parcelRequire("kV55x");
var $1PmPk = parcelRequire("1PmPk");
var $5OCzC = parcelRequire("5OCzC");
var $aHKds = parcelRequire("aHKds");
parcelRequire("cOond");
var $h4MAN = parcelRequire("h4MAN");
parcelRequire("7edQJ");
var $6NYMu = parcelRequire("6NYMu");
var $5Ywqs = parcelRequire("5Ywqs");
parcelRequire("hr1EK");
var $6Savq = parcelRequire("6Savq");
var $j4unN = parcelRequire("j4unN");

var $2lmjj = parcelRequire("2lmjj");

var $5BaNe = parcelRequire("5BaNe");
class $8dd872409796e78b$export$d634de534db06769 {
    // ADB socket id starts from 1
    // (0 means open failed)
    #initializers = new (0, $1PmPk.AsyncOperationManager)(1);
    /**
     * Socket local ID to the socket controller.
     */ #sockets = new Map();
    #writer;
    options;
    #closed = false;
    #disconnected = new (0, $aHKds.PromiseResolver)();
    get disconnected() {
        return this.#disconnected.promise;
    }
    #incomingSocketHandlers = new Map();
    #readAbortController = new (0, $6NYMu.AbortController)();
    constructor(connection, options){
        this.options = options;
        // Don't allow negative values in dispatcher
        if (this.options.initialDelayedAckBytes < 0) this.options.initialDelayedAckBytes = 0;
        connection.readable.pipeTo(new (0, $6NYMu.WritableStream)({
            write: async (packet)=>{
                switch(packet.command){
                    case (0, $2lmjj.AdbCommand).Close:
                        await this.#handleClose(packet);
                        break;
                    case (0, $2lmjj.AdbCommand).Okay:
                        this.#handleOkay(packet);
                        break;
                    case (0, $2lmjj.AdbCommand).Open:
                        await this.#handleOpen(packet);
                        break;
                    case (0, $2lmjj.AdbCommand).Write:
                        await this.#handleWrite(packet);
                        break;
                    default:
                        // Junk data may only appear in the authentication phase,
                        // since the dispatcher only works after authentication,
                        // all packets should have a valid command.
                        // (although it's possible that Adb added new commands in the future)
                        throw new Error(`Unknown command: ${packet.command.toString(16)}`);
                }
            }
        }), {
            preventCancel: options.preserveConnection ?? false,
            signal: this.#readAbortController.signal
        }).then(()=>{
            this.#dispose();
        }, (e)=>{
            if (!this.#closed) this.#disconnected.reject(e);
            this.#dispose();
        });
        this.#writer = connection.writable.getWriter();
    }
    async #handleClose(packet) {
        // If the socket is still pending
        if (packet.arg0 === 0 && this.#initializers.reject(packet.arg1, new Error("Socket open failed"))) // Device failed to create the socket
        // (unknown service string, failed to execute command, etc.)
        // it doesn't break the connection,
        // so only reject the socket creation promise,
        // don't throw an error here.
        return;
        // From https://android.googlesource.com/platform/packages/modules/adb/+/65d18e2c1cc48b585811954892311b28a4c3d188/adb.cpp#459
        /* According to protocol.txt, p->msg.arg0 might be 0 to indicate
         * a failed OPEN only. However, due to a bug in previous ADB
         * versions, CLOSE(0, remote-id, "") was also used for normal
         * CLOSE() operations.
         */ // Ignore `arg0` and search for the socket
        const socket = this.#sockets.get(packet.arg1);
        if (socket) {
            await socket.close();
            socket.dispose();
            this.#sockets.delete(packet.arg1);
            return;
        }
    // TODO: adb: is double closing an socket a catastrophic error?
    // If the client sends two `CLSE` packets for one socket,
    // the device may also respond with two `CLSE` packets.
    }
    #handleOkay(packet) {
        let ackBytes;
        if (this.options.initialDelayedAckBytes !== 0) {
            if (packet.payload.length !== 4) throw new Error("Invalid OKAY packet. Payload size should be 4");
            ackBytes = (0, $h4MAN.getUint32LittleEndian)(packet.payload, 0);
        } else {
            if (packet.payload.length !== 0) throw new Error("Invalid OKAY packet. Payload size should be 0");
            ackBytes = Infinity;
        }
        if (this.#initializers.resolve(packet.arg1, {
            remoteId: packet.arg0,
            availableWriteBytes: ackBytes
        })) // Device successfully created the socket
        return;
        const socket = this.#sockets.get(packet.arg1);
        if (socket) {
            // When delayed ack is enabled, `ackBytes` is a positive number represents
            // how many bytes the device has received from this socket.
            // When delayed ack is disabled, `ackBytes` is always `Infinity` represents
            // the device has received last `WRTE` packet from the socket.
            socket.ack(ackBytes);
            return;
        }
        // Maybe the device is responding to a packet of last connection
        // Tell the device to close the socket
        this.sendPacket((0, $2lmjj.AdbCommand).Close, packet.arg1, packet.arg0, (0, $j4unN.EMPTY_UINT8_ARRAY));
    }
    #sendOkay(localId, remoteId, ackBytes) {
        let payload;
        if (this.options.initialDelayedAckBytes !== 0) {
            // TODO: try reusing this buffer to reduce memory allocation
            // However, that requires blocking reentrance of `sendOkay`, which might be more expensive
            payload = new Uint8Array(4);
            (0, $h4MAN.setUint32LittleEndian)(payload, 0, ackBytes);
        } else payload = (0, $j4unN.EMPTY_UINT8_ARRAY);
        return this.sendPacket((0, $2lmjj.AdbCommand).Okay, localId, remoteId, payload);
    }
    async #handleOpen(packet) {
        // Allocate a local ID for the socket from `#initializers`.
        // `AsyncOperationManager` doesn't directly support returning the next ID,
        // so use `add` + `resolve` to simulate this
        const [localId] = this.#initializers.add();
        this.#initializers.resolve(localId, undefined);
        const remoteId = packet.arg0;
        let availableWriteBytes = packet.arg1;
        let service = (0, $6Savq.decodeUtf8)(packet.payload);
        // ADB Daemon still adds a null character to the service string
        if (service.endsWith("\0")) service = service.substring(0, service.length - 1);
        // Check remote delayed ack enablement is consistent with local
        if (this.options.initialDelayedAckBytes === 0) {
            if (availableWriteBytes !== 0) throw new Error("Invalid OPEN packet. arg1 should be 0");
            availableWriteBytes = Infinity;
        } else {
            if (availableWriteBytes === 0) throw new Error("Invalid OPEN packet. arg1 should be greater than 0");
        }
        const handler = this.#incomingSocketHandlers.get(service);
        if (!handler) {
            await this.sendPacket((0, $2lmjj.AdbCommand).Close, 0, remoteId, (0, $j4unN.EMPTY_UINT8_ARRAY));
            return;
        }
        const controller = new (0, $5BaNe.AdbDaemonSocketController)({
            dispatcher: this,
            localId: localId,
            remoteId: remoteId,
            localCreated: false,
            service: service,
            availableWriteBytes: availableWriteBytes
        });
        try {
            await handler(controller.socket);
            this.#sockets.set(localId, controller);
            await this.#sendOkay(localId, remoteId, this.options.initialDelayedAckBytes);
        } catch (e) {
            await this.sendPacket((0, $2lmjj.AdbCommand).Close, 0, remoteId, (0, $j4unN.EMPTY_UINT8_ARRAY));
        }
    }
    async #handleWrite(packet) {
        const socket = this.#sockets.get(packet.arg1);
        if (!socket) throw new Error(`Unknown local socket id: ${packet.arg1}`);
        let handled = false;
        const promises = [
            (async ()=>{
                await socket.enqueue(packet.payload);
                await this.#sendOkay(packet.arg1, packet.arg0, packet.payload.length);
                handled = true;
            })()
        ];
        if (this.options.readTimeLimit) promises.push((async ()=>{
            await (0, $5OCzC.delay)(this.options.readTimeLimit);
            if (!handled) throw new Error(`readable of \`${socket.service}\` has stalled for ${this.options.readTimeLimit} milliseconds`);
        })());
        await Promise.race(promises);
    }
    async createSocket(service) {
        if (this.options.appendNullToServiceString) service += "\0";
        const [localId, initializer] = this.#initializers.add();
        await this.sendPacket((0, $2lmjj.AdbCommand).Open, localId, this.options.initialDelayedAckBytes, service);
        // Fulfilled by `handleOkay`
        const { remoteId: remoteId, availableWriteBytes: availableWriteBytes } = await initializer;
        const controller = new (0, $5BaNe.AdbDaemonSocketController)({
            dispatcher: this,
            localId: localId,
            remoteId: remoteId,
            localCreated: true,
            service: service,
            availableWriteBytes: availableWriteBytes
        });
        this.#sockets.set(localId, controller);
        return controller.socket;
    }
    addReverseTunnel(service, handler) {
        this.#incomingSocketHandlers.set(service, handler);
    }
    removeReverseTunnel(address) {
        this.#incomingSocketHandlers.delete(address);
    }
    clearReverseTunnels() {
        this.#incomingSocketHandlers.clear();
    }
    async sendPacket(command, arg0, arg1, // PERF: It's slightly faster to not use default parameter values
    payload) {
        if (typeof payload === "string") payload = (0, $6Savq.encodeUtf8)(payload);
        if (payload.length > this.options.maxPayloadSize) throw new TypeError("payload too large");
        await (0, $5Ywqs.Consumable).WritableStream.write(this.#writer, {
            command: command,
            arg0: arg0,
            arg1: arg1,
            payload: payload,
            checksum: this.options.calculateChecksum ? (0, $2lmjj.calculateChecksum)(payload) : 0,
            magic: command ^ 0xffffffff
        });
    }
    async close() {
        // Send `CLSE` packets for all sockets
        await Promise.all(Array.from(this.#sockets.values(), (socket)=>socket.close()));
        // Stop receiving
        // It's possible that we haven't received all `CLSE` confirm packets,
        // but it doesn't matter, the next connection can cope with them.
        this.#closed = true;
        this.#readAbortController.abort();
        if (this.options.preserveConnection) this.#writer.releaseLock();
        else await this.#writer.close();
    // `pipe().then()` will call `dispose`
    }
    #dispose() {
        for (const socket of this.#sockets.values())socket.dispose();
        this.#disconnected.resolve();
    }
}

});
parcelRegister("5BaNe", function(module, exports) {

$parcel$export(module.exports, "AdbDaemonSocketController", () => $4138c7bd76e67256$export$f061bb53e3f17c7c);
parcelRequire("kV55x");
var $aHKds = parcelRequire("aHKds");
parcelRequire("7edQJ");
var $jEctC = parcelRequire("jEctC");
var $fnPEF = parcelRequire("fnPEF");
parcelRequire("hr1EK");
var $j4unN = parcelRequire("j4unN");

var $2lmjj = parcelRequire("2lmjj");
class $4138c7bd76e67256$export$f061bb53e3f17c7c {
    #dispatcher;
    localId;
    remoteId;
    localCreated;
    service;
    #readable;
    #readableController;
    get readable() {
        return this.#readable;
    }
    #writableController;
    writable;
    #closed = false;
    #closedPromise = new (0, $aHKds.PromiseResolver)();
    get closed() {
        return this.#closedPromise.promise;
    }
    #socket;
    get socket() {
        return this.#socket;
    }
    #availableWriteBytesChanged;
    /**
     * When delayed ack is disabled, returns `Infinity` if the socket is ready to write
     * (exactly one packet can be written no matter how large it is), or `-1` if the socket
     * is waiting for ack message.
     *
     * When delayed ack is enabled, returns a non-negative finite number indicates the number of
     * bytes that can be written to the socket before waiting for ack message.
     */ #availableWriteBytes = 0;
    constructor(options){
        this.#dispatcher = options.dispatcher;
        this.localId = options.localId;
        this.remoteId = options.remoteId;
        this.localCreated = options.localCreated;
        this.service = options.service;
        this.#readable = new (0, $fnPEF.PushReadableStream)((controller)=>{
            this.#readableController = controller;
        });
        this.writable = new (0, $jEctC.MaybeConsumable).WritableStream({
            start: (controller)=>{
                this.#writableController = controller;
                controller.signal.addEventListener("abort", ()=>{
                    this.#availableWriteBytesChanged?.reject(controller.signal.reason);
                });
            },
            write: async (data)=>{
                const size = data.length;
                const chunkSize = this.#dispatcher.options.maxPayloadSize;
                for(let start = 0, end = chunkSize; start < size; start = end, end += chunkSize){
                    const chunk = data.subarray(start, end);
                    await this.#writeChunk(chunk);
                }
            }
        });
        this.#socket = new $4138c7bd76e67256$export$8f6ff11549e9fecf(this);
        this.#availableWriteBytes = options.availableWriteBytes;
    }
    async #writeChunk(data) {
        const length = data.length;
        while(this.#availableWriteBytes < length){
            // Only one lock is required because Web Streams API guarantees
            // that `write` is not reentrant.
            const resolver = new (0, $aHKds.PromiseResolver)();
            this.#availableWriteBytesChanged = resolver;
            await resolver.promise;
        }
        if (this.#availableWriteBytes === Infinity) this.#availableWriteBytes = -1;
        else this.#availableWriteBytes -= length;
        await this.#dispatcher.sendPacket((0, $2lmjj.AdbCommand).Write, this.localId, this.remoteId, data);
    }
    async enqueue(data) {
        // Consumers can `cancel` the `readable` if they are not interested in future data.
        // Throw away the data if that happens.
        if (this.#readableController.abortSignal.aborted) return;
        try {
            await this.#readableController.enqueue(data);
        } catch (e) {
            if (this.#readableController.abortSignal.aborted) return;
            throw e;
        }
    }
    ack(bytes) {
        this.#availableWriteBytes += bytes;
        this.#availableWriteBytesChanged?.resolve();
    }
    async close() {
        if (this.#closed) return;
        this.#closed = true;
        this.#availableWriteBytesChanged?.reject(new Error("Socket closed"));
        try {
            this.#writableController.error(new Error("Socket closed"));
        } catch  {
        // ignore
        }
        await this.#dispatcher.sendPacket((0, $2lmjj.AdbCommand).Close, this.localId, this.remoteId, (0, $j4unN.EMPTY_UINT8_ARRAY));
    }
    dispose() {
        try {
            this.#readableController.close();
        } catch  {
        // ignore
        }
        this.#closedPromise.resolve();
    }
}
class $4138c7bd76e67256$export$8f6ff11549e9fecf {
    #controller;
    get localId() {
        return this.#controller.localId;
    }
    get remoteId() {
        return this.#controller.remoteId;
    }
    get localCreated() {
        return this.#controller.localCreated;
    }
    get service() {
        return this.#controller.service;
    }
    get readable() {
        return this.#controller.readable;
    }
    get writable() {
        return this.#controller.writable;
    }
    get closed() {
        return this.#controller.closed;
    }
    constructor(controller){
        this.#controller = controller;
    }
    close() {
        return this.#controller.close();
    }
}

});


parcelRegister("aIHw7", function(module, exports) {

$parcel$export(module.exports, "AdbDaemonTransport", () => $7cdfc506af36bd48$export$7d98e1b80c4a2dc2);
parcelRequire("kV55x");
var $aHKds = parcelRequire("aHKds");
parcelRequire("7edQJ");
var $6NYMu = parcelRequire("6NYMu");
var $5Ywqs = parcelRequire("5Ywqs");
parcelRequire("hr1EK");
var $6Savq = parcelRequire("6Savq");

var $bFpy9 = parcelRequire("bFpy9");

var $drR7i = parcelRequire("drR7i");

var $gYm23 = parcelRequire("gYm23");

var $cb2uE = parcelRequire("cb2uE");

var $2lmjj = parcelRequire("2lmjj");
const $7cdfc506af36bd48$export$9bf5b66cfd38320b = 0x01000001;
const $7cdfc506af36bd48$export$a9b40d5d0c7f809b = [
    (0, $drR7i.AdbFeature).ShellV2,
    (0, $drR7i.AdbFeature).Cmd,
    (0, $drR7i.AdbFeature).StatV2,
    (0, $drR7i.AdbFeature).ListV2,
    (0, $drR7i.AdbFeature).FixedPushMkdir,
    "apex",
    (0, $drR7i.AdbFeature).Abb,
    // only tells the client the symlink timestamp issue in `adb push --sync` has been fixed.
    // No special handling required.
    "fixed_push_symlink_timestamp",
    (0, $drR7i.AdbFeature).AbbExec,
    "remount_shell",
    "track_app",
    (0, $drR7i.AdbFeature).SendReceiveV2,
    "sendrecv_v2_brotli",
    "sendrecv_v2_lz4",
    "sendrecv_v2_zstd",
    "sendrecv_v2_dry_run_send",
    (0, $drR7i.AdbFeature).DelayedAck
];
const $7cdfc506af36bd48$export$c0c61e0faab919ab = 33554432;
class $7cdfc506af36bd48$export$7d98e1b80c4a2dc2 {
    /**
     * Authenticates the connection and creates an `AdbDaemonTransport` instance
     * that can be used by `Adb` class.
     *
     * If an authentication process failed,
     * no matter which value the `preserveConnection` option has,
     * the `connection` is always kept open, so it can be used in another `authenticate` call.
     */ static async authenticate({ serial: serial, connection: connection, credentialStore: credentialStore, authenticators: authenticators = (0, $gYm23.ADB_DEFAULT_AUTHENTICATORS), features: features = $7cdfc506af36bd48$export$a9b40d5d0c7f809b, initialDelayedAckBytes: initialDelayedAckBytes = $7cdfc506af36bd48$export$c0c61e0faab919ab, ...options }) {
        // Initially, set to highest-supported version and payload size.
        let version = 0x01000001;
        // Android 4: 4K, Android 7: 256K, Android 9: 1M
        let maxPayloadSize = 1048576;
        const resolver = new (0, $aHKds.PromiseResolver)();
        const authProcessor = new (0, $gYm23.AdbAuthenticationProcessor)(authenticators, credentialStore);
        // Here is similar to `AdbPacketDispatcher`,
        // But the received packet types and send packet processing are different.
        const abortController = new (0, $6NYMu.AbortController)();
        const pipe = connection.readable.pipeTo(new (0, $6NYMu.WritableStream)({
            async write (packet) {
                switch(packet.command){
                    case (0, $2lmjj.AdbCommand).Connect:
                        version = Math.min(version, packet.arg0);
                        maxPayloadSize = Math.min(maxPayloadSize, packet.arg1);
                        resolver.resolve((0, $6Savq.decodeUtf8)(packet.payload));
                        break;
                    case (0, $2lmjj.AdbCommand).Auth:
                        {
                            const response = await authProcessor.process(packet);
                            await sendPacket(response);
                            break;
                        }
                    default:
                        break;
                }
            }
        }), {
            // Don't cancel the source ReadableStream on AbortSignal abort.
            preventCancel: true,
            signal: abortController.signal
        }).then(()=>{
            // If `resolver` is already settled, call `reject` won't do anything.
            resolver.reject(new Error("Connection closed unexpectedly"));
        }, (e)=>{
            resolver.reject(e);
        });
        const writer = connection.writable.getWriter();
        async function sendPacket(init) {
            // Always send checksum in auth steps
            // Because we don't know if the device needs it or not.
            init.checksum = (0, $2lmjj.calculateChecksum)(init.payload);
            init.magic = init.command ^ 0xffffffff;
            await (0, $5Ywqs.Consumable).WritableStream.write(writer, init);
        }
        const actualFeatures = features.slice();
        if (initialDelayedAckBytes <= 0) {
            const index = features.indexOf((0, $drR7i.AdbFeature).DelayedAck);
            if (index !== -1) actualFeatures.splice(index, 1);
        }
        let banner;
        try {
            await sendPacket({
                command: (0, $2lmjj.AdbCommand).Connect,
                arg0: version,
                arg1: maxPayloadSize,
                // The terminating `;` is required in formal definition
                // But ADB daemon (all versions) can still work without it
                payload: (0, $6Savq.encodeUtf8)(`host::features=${actualFeatures.join(",")}`)
            });
            banner = await resolver.promise;
        } finally{
            // When failed, release locks on `connection` so the caller can try again.
            // When success, also release locks so `AdbPacketDispatcher` can use them.
            abortController.abort();
            writer.releaseLock();
            // Wait until pipe stops (`ReadableStream` lock released)
            await pipe;
        }
        return new $7cdfc506af36bd48$export$7d98e1b80c4a2dc2({
            serial: serial,
            connection: connection,
            version: version,
            maxPayloadSize: maxPayloadSize,
            banner: banner,
            features: actualFeatures,
            initialDelayedAckBytes: initialDelayedAckBytes,
            ...options
        });
    }
    #connection;
    get connection() {
        return this.#connection;
    }
    #dispatcher;
    #serial;
    get serial() {
        return this.#serial;
    }
    #protocolVersion;
    get protocolVersion() {
        return this.#protocolVersion;
    }
    get maxPayloadSize() {
        return this.#dispatcher.options.maxPayloadSize;
    }
    #banner;
    get banner() {
        return this.#banner;
    }
    get disconnected() {
        return this.#dispatcher.disconnected;
    }
    #clientFeatures;
    get clientFeatures() {
        return this.#clientFeatures;
    }
    constructor({ serial: serial, connection: connection, version: version, banner: banner, features: features = $7cdfc506af36bd48$export$a9b40d5d0c7f809b, initialDelayedAckBytes: initialDelayedAckBytes, ...options }){
        this.#serial = serial;
        this.#connection = connection;
        this.#banner = (0, $bFpy9.AdbBanner).parse(banner);
        this.#clientFeatures = features;
        if (features.includes((0, $drR7i.AdbFeature).DelayedAck)) {
            if (initialDelayedAckBytes <= 0) throw new TypeError("`initialDelayedAckBytes` must be greater than 0 when DelayedAck feature is enabled.");
            if (!this.#banner.features.includes((0, $drR7i.AdbFeature).DelayedAck)) initialDelayedAckBytes = 0;
        } else initialDelayedAckBytes = 0;
        let calculateChecksum;
        let appendNullToServiceString;
        if (version >= $7cdfc506af36bd48$export$9bf5b66cfd38320b) {
            calculateChecksum = false;
            appendNullToServiceString = false;
        } else {
            calculateChecksum = true;
            appendNullToServiceString = true;
        }
        this.#dispatcher = new (0, $cb2uE.AdbPacketDispatcher)(connection, {
            calculateChecksum: calculateChecksum,
            appendNullToServiceString: appendNullToServiceString,
            initialDelayedAckBytes: initialDelayedAckBytes,
            ...options
        });
        this.#protocolVersion = version;
    }
    connect(service) {
        return this.#dispatcher.createSocket(service);
    }
    addReverseTunnel(handler, address) {
        if (!address) {
            const id = Math.random().toString().substring(2);
            address = `localabstract:reverse_${id}`;
        }
        this.#dispatcher.addReverseTunnel(address, handler);
        return address;
    }
    removeReverseTunnel(address) {
        this.#dispatcher.removeReverseTunnel(address);
    }
    clearReverseTunnels() {
        this.#dispatcher.clearReverseTunnels();
    }
    close() {
        return this.#dispatcher.close();
    }
}

});


parcelRegister("jBeoN", function(module, exports) {
parcelRequire("iHRUW");
parcelRequire("btVdk");

});
parcelRegister("iHRUW", function(module, exports) {
// cspell:ignore tport
parcelRequire("kV55x");
var $aHKds = parcelRequire("aHKds");
parcelRequire("cOond");
var $jzfEx = parcelRequire("jzfEx");
parcelRequire("7edQJ");
var $bJSM1 = parcelRequire("bJSM1");
var $jEctC = parcelRequire("jEctC");
var $67qk3 = parcelRequire("67qk3");
parcelRequire("hr1EK");
var $6Savq = parcelRequire("6Savq");
var $j4unN = parcelRequire("j4unN");
var $6yg6p = parcelRequire("6yg6p");

var $bFpy9 = parcelRequire("bFpy9");
parcelRequire("5lBQi");
var $32bmk = parcelRequire("32bmk");
var $fXuIk = parcelRequire("fXuIk");
var $gtlgZ = parcelRequire("gtlgZ");

var $btVdk = parcelRequire("btVdk");
const $d9e611074e4605d2$var$OKAY = (0, $6Savq.encodeUtf8)("OKAY");
const $d9e611074e4605d2$var$FAIL = (0, $6Savq.encodeUtf8)("FAIL");
class $d9e611074e4605d2$var$AdbServerStream {
    #connection;
    #buffered;
    #writer;
    constructor(connection){
        this.#connection = connection;
        this.#buffered = new (0, $bJSM1.BufferedReadableStream)(connection.readable);
        this.#writer = connection.writable.getWriter();
    }
    readExactly(length) {
        return this.#buffered.readExactly(length);
    }
    readString() {
        return (0, $6yg6p.SyncPromise).try(()=>this.readExactly(4)).then((buffer)=>{
            const length = (0, $32bmk.hexToNumber)(buffer);
            if (length === 0) return 0, $j4unN.EMPTY_UINT8_ARRAY;
            else return this.readExactly(length);
        }).then((buffer)=>{
            // TODO: Investigate using stream mode `TextDecoder` for long strings.
            // Because concatenating strings uses rope data structure,
            // which only points to the original strings and doesn't copy the data,
            // it's more efficient than concatenating `Uint8Array`s.
            //
            // ```
            // const decoder = new TextDecoder();
            // let result = '';
            // for await (const chunk of stream.iterateExactly(length)) {
            //     result += decoder.decode(chunk, { stream: true });
            // }
            // result += decoder.decode();
            // return result;
            // ```
            //
            // Although, it will be super complex to use `SyncPromise` with async iterator,
            // `stream.iterateExactly` need to return an
            // `Iterator<Uint8Array | Promise<Uint8Array>>` instead of a true async iterator.
            // Maybe `SyncPromise` should support async iterators directly.
            return (0, $6Savq.decodeUtf8)(buffer);
        }).valueOrPromise();
    }
    async writeString(value) {
        // TODO: investigate using `encodeUtf8("0000" + value)` then modifying the length
        // That way allocates a new string (hopefully only a rope) instead of a new buffer
        const encoded = (0, $6Savq.encodeUtf8)(value);
        const buffer = new Uint8Array(4 + encoded.length);
        (0, $32bmk.write4HexDigits)(buffer, 0, encoded.length);
        buffer.set(encoded, 4);
        await this.#writer.write(buffer);
    }
    async readOkay() {
        const response = await this.readExactly(4);
        if ((0, $gtlgZ.sequenceEqual)(response, $d9e611074e4605d2$var$OKAY)) // `OKAY` is followed by data length and data
        // But different services want to parse the data differently
        // So don't read the data here
        return;
        if ((0, $gtlgZ.sequenceEqual)(response, $d9e611074e4605d2$var$FAIL)) {
            const reason = await this.readString();
            throw new Error(reason);
        }
        throw new Error(`Unexpected response: ${(0, $6Savq.decodeUtf8)(response)}`);
    }
    release() {
        this.#writer.releaseLock();
        return {
            readable: this.#buffered.release(),
            writable: this.#connection.writable,
            closed: this.#connection.closed,
            close: ()=>this.#connection.close()
        };
    }
    async dispose() {
        await this.#buffered.cancel().catch((0, $fXuIk.NOOP));
        await this.#writer.close().catch((0, $fXuIk.NOOP));
        try {
            await this.#connection.close();
        } catch  {
        // ignore
        }
    }
}
class $d9e611074e4605d2$export$21bea6a433f41b7c {
    static VERSION = 41;
    connector;
    wireless = new $d9e611074e4605d2$export$21bea6a433f41b7c.WirelessCommands(this);
    mDns = new $d9e611074e4605d2$export$21bea6a433f41b7c.MDnsCommands(this);
    constructor(connection){
        this.connector = connection;
    }
    async createConnection(request, options) {
        const connection = await this.connector.connect(options);
        const stream = new $d9e611074e4605d2$var$AdbServerStream(connection);
        try {
            await stream.writeString(request);
        } catch (e) {
            await stream.dispose();
            throw e;
        }
        try {
            // `raceSignal` throws when the signal is aborted,
            // so the `catch` block can close the connection.
            await $d9e611074e4605d2$export$76ed3709e60def45(()=>stream.readOkay(), options?.signal);
            return stream;
        } catch (e) {
            await stream.dispose();
            throw e;
        }
    }
    /**
     * `adb version`
     */ async getVersion() {
        const connection = await this.createConnection("host:version");
        try {
            const length = (0, $32bmk.hexToNumber)(await connection.readExactly(4));
            const version = (0, $32bmk.hexToNumber)(await connection.readExactly(length));
            return version;
        } finally{
            await connection.dispose();
        }
    }
    async validateVersion() {
        const version = await this.getVersion();
        if (version !== $d9e611074e4605d2$export$21bea6a433f41b7c.VERSION) throw new Error(`adb server version (${version}) doesn't match this client (${$d9e611074e4605d2$export$21bea6a433f41b7c.VERSION})`);
    }
    /**
     * `adb kill-server`
     */ async killServer() {
        const connection = await this.createConnection("host:kill");
        await connection.dispose();
    }
    /**
     * `adb host-features`
     */ async getServerFeatures() {
        const connection = await this.createConnection("host:host-features");
        try {
            const response = await connection.readString();
            return response.split(",");
        } finally{
            await connection.dispose();
        }
    }
    parseDeviceList(value) {
        const devices = [];
        for (const line of value.split("\n")){
            if (!line) continue;
            const parts = line.split(" ").filter(Boolean);
            const serial = parts[0];
            const status = parts[1];
            if (status !== "device" && status !== "unauthorized") continue;
            let product;
            let model;
            let device;
            let transportId;
            for(let i = 2; i < parts.length; i += 1){
                const [key, value] = parts[i].split(":");
                switch(key){
                    case "product":
                        product = value;
                        break;
                    case "model":
                        model = value;
                        break;
                    case "device":
                        device = value;
                        break;
                    case "transport_id":
                        transportId = BigInt(value);
                        break;
                }
            }
            if (!transportId) throw new Error(`No transport id for device ${serial}`);
            devices.push({
                serial: serial,
                authenticating: status === "unauthorized",
                product: product,
                model: model,
                device: device,
                transportId: transportId
            });
        }
        return devices;
    }
    /**
     * `adb devices -l`
     */ async getDevices() {
        const connection = await this.createConnection("host:devices-l");
        try {
            const response = await connection.readString();
            return this.parseDeviceList(response);
        } finally{
            await connection.dispose();
        }
    }
    /**
     * Track the device list.
     *
     * @param signal An optional `AbortSignal` to stop tracking
     *
     * When `signal` is aborted, `trackDevices` will return normally, instead of throwing `signal.reason`.
     */ async *trackDevices(signal) {
        const connection = await this.createConnection("host:track-devices-l");
        try {
            while(true){
                const response = await $d9e611074e4605d2$export$76ed3709e60def45(async ()=>await connection.readString(), signal);
                const devices = this.parseDeviceList(response);
                yield devices;
            }
        } catch (e) {
            if (e === signal?.reason) return;
        } finally{
            await connection.dispose();
        }
    }
    formatDeviceService(device, command) {
        if (!device) return `host:${command}`;
        if ("transportId" in device) return `host-transport-id:${device.transportId}:${command}`;
        if ("serial" in device) return `host-serial:${device.serial}:${command}`;
        if ("usb" in device) return `host-usb:${command}`;
        if ("tcp" in device) return `host-local:${command}`;
        throw new TypeError("Invalid device selector");
    }
    /**
     * `adb -s <device> reconnect` or `adb reconnect offline`
     */ async reconnectDevice(device) {
        const connection = await this.createConnection(device === "offline" ? "host:reconnect-offline" : this.formatDeviceService(device, "reconnect"));
        try {
            await connection.readString();
        } finally{
            await connection.dispose();
        }
    }
    /**
     * Gets the features supported by the device.
     * The transport ID of the selected device is also returned,
     * so the caller can execute other commands against the same device.
     * @param device The device selector
     * @returns The transport ID of the selected device, and the features supported by the device.
     */ async getDeviceFeatures(device) {
        // On paper, `host:features` is a host service (device features are cached in host),
        // so it shouldn't use `createDeviceConnection`,
        // which is used to forward the service to the device.
        //
        // However, `createDeviceConnection` is a two step process:
        //
        //    1. Send a switch device service to host, to switch the connection to the device.
        //    2. Send the actual service to host, let it forward the service to the device.
        //
        // In step 2, the host only forward the service to device if the service is unknown to host.
        // If the service is a host service, it's still handled by host.
        //
        // Even better, if the service needs a device selector, but the selector is not provided,
        // the service will be executed against the device selected by the switch device service.
        // So we can use all device selector formats for the host service,
        // and get the transport ID in the same time.
        const connection = await this.createDeviceConnection(device, "host:features");
        // Luckily `AdbServerClient.Socket` is compatible with `AdbServerClient.ServerConnection`
        const stream = new $d9e611074e4605d2$var$AdbServerStream(connection);
        try {
            const featuresString = await stream.readString();
            const features = featuresString.split(",");
            return {
                transportId: connection.transportId,
                features: features
            };
        } finally{
            await stream.dispose();
        }
    }
    /**
     * Creates a connection that will forward the service to device.
     * @param device The device selector
     * @param service The service to forward
     * @returns An `AdbServerClient.Socket` that can be used to communicate with the service
     */ async createDeviceConnection(device, service) {
        await this.validateVersion();
        let switchService;
        let transportId;
        if (!device) switchService = `host:tport:any`;
        else if ("transportId" in device) {
            switchService = `host:transport-id:${device.transportId}`;
            transportId = device.transportId;
        } else if ("serial" in device) switchService = `host:tport:serial:${device.serial}`;
        else if ("usb" in device) switchService = `host:tport:usb`;
        else if ("tcp" in device) switchService = `host:tport:local`;
        else throw new TypeError("Invalid device selector");
        const connection = await this.createConnection(switchService);
        try {
            await connection.writeString(service);
        } catch (e) {
            await connection.dispose();
            throw e;
        }
        try {
            if (transportId === undefined) {
                const array = await connection.readExactly(8);
                transportId = (0, $jzfEx.getUint64LittleEndian)(array, 0);
            }
            await connection.readOkay();
            const socket = connection.release();
            return {
                transportId: transportId,
                service: service,
                readable: socket.readable,
                writable: new (0, $67qk3.WrapWritableStream)(socket.writable).bePipedThroughFrom(new (0, $jEctC.MaybeConsumable).UnwrapStream()),
                get closed () {
                    return socket.closed;
                },
                async close () {
                    await socket.close();
                }
            };
        } catch (e) {
            await connection.dispose();
            throw e;
        }
    }
    /**
     * Wait for a device to be connected or disconnected.
     *
     * `adb wait-for-<state>`
     *
     * @param device The device selector
     * @param state The state to wait for
     * @param options The options
     * @returns A promise that resolves when the condition is met.
     */ async waitFor(device, state, options) {
        let type;
        if (!device) type = "any";
        else if ("transportId" in device) type = "any";
        else if ("serial" in device) type = "any";
        else if ("usb" in device) type = "usb";
        else if ("tcp" in device) type = "local";
        else throw new TypeError("Invalid device selector");
        // `waitFor` can't use `connectDevice`, because the device
        // might not be available yet.
        const service = this.formatDeviceService(device, `wait-for-${type}-${state}`);
        const connection = await this.createConnection(service, options);
        try {
            await connection.readOkay();
        } finally{
            await connection.dispose();
        }
    }
    async createTransport(device) {
        const { transportId: transportId, features: features } = await this.getDeviceFeatures(device);
        const devices = await this.getDevices();
        const info = devices.find((device)=>device.transportId === transportId);
        const banner = new (0, $bFpy9.AdbBanner)(info?.product, info?.model, info?.device, features);
        return new (0, $btVdk.AdbServerTransport)(this, info?.serial ?? "", banner, transportId);
    }
}
async function $d9e611074e4605d2$export$76ed3709e60def45(callback, ...signals) {
    const abortPromise = new (0, $aHKds.PromiseResolver)();
    function abort() {
        abortPromise.reject(this.reason);
    }
    try {
        for (const signal of signals){
            if (!signal) continue;
            if (signal.aborted) throw signal.reason;
            signal.addEventListener("abort", abort);
        }
        return await Promise.race([
            callback(),
            abortPromise.promise
        ]);
    } finally{
        for (const signal of signals){
            if (!signal) continue;
            signal.removeEventListener("abort", abort);
        }
    }
}
(function(AdbServerClient) {
    class NetworkError extends Error {
        constructor(message){
            super(message);
            this.name = "NetworkError";
        }
    }
    AdbServerClient.NetworkError = NetworkError;
    class UnauthorizedError extends Error {
        constructor(message){
            super(message);
            this.name = "UnauthorizedError";
        }
    }
    AdbServerClient.UnauthorizedError = UnauthorizedError;
    class AlreadyConnectedError extends Error {
        constructor(message){
            super(message);
            this.name = "AlreadyConnectedError";
        }
    }
    AdbServerClient.AlreadyConnectedError = AlreadyConnectedError;
    class WirelessCommands {
        #client;
        constructor(client){
            this.#client = client;
        }
        /**
         * `adb pair <password> <address>`
         */ async pair(address, password) {
            const connection = await this.#client.createConnection(`host:pair:${password}:${address}`);
            try {
                const response = await connection.readExactly(4);
                // `response` is either `FAIL`, or 4 hex digits for length of the string
                if ((0, $gtlgZ.sequenceEqual)(response, $d9e611074e4605d2$var$FAIL)) throw new Error(await connection.readString());
                const length = (0, $32bmk.hexToNumber)(response);
                // Ignore the string as it's always `Successful ...`
                await connection.readExactly(length);
            } finally{
                await connection.dispose();
            }
        }
        /**
         * `adb connect <address>`
         */ async connect(address) {
            const connection = await this.#client.createConnection(`host:connect:${address}`);
            try {
                const response = await connection.readString();
                switch(response){
                    case `already connected to ${address}`:
                        throw new AdbServerClient.AlreadyConnectedError(response);
                    case `failed to connect to ${address}`:
                    case `failed to authenticate to ${address}`:
                        throw new AdbServerClient.UnauthorizedError(response);
                    case `connected to ${address}`:
                        return;
                    default:
                        throw new AdbServerClient.NetworkError(response);
                }
            } finally{
                await connection.dispose();
            }
        }
        /**
         * `adb disconnect <address>`
         */ async disconnect(address) {
            const connection = await this.#client.createConnection(`host:disconnect:${address}`);
            try {
                await connection.readString();
            } finally{
                await connection.dispose();
            }
        }
    }
    AdbServerClient.WirelessCommands = WirelessCommands;
    class MDnsCommands {
        #client;
        constructor(client){
            this.#client = client;
        }
        async check() {
            const connection = await this.#client.createConnection("host:mdns:check");
            try {
                const response = await connection.readString();
                return !response.startsWith("ERROR:");
            } finally{
                await connection.dispose();
            }
        }
        async getServices() {
            const connection = await this.#client.createConnection("host:mdns:services");
            try {
                const response = await connection.readString();
                return response.split("\n").filter(Boolean).map((line)=>{
                    const parts = line.split("	");
                    return {
                        name: parts[0],
                        service: parts[1],
                        address: parts[2]
                    };
                });
            } finally{
                await connection.dispose();
            }
        }
    }
    AdbServerClient.MDnsCommands = MDnsCommands;
})($d9e611074e4605d2$export$21bea6a433f41b7c || ($d9e611074e4605d2$export$21bea6a433f41b7c = {}));

});
parcelRegister("btVdk", function(module, exports) {

$parcel$export(module.exports, "AdbServerTransport", () => $85bec8a2f163a989$export$7c1775a424a7d7ad);
parcelRequire("kV55x");
var $aHKds = parcelRequire("aHKds");
parcelRequire("7edQJ");
var $6NYMu = parcelRequire("6NYMu");

var $drR7i = parcelRequire("drR7i");
const $85bec8a2f163a989$export$7c2347b5f1ca1982 = [
    (0, $drR7i.AdbFeature).ShellV2,
    (0, $drR7i.AdbFeature).Cmd,
    (0, $drR7i.AdbFeature).StatV2,
    (0, $drR7i.AdbFeature).ListV2,
    (0, $drR7i.AdbFeature).FixedPushMkdir,
    "apex",
    (0, $drR7i.AdbFeature).Abb,
    // only tells the client the symlink timestamp issue in `adb push --sync` has been fixed.
    // No special handling required.
    "fixed_push_symlink_timestamp",
    (0, $drR7i.AdbFeature).AbbExec,
    "remount_shell",
    "track_app",
    (0, $drR7i.AdbFeature).SendReceiveV2,
    "sendrecv_v2_brotli",
    "sendrecv_v2_lz4",
    "sendrecv_v2_zstd",
    "sendrecv_v2_dry_run_send"
];
class $85bec8a2f163a989$export$7c1775a424a7d7ad {
    #client;
    serial;
    transportId;
    maxPayloadSize = 1048576;
    banner;
    #closed = new (0, $aHKds.PromiseResolver)();
    #waitAbortController = new (0, $6NYMu.AbortController)();
    disconnected;
    get clientFeatures() {
        // No need to get host features (features supported by ADB server)
        // Because we create all ADB packets ourselves
        return $85bec8a2f163a989$export$7c2347b5f1ca1982;
    }
    constructor(client, serial, banner, transportId){
        this.#client = client;
        this.serial = serial;
        this.banner = banner;
        this.transportId = transportId;
        this.disconnected = Promise.race([
            this.#closed.promise,
            client.waitFor({
                transportId: transportId
            }, "disconnect", {
                signal: this.#waitAbortController.signal,
                unref: true
            })
        ]);
    }
    async connect(service) {
        return await this.#client.createDeviceConnection({
            transportId: this.transportId
        }, service);
    }
    async addReverseTunnel(handler, address) {
        return await this.#client.connector.addReverseTunnel(handler, address);
    }
    async removeReverseTunnel(address) {
        await this.#client.connector.removeReverseTunnel(address);
    }
    async clearReverseTunnels() {
        await this.#client.connector.clearReverseTunnels();
    }
    close() {
        this.#closed.resolve();
        this.#waitAbortController.abort();
    }
}

});




parcelRegister("byTpg", function(module, exports) {

$parcel$export(module.exports, "isErrorName", () => $86add9489fa853fa$export$9c7d51c3d5b5355e);
$parcel$export(module.exports, "findUsbAlternateInterface", () => $86add9489fa853fa$export$a36c2d3c1065d369);
$parcel$export(module.exports, "getSerialNumber", () => $86add9489fa853fa$export$94caf855bf00ca69);
function $86add9489fa853fa$export$9c7d51c3d5b5355e(e, name) {
    // node-usb package doesn't use `DOMException`,
    // so use a looser check
    // https://github.com/node-usb/node-usb/issues/573
    return typeof e === "object" && e !== null && "name" in e && e.name === name;
}
function $86add9489fa853fa$var$alternateMatchesFilter(alternate, filters) {
    return filters.some((filter)=>alternate.interfaceClass === filter.classCode && alternate.interfaceSubclass === filter.subclassCode && alternate.interfaceProtocol === filter.protocolCode);
}
function $86add9489fa853fa$export$a36c2d3c1065d369(device, filters) {
    for (const configuration of device.configurations){
        for (const interface_ of configuration.interfaces)for (const alternate of interface_.alternates){
            if ($86add9489fa853fa$var$alternateMatchesFilter(alternate, filters)) return {
                configuration: configuration,
                interface_: interface_,
                alternate: alternate
            };
        }
    }
    throw new TypeError("No matched alternate interface found");
}
function $86add9489fa853fa$var$padNumber(value) {
    return value.toString(16).padStart(4, "0");
}
function $86add9489fa853fa$export$94caf855bf00ca69(device) {
    if (device.serialNumber) return device.serialNumber;
    return $86add9489fa853fa$var$padNumber(device.vendorId) + "x" + $86add9489fa853fa$var$padNumber(device.productId);
}

});


parcelRegister("aI8PJ", function(module, exports) {

$parcel$export(module.exports, "AdbDaemonWebUsbDeviceManager", () => $7cc4dd8e8afc9fca$export$b13bb639ae0909dd);

var $dGdCH = parcelRequire("dGdCH");

var $byTpg = parcelRequire("byTpg");
class $7cc4dd8e8afc9fca$export$b13bb639ae0909dd {
    /**
     * Gets the instance of {@link AdbDaemonWebUsbDeviceManager} using browser WebUSB implementation.
     *
     * May be `undefined` if current runtime does not support WebUSB.
     */ static BROWSER = typeof globalThis.navigator !== "undefined" && !!globalThis.navigator.usb ? new $7cc4dd8e8afc9fca$export$b13bb639ae0909dd(globalThis.navigator.usb) : undefined;
    #usbManager;
    /**
     * Create a new instance of {@link AdbDaemonWebUsbDeviceManager} using the specified WebUSB implementation.
     * @param usbManager A WebUSB compatible interface.
     */ constructor(usbManager){
        this.#usbManager = usbManager;
    }
    /**
     * Request access to a connected device.
     * This is a convince method for `usb.requestDevice()`.
     * @param filters
     * The filters to apply to the device list.
     *
     * It must have `classCode`, `subclassCode` and `protocolCode` fields for selecting the ADB interface,
     * but might also have `vendorId`, `productId` or `serialNumber` fields to limit the displayed device list.
     *
     * Defaults to {@link ADB_DEFAULT_DEVICE_FILTER}.
     * @returns An {@link AdbDaemonWebUsbDevice} instance if the user selected a device,
     * or `undefined` if the user cancelled the device picker.
     */ async requestDevice(options = {}) {
        if (!options.filters) options.filters = [
            (0, $dGdCH.ADB_DEFAULT_DEVICE_FILTER)
        ];
        else if (options.filters.length === 0) throw new TypeError("filters must not be empty");
        try {
            const device = await this.#usbManager.requestDevice(options);
            return new (0, $dGdCH.AdbDaemonWebUsbDevice)(device, options.filters, this.#usbManager);
        } catch (e) {
            // No device selected
            if ((0, $byTpg.isErrorName)(e, "NotFoundError")) return undefined;
            throw e;
        }
    }
    /**
     * Get all connected and authenticated devices.
     * This is a convince method for `usb.getDevices()`.
     * @param filters
     * The filters to apply to the device list.
     *
     * It must have `classCode`, `subclassCode` and `protocolCode` fields for selecting the ADB interface,
     * but might also have `vendorId`, `productId` or `serialNumber` fields to limit the device list.
     *
     * Defaults to {@link ADB_DEFAULT_DEVICE_FILTER}.
     * @returns An array of {@link AdbDaemonWebUsbDevice} instances for all connected and authenticated devices.
     */ async getDevices(filters = [
        (0, $dGdCH.ADB_DEFAULT_DEVICE_FILTER)
    ]) {
        if (filters.length === 0) throw new TypeError("filters must not be empty");
        const devices = await this.#usbManager.getDevices();
        return devices.filter((device)=>{
            for (const filter of filters){
                if ("vendorId" in filter && device.vendorId !== filter.vendorId) continue;
                if ("productId" in filter && device.productId !== filter.productId) continue;
                if ("serialNumber" in filter && (0, $byTpg.getSerialNumber)(device) !== filter.serialNumber) continue;
                try {
                    (0, $byTpg.findUsbAlternateInterface)(device, filters);
                    return true;
                } catch  {
                    continue;
                }
            }
            return false;
        }).map((device)=>new (0, $dGdCH.AdbDaemonWebUsbDevice)(device, filters, this.#usbManager));
    }
}

});

parcelRegister("7wgv6", function(module, exports) {
class $5798523fb16f23f6$export$a03a0d59dcbcc7 {
    #callback;
    #usbManager;
    constructor(callback, usb){
        this.#callback = callback;
        this.#usbManager = usb;
        this.#usbManager.addEventListener("connect", this.#handleConnect);
        this.#usbManager.addEventListener("disconnect", this.#handleDisconnect);
    }
    dispose() {
        this.#usbManager.removeEventListener("connect", this.#handleConnect);
        this.#usbManager.removeEventListener("disconnect", this.#handleDisconnect);
    }
    #handleConnect = (e)=>{
        this.#callback(e.device.serialNumber);
    };
    #handleDisconnect = ()=>{
        this.#callback();
    };
}

});


parcelRegister("jhyqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e09a507438314e34$export$2e2bcd8739ae039);
// cspell: ignore RSASSA
function $e09a507438314e34$var$openDatabase() {
    return new Promise((resolve, reject)=>{
        const request = indexedDB.open("Tango", 1);
        request.onerror = ()=>{
            reject(request.error);
        };
        request.onupgradeneeded = ()=>{
            const db = request.result;
            db.createObjectStore("Authentication", {
                autoIncrement: true
            });
        };
        request.onsuccess = ()=>{
            const db = request.result;
            resolve(db);
        };
    });
}
async function $e09a507438314e34$var$saveKey(key) {
    const db = await $e09a507438314e34$var$openDatabase();
    return new Promise((resolve, reject)=>{
        const transaction = db.transaction("Authentication", "readwrite");
        const store = transaction.objectStore("Authentication");
        const putRequest = store.add(key);
        putRequest.onerror = ()=>{
            reject(putRequest.error);
        };
        putRequest.onsuccess = ()=>{
            resolve();
        };
        transaction.onerror = ()=>{
            reject(transaction.error);
        };
        transaction.oncomplete = ()=>{
            db.close();
        };
    });
}
async function $e09a507438314e34$var$getAllKeys() {
    const db = await $e09a507438314e34$var$openDatabase();
    return new Promise((resolve, reject)=>{
        const transaction = db.transaction("Authentication", "readonly");
        const store = transaction.objectStore("Authentication");
        const getRequest = store.getAll();
        getRequest.onerror = ()=>{
            reject(getRequest.error);
        };
        getRequest.onsuccess = ()=>{
            resolve(getRequest.result);
        };
        transaction.onerror = ()=>{
            reject(transaction.error);
        };
        transaction.oncomplete = ()=>{
            db.close();
        };
    });
}
class $e09a507438314e34$export$2e2bcd8739ae039 {
    #appName;
    constructor(appName = "Tango"){
        this.#appName = appName;
    }
    /**
     * Generates a RSA private key and store it into LocalStorage.
     *
     * Calling this method multiple times will overwrite the previous key.
     *
     * @returns The private key in PKCS #8 format.
     */ async generateKey() {
        const { privateKey: cryptoKey } = await crypto.subtle.generateKey({
            name: "RSASSA-PKCS1-v1_5",
            modulusLength: 2048,
            // 65537
            publicExponent: new Uint8Array([
                0x01,
                0x00,
                0x01
            ]),
            hash: "SHA-1"
        }, true, [
            "sign",
            "verify"
        ]);
        const privateKey = new Uint8Array(await crypto.subtle.exportKey("pkcs8", cryptoKey));
        await $e09a507438314e34$var$saveKey(privateKey);
        return {
            buffer: privateKey,
            name: `${this.#appName}@${globalThis.location.hostname}`
        };
    }
    /**
     * Yields the stored RSA private key.
     *
     * This method returns a generator, so `for await...of...` loop should be used to read the key.
     */ async *iterateKeys() {
        for (const key of (await $e09a507438314e34$var$getAllKeys()))yield {
            buffer: key,
            name: `${this.#appName}@${globalThis.location.hostname}`
        };
    }
}

});



//# sourceMappingURL=index.1da9e15d.js.map
